// ChildIssuesSeedAll.js

export const CHILD_ISSUES_PART1 = [
  {
    id: "screen-fragmentation",
    title: {
      en: "Screen-Induced Attention Fragmentation & Digital Overload",
      hi: "स्क्रीन-प्रेरित ध्यान विखंडन और डिजिटल अतिभार"
    },
    questions: {
      parent: {
        en: [
          "My child uses multiple devices at the same time.",
          "My child spends excessive time on screens daily.",
          "My child struggles to limit screen time despite reminders.",
          "Screen use interferes with meals or family interaction.",
          "My child prefers screens over offline activities.",
          "My child frequently loses focus during homework or study.",
          "My child struggles to finish tasks due to screen distractions.",
          "My child’s attention span has shortened noticeably.",
          "My child multitasks with screens even during important activities.",
          "My child becomes restless when screens are removed.",
          "My child becomes irritable or anxious without screens.",
          "Screen content influences my child’s mood or behavior.",
          "My child gets frustrated easily when interrupted during screen time.",
          "My child shows compulsive screen-checking behaviors.",
          "Screen overuse causes conflicts with family or peers.",
          "My child uses screens late at night.",
          "Screen time affects my child’s sleep quality.",
          "My child complains of eye strain, headaches, or fatigue from screens.",
          "Physical activity is reduced due to screen use.",
          "My child exhibits poor posture during screen use.",
          "My child understands the importance of screen limits.",
          "My child can prioritize tasks over screen use.",
          "My child uses screens responsibly for learning purposes.",
          "My child avoids harmful or inappropriate content online.",
          "My child balances screen time with offline hobbies and social interactions."
        ],
        hi: [
          "मेरा बच्चा एक साथ कई डिवाइस इस्तेमाल करता है।",
          "मेरा बच्चा रोज़ाना बहुत अधिक समय स्क्रीन पर बिताता है।",
          "याद दिलाने के बावजूद बच्चा स्क्रीन समय सीमित करने में संघर्ष करता है।",
          "स्क्रीन उपयोग भोजन या परिवार के साथ बातचीत में बाधा डालता है।",
          "बच्चा ऑफलाइन गतिविधियों की बजाय स्क्रीन को प्राथमिकता देता है।",
          "मेरा बच्चा होमवर्क या पढ़ाई के दौरान बार-बार ध्यान खो देता है।",
          "स्क्रीन distractions के कारण बच्चा कार्य पूरा करने में संघर्ष करता है।",
          "बच्चे का ध्यान अवधि स्पष्ट रूप से कम हो गई है।",
          "महत्वपूर्ण गतिविधियों के दौरान भी बच्चा स्क्रीन के साथ मल्टीटास्क करता है।",
          "स्क्रीन हटाए जाने पर बच्चा बेचैन हो जाता है।",
          "स्क्रीन के बिना बच्चा चिड़चिड़ा या चिंतित हो जाता है।",
          "स्क्रीन सामग्री बच्चे के मूड या व्यवहार को प्रभावित करती है।",
          "स्क्रीन समय के दौरान रुकावट पर बच्चा आसानी से निराश हो जाता है।",
          "बच्चा स्क्रीन चेक करने का compulsive व्यवहार दिखाता है।",
          "स्क्रीन अधिक उपयोग से परिवार या साथियों से विवाद होता है।",
          "मेरा बच्चा रात देर तक स्क्रीन इस्तेमाल करता है।",
          "स्क्रीन समय बच्चे की नींद की गुणवत्ता को प्रभावित करता है।",
          "बच्चा स्क्रीन से आँखों में तनाव, सिरदर्द या थकान की शिकायत करता है।",
          "स्क्रीन उपयोग के कारण शारीरिक गतिविधि कम हो गई है।",
          "बच्चा स्क्रीन उपयोग के दौरान खराब पोस्चर दिखाता है।",
          "मेरा बच्चा स्क्रीन सीमाओं के महत्व को समझता है।",
          "बच्चा स्क्रीन उपयोग से पहले कार्यों को प्राथमिकता दे सकता है।",
          "बच्चा सीखने के उद्देश्य से स्क्रीन का जिम्मेदारी से उपयोग करता है।",
          "बच्चा ऑनलाइन हानिकारक या अनुचित सामग्री से बचता है।",
          "बच्चा स्क्रीन समय को ऑफलाइन शौक और सामाजिक संपर्कों के साथ संतुलित करता है।"
        ]
      },
      educator: {
        en: [
          "Child appears distracted or fragmented in attention during lessons after screen-heavy evenings/weekends.",
          "Frequently switches between tasks without completion in class.",
          "Prefers quick digital-style activities over sustained reading/writing.",
          "Shows restlessness or fidgeting when not using digital tools.",
          "Transitions poorly from break/screen time back to structured classwork.",
          "Eye strain or fatigue noticeable during prolonged focus tasks."
        ],
        hi: [
          "स्क्रीन-भरे शाम/वीकेंड के बाद कक्षा में बच्चा ध्यान में विखंडन या विचलित दिखता है।",
          "कक्षा में कार्य बिना पूरा किए बार-बार बदलता रहता है।",
          "लंबे पढ़ने/लिखने की बजाय तेज़ डिजिटल गतिविधियाँ पसंद करता है।",
          "डिजिटल टूल न होने पर बेचैनी या हिलना-डुलना दिखाता है।",
          "ब्रेक/स्क्रीन से संरचित कक्षा कार्य में खराब संक्रमण करता है।",
          "लंबे फोकस कार्यों में आँखों का तनाव या थकान दिखाई देती है।"
        ]
      },
      doctor: {
        en: [
          "History suggests screen exposure correlates with shortened attention span and sleep disruption.",
          "Reports of eye strain, headaches, or reduced physical activity linked to digital overuse.",
          "Behavioral irritability/anxiety increases post-screen time."
        ],
        hi: [
          "इतिहास से स्क्रीन संपर्क का छोटा ध्यान अवधि और नींद विघटन से संबंध दिखता है।",
          "आँखों का तनाव, सिरदर्द या कम शारीरिक गतिविधि डिजिटल अधिक उपयोग से जुड़ी।",
          "स्क्रीन समय के बाद व्यवहार में चिड़चिड़ापन/चिंता बढ़ती है।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (Lower = better)",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong / Healthy — minimal concern", hi: "मजबूत / स्वस्थ — न्यूनतम चिंता" },
          insight: {
            en: "Child shows good digital balance. Continue reinforcing healthy limits and offline activities.",
            hi: "बच्चा अच्छा डिजिटल संतुलन दिखाता है। स्वस्थ सीमाएँ और ऑफलाइन गतिविधियाँ मजबूत करते रहें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild / Emerging concern", hi: "हल्की / उभरती चिंता" },
          insight: {
            en: "Occasional overload signs appearing. Introduce consistent screen-time rules and monitor sleep/attention.",
            hi: "कभी-कभी अतिभार के संकेत। नियमित स्क्रीन-समय नियम लागू करें और नींद/ध्यान पर नजर रखें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern", hi: "मध्यम चिंता" },
          insight: {
            en: "Noticeable impact on focus, mood & health. Create family media plan; consider reduced evening screens.",
            hi: "ध्यान, मूड और स्वास्थ्य पर स्पष्ट प्रभाव। परिवार मीडिया प्लान बनाएँ; शाम की स्क्रीन कम करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern", hi: "उच्च चिंता" },
          insight: {
            en: "Significant dependency & fragmentation. Seek professional input (pediatrician/therapist) for structured detox & alternatives.",
            hi: "महत्वपूर्ण निर्भरता और विखंडन। संरचित detox और विकल्पों के लिए पेशेवर सलाह लें (बाल रोग विशेषज्ञ/थेरेपिस्ट)।"
          }
        }
      ]
    }
  },

  // Issue 2: Poor Executive Function & Life Skills Deficit
  {
    id: "executive-function",
    title: {
      en: "Poor Executive Function & Life Skills Deficit",
      hi: "कमज़ोर कार्यकारी कार्य और जीवन कौशल की कमी"
    },
    questions: {
      parent: {
        en: [
          "My child struggles to plan homework or daily tasks.",
          "My child frequently misplaces items or forgets responsibilities.",
          "My child needs constant reminders to complete tasks.",
          "My child procrastinates on assignments or chores.",
          "My child cannot prioritize tasks effectively.",
          "My child struggles to solve problems independently.",
          "My child avoids making decisions without adult guidance.",
          "My child has difficulty weighing options or consequences.",
          "My child relies on others for simple solutions.",
          "My child repeats mistakes without learning from them.",
          "My child struggles to follow routines consistently.",
          "My child has difficulty managing personal belongings.",
          "My child cannot independently manage school or home responsibilities.",
          "My child relies heavily on adults for basic self-care or organization.",
          "My child shows low initiative in completing tasks.",
          "My child becomes frustrated with unexpected changes.",
          "My child struggles to adjust plans when challenges arise.",
          "My child reacts impulsively instead of thinking through choices.",
          "My child has difficulty managing time for multiple activities.",
          "My child avoids complex or multi-step tasks.",
          "My child lacks basic household or personal life skills.",
          "My child cannot manage simple finances or budgeting.",
          "My child struggles to plan for events or activities.",
          "My child shows difficulty in self-care or hygiene tasks.",
          "My child is not learning to balance responsibilities and leisure."
        ],
        hi: [
          "मेरा बच्चा होमवर्क या दैनिक कार्यों की योजना बनाने में संघर्ष करता है।",
          "बच्चा अक्सर चीजें गुम कर देता है या जिम्मेदारियाँ भूल जाता है।",
          "कार्य पूरा करने के लिए लगातार याद दिलाने की जरूरत पड़ती है।",
          "बच्चा असाइनमेंट या घर के कामों में टालमटोल करता है।",
          "बच्चा कार्यों को प्रभावी ढंग से प्राथमिकता नहीं दे पाता।",
          "बच्चा स्वतंत्र रूप से समस्याएँ हल करने में संघर्ष करता है।",
          "वयस्क मार्गदर्शन के बिना निर्णय लेने से बचता है।",
          "विकल्पों या परिणामों का मूल्यांकन करने में कठिनाई।",
          "सरल समाधानों के लिए दूसरों पर निर्भर रहता है।",
          "गलतियों से सीखे बिना दोहराता है।",
          "दिनचर्या को लगातार फॉलो करने में संघर्ष।",
          "व्यक्तिगत सामान प्रबंधन में कठिनाई।",
          "स्कूल या घर की जिम्मेदारियाँ स्वतंत्र रूप से नहीं संभाल पाता।",
          "बेसिक सेल्फ-केयर या संगठन के लिए वयस्कों पर भारी निर्भर।",
          "कार्य पूरा करने में कम पहल दिखाता है।",
          "अप्रत्याशित बदलावों पर निराश हो जाता है।",
          "चुनौतियों पर योजनाएँ बदलने में संघर्ष।",
          "विचार किए बिना आवेग में प्रतिक्रिया देता है।",
          "एकाधिक गतिविधियों के लिए समय प्रबंधन में कठिनाई।",
          "जटिल या बहु-चरण कार्यों से बचता है।",
          "बेसिक घरेलू या व्यक्तिगत जीवन कौशल की कमी।",
          "सरल वित्त या बजट प्रबंधन नहीं कर पाता।",
          "कार्यक्रम या गतिविधियों की योजना बनाने में संघर्ष।",
          "सेल्फ-केयर या स्वच्छता कार्यों में कठिनाई।",
          "जिम्मेदारियों और अवकाश के बीच संतुलन सीख नहीं रहा।"
        ]
      },
      educator: {
        en: [
          "Requires repeated prompts to start or complete classwork.",
          "Frequently forgets materials or homework.",
          "Struggles with multi-step instructions or projects.",
          "Shows poor organization of desk/notebook.",
          "Has difficulty transitioning between subjects/activities.",
          "Low initiative in group or independent tasks."
        ],
        hi: [
          "कक्षा कार्य शुरू या पूरा करने के लिए बार-बार प्रॉम्प्ट की जरूरत।",
          "अक्सर सामग्री या होमवर्क भूल जाता है।",
          "बहु-चरण निर्देशों या प्रोजेक्ट्स में संघर्ष।",
          "डेस्क/नोटबुक की खराब व्यवस्था।",
          "विषयों/गतिविधियों के बीच संक्रमण में कठिनाई।",
          "समूह या स्वतंत्र कार्यों में कम पहल।"
        ]
      },
      doctor: {
        en: [
          "Developmental history indicates delays in planning/organization skills.",
          "Difficulty with age-expected independence in daily routines.",
          "Impulsivity or inflexibility noted in clinical observation."
        ],
        hi: [
          "विकास इतिहास में योजना/संगठन कौशलों में विलंब संकेत।",
          "दैनिक दिनचर्या में आयु-अनुसार स्वतंत्रता में कठिनाई।",
          "क्लिनिकल अवलोकन में आवेगशीलता या अनम्यता।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (Lower = better)",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong / Healthy", hi: "मजबूत / स्वस्थ" },
          insight: {
            en: "Good executive skills foundation. Encourage more independence through small responsibilities.",
            hi: "अच्छी कार्यकारी कौशल नींव। छोटी जिम्मेदारियों से स्वतंत्रता बढ़ाएँ।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild / Emerging concern", hi: "हल्की / उभरती चिंता" },
          insight: {
            en: "Occasional lapses in planning/organization. Use visual aids, checklists, and routines to build habits.",
            hi: "योजना/संगठन में कभी-कभी चूक। दृश्य सहायक, चेकलिस्ट और दिनचर्या से आदतें बनाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern", hi: "मध्यम चिंता" },
          insight: {
            en: "Noticeable impact on daily functioning. Implement structured supports like planners and break tasks into steps.",
            hi: "दैनिक कार्यों पर स्पष्ट प्रभाव। प्लानर और कार्यों को चरणों में बाँटकर संरचित सहायता लागू करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern", hi: "उच्च चिंता" },
          insight: {
            en: "Significant deficits affecting independence. Consider assessment for executive function support or therapy.",
            hi: "स्वतंत्रता प्रभावित करने वाली महत्वपूर्ण कमी। कार्यकारी कार्य सहायता या थेरेपी के लिए मूल्यांकन विचार करें।"
          }
        }
      ]
    }
  },
  {
    id: "emotional-dysregulation",
    title: {
      en: "Emotional Dysregulation, Anxiety & Low Resilience",
      hi: "भावनात्मक असंतुलन, चिंता और कम लचीलापन"
    },
    questions: {
      parent: {
        en: [
          "My child recognizes their emotions accurately.",
          "My child can name what they feel in stressful situations.",
          "My child frequently feels overwhelmed by minor setbacks.",
          "My child is aware of the effect of emotions on behavior.",
          "My child ignores or suppresses feelings instead of expressing them.",
          "My child loses temper easily.",
          "My child has frequent emotional outbursts.",
          "My child struggles to calm down after frustration.",
          "My child reacts excessively to minor provocations.",
          "My child blames others for emotional reactions.",
          "My child shows worry or fear about school, peers, or performance.",
          "My child avoids situations due to anxiety.",
          "Stress negatively affects my child’s sleep or appetite.",
          "My child has physical symptoms (stomachaches, headaches) under stress.",
          "My child struggles to focus when anxious.",
          "My child gives up easily when faced with challenges.",
          "My child struggles to learn from mistakes.",
          "My child cannot self-soothe or calm down independently.",
          "My child feels hopeless when problems arise.",
          "My child avoids trying new things due to fear of failure.",
          "My child seeks help appropriately when stressed.",
          "My child has at least one trusted person to talk to.",
          "My child can recover emotionally after conflict or disappointment.",
          "My child maintains friendships despite emotional challenges.",
          "My child demonstrates gradual improvement in emotional regulation with guidance."
        ],
        hi: [
          "मेरा बच्चा अपनी भावनाओं को सटीक रूप से पहचानता है।",
          "तनावपूर्ण स्थितियों में बच्चा बता सकता है कि उसे क्या महसूस हो रहा है।",
          "छोटी असफलताओं से बच्चा अक्सर अभिभूत महसूस करता है।",
          "बच्चा भावनाओं के व्यवहार पर प्रभाव को समझता है।",
          "भावनाओं को व्यक्त करने की बजाय दबा या नजरअंदाज करता है।",
          "बच्चा आसानी से गुस्सा खो देता है।",
          "बार-बार भावनात्मक विस्फोट होते हैं।",
          "निराशा के बाद शांत होने में संघर्ष करता है।",
          "छोटी उकसावे पर अत्यधिक प्रतिक्रिया देता है।",
          "भावनात्मक प्रतिक्रियाओं के लिए दूसरों को दोष देता है।",
          "स्कूल, साथी या प्रदर्शन को लेकर चिंता या डर दिखाता है।",
          "चिंता के कारण स्थितियों से बचता है।",
          "तनाव नींद या भूख पर नकारात्मक प्रभाव डालता है।",
          "तनाव में पेट दर्द, सिरदर्द जैसे शारीरिक लक्षण।",
          "चिंतित होने पर फोकस करने में कठिनाई।",
          "चुनौतियों का सामना करने पर जल्दी हार मान लेता है।",
          "गलतियों से सीखने में संघर्ष।",
          "स्वतंत्र रूप से शांत नहीं हो पाता।",
          "समस्याओं पर निराश महसूस करता है।",
          "असफलता के डर से नई चीजें आजमाने से बचता है।",
          "तनाव में उचित मदद मांगता है।",
          "कम से कम एक विश्वसनीय व्यक्ति से बात करता है।",
          "विवाद या निराशा के बाद भावनात्मक रूप से उबर सकता है।",
          "भावनात्मक चुनौतियों के बावजूद दोस्ती बनाए रखता है।",
          "मार्गदर्शन से भावनात्मक नियंत्रण में धीरे-धीरे सुधार दिखाता है।"
        ]
      },
      educator: {
        en: [
          "Emotional outbursts or withdrawal disrupt class participation.",
          "Difficulty recovering from frustration during lessons or group work.",
          "Anxiety visible before tests/presentations (fidgeting, avoidance).",
          "Overreacts to peer feedback or minor corrections.",
          "Struggles to re-engage after setbacks in academic tasks.",
          "Needs frequent adult co-regulation during stressful activities."
        ],
        hi: [
          "भावनात्मक विस्फोट या वापसी कक्षा भागीदारी में बाधा डालते हैं।",
          "पाठ या समूह कार्य में निराशा से उबरने में कठिनाई।",
          "टेस्ट/प्रस्तुति से पहले चिंता दिखती है (बेचैनी, बचना)।",
          "साथी फीडबैक या छोटी सुधार पर अत्यधिक प्रतिक्रिया।",
          "शैक्षिक कार्यों में असफलता के बाद पुनः जुड़ने में संघर्ष।",
          "तनावपूर्ण गतिविधियों में बार-बार वयस्क सह-नियमन की जरूरत।"
        ]
      },
      doctor: {
        en: [
          "Reports of frequent somatic complaints linked to stress/anxiety.",
          "History of prolonged emotional recovery or low frustration tolerance.",
          "Signs of generalized worry impacting sleep, appetite or concentration."
        ],
        hi: [
          "तनाव/चिंता से जुड़े बार-बार शारीरिक शिकायतें।",
          "लंबे भावनात्मक उबरने या कम frustration सहनशीलता का इतिहास।",
          "सामान्य चिंता के संकेत जो नींद, भूख या एकाग्रता प्रभावित करते हैं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (Lower = better)",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong / Healthy", hi: "मजबूत / स्वस्थ" },
          insight: {
            en: "Solid emotional regulation skills. Keep nurturing open expression and coping strategies.",
            hi: "मजबूत भावनात्मक नियंत्रण कौशल। खुली अभिव्यक्ति और coping रणनीतियों को बढ़ावा देते रहें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild / Emerging concern", hi: "हल्की / उभरती चिंता" },
          insight: {
            en: "Occasional overwhelm visible. Practice simple co-regulation techniques (breathing, naming feelings) daily.",
            hi: "कभी-कभी अभिभूत होना दिखता है। रोज़ाना सरल सह-नियमन तकनीकें (साँस, भावनाओं का नाम) अभ्यास करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern", hi: "मध्यम चिंता" },
          insight: {
            en: "Frequent dysregulation affecting daily life. Build a family emotion coaching routine and consider school counselor input.",
            hi: "बार-बार असंतुलन दैनिक जीवन प्रभावित कर रहा है। परिवार भावना कोचिंग रूटीन बनाएँ और स्कूल काउंसलर से इनपुट लें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern", hi: "उच्च चिंता" },
          insight: {
            en: "Significant anxiety/resilience challenges. Professional support (child psychologist) recommended for targeted coping skill-building.",
            hi: "महत्वपूर्ण चिंता/लचीलापन चुनौतियाँ। लक्षित coping कौशल विकास के लिए बाल मनोवैज्ञानिक की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "low-self-esteem",
    title: {
      en: "Low Self-Esteem & Learned Helplessness",
      hi: "कम आत्म-सम्मान और सीखी हुई असहायता"
    },
    description: {
      en: "Low confidence, dependency, fear of failure, and lack of agency.",
      hi: "कम आत्मविश्वास, निर्भरता, असफलता का डर और स्वायत्तता की कमी।"
    },
    questions: {
      parent: {
        en: [
          "My child feels proud of their accomplishments.",
          "My child often doubts their abilities.",
          "My child compares themselves negatively with peers.",
          "My child believes they cannot succeed at tasks.",
          "My child expresses feelings of inadequacy regularly.",
          "My child avoids trying new tasks.",
          "My child relies heavily on adults for encouragement.",
          "My child gives up easily when faced with challenges.",
          "My child hesitates to participate in school or group activities.",
          "My child fears making mistakes.",
          "My child avoids speaking in front of others.",
          "My child struggles to make friends or join groups.",
          "My child is overly dependent on peers for approval.",
          "My child isolates themselves during social or learning activities.",
          "My child finds it difficult to assert opinions.",
          "My child takes criticism personally.",
          "My child feels hopeless after setbacks.",
          "My child struggles to recover from mistakes.",
          "My child cannot learn from failures without adult guidance.",
          "My child fears trying challenging tasks.",
          "My child makes few independent decisions.",
          "My child relies on adults for even minor choices.",
          "My child feels powerless to change situations.",
          "My child avoids responsibilities due to fear of failure.",
          "My child’s self-esteem improves slowly even with support."
        ],
        hi: [
          "मेरा बच्चा अपनी उपलब्धियों पर गर्व महसूस करता है।",
          "बच्चा अक्सर अपनी क्षमताओं पर संदेह करता है।",
          "बच्चा खुद की तुलना साथियों से नकारात्मक रूप से करता है।",
          "बच्चा मानता है कि वह कार्यों में सफल नहीं हो सकता।",
          "बच्चा नियमित रूप से अपर्याप्तता की भावनाएँ व्यक्त करता है।",
          "बच्चा नई चीजें आजमाने से बचता है।",
          "बच्चा प्रोत्साहन के लिए वयस्कों पर बहुत अधिक निर्भर रहता है।",
          "चुनौतियों का सामना करने पर बच्चा आसानी से हार मान लेता है।",
          "स्कूल या समूह गतिविधियों में भाग लेने में संकोच करता है।",
          "गलती करने के डर से बच्चा डरता है।",
          "दूसरों के सामने बोलने से बचता है।",
          "दोस्त बनाने या समूह में शामिल होने में संघर्ष करता है।",
          "साथियों की मंजूरी के लिए अत्यधिक निर्भर रहता है।",
          "सामाजिक या सीखने की गतिविधियों के दौरान खुद को अलग-थलग कर लेता है।",
          "अपनी राय व्यक्त करने में कठिनाई महसूस करता है।",
          "आलोचना को व्यक्तिगत रूप से लेता है।",
          "असफलताओं के बाद निराश महसूस करता है।",
          "गलतियों से उबरने में संघर्ष करता है।",
          "वयस्क मार्गदर्शन के बिना असफलताओं से सीख नहीं पाता।",
          "चुनौतीपूर्ण कार्य आजमाने से डरता है।",
          "बच्चा बहुत कम स्वतंत्र निर्णय लेता है।",
          "छोटे-छोटे चुनावों के लिए भी वयस्कों पर निर्भर रहता है।",
          "स्थितियों को बदलने में खुद को असहाय महसूस करता है।",
          "असफलता के डर से जिम्मेदारियों से बचता है।",
          "समर्थन के बावजूद बच्चे का आत्म-सम्मान धीरे-धीरे सुधरता है।"
        ]
      },
      educator: {
        en: [
          "Rarely volunteers answers or ideas in class discussions.",
          "Gives up quickly on difficult problems or assignments.",
          "Avoids eye contact or participation after receiving correction/feedback.",
          "Frequently says “I can’t do it” or “I’m bad at this” during tasks.",
          "Shows reluctance to join group work or presentations.",
          "Compares own work negatively to classmates even when performing adequately."
        ],
        hi: [
          "कक्षा चर्चा में जवाब या विचार देने में बहुत कम पहल करता है।",
          "कठिन समस्याओं या असाइनमेंट पर जल्दी हार मान लेता है।",
          "सुधार/फीडबैक मिलने के बाद आँख मिलाने या भाग लेने से बचता है।",
          "कार्यों के दौरान अक्सर कहता है “मैं यह नहीं कर सकता” या “मैं इसमें बुरा हूँ”।",
          "समूह कार्य या प्रस्तुतियों में शामिल होने से हिचकिचाता है।",
          "पर्याप्त प्रदर्शन के बावजूद अपनी कक्षा साथियों से नकारात्मक तुलना करता है।"
        ]
      },
      doctor: {
        en: [
          "Persistent low self-worth statements or self-deprecating comments during assessment.",
          "Pattern of avoidance behavior linked to perceived failure risk.",
          "Limited sense of personal agency or internal locus of control observed.",
          "Slow response to encouragement or positive reinforcement in clinical setting."
        ],
        hi: [
          "मूल्यांकन के दौरान लगातार कम आत्म-मूल्य के बयान या आत्म-निंदात्मक टिप्पणियाँ।",
          "असफलता के जोखिम की धारणा से जुड़ा बचने का पैटर्न।",
          "व्यक्तिगत स्वायत्तता या आंतरिक नियंत्रण की सीमित भावना दिखाई देती है।",
          "क्लिनिकल सेटिंग में प्रोत्साहन या सकारात्मक सुदृढ़ीकरण पर धीमी प्रतिक्रिया।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Excellent / No concern, 3 = High concern) — Lower total score = better",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong / Healthy — minimal concern", hi: "मजबूत / स्वस्थ — न्यूनतम चिंता" },
          insight: {
            en: "Child shows solid self-esteem and sense of agency. Continue praising effort, celebrating small wins, and encouraging independence to maintain this strength.",
            hi: "बच्चा मजबूत आत्म-सम्मान और स्वायत्तता की भावना दिखाता है। प्रयास की प्रशंसा, छोटी सफलताओं का जश्न और स्वतंत्रता को प्रोत्साहित करके इस ताकत को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild / Emerging concern", hi: "हल्की / उभरती चिंता" },
          insight: {
            en: "Occasional self-doubt or hesitation appearing. Focus on effort-based praise, provide safe opportunities for success, and model positive self-talk at home.",
            hi: "कभी-कभी आत्म-संदेह या संकोच दिखाई देता है। प्रयास-आधारित प्रशंसा पर ध्यान दें, सफलता के सुरक्षित अवसर प्रदान करें और घर पर सकारात्मक आत्म-संवाद का मॉडल बनाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern", hi: "मध्यम चिंता" },
          insight: {
            en: "Noticeable dependency and fear of failure affecting participation and resilience. Build daily success experiences, reduce over-helping, and consider structured confidence-building activities (e.g., small responsibilities, journaling strengths).",
            hi: "भागीदारी और लचीलापन पर निर्भरता और असफलता के डर का स्पष्ट प्रभाव। रोज़ाना सफलता के अनुभव बनाएँ, अत्यधिक मदद कम करें और संरचित आत्मविश्वास निर्माण गतिविधियाँ (छोटी जिम्मेदारियाँ, ताकतों का जर्नलिंग) विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern", hi: "उच्च चिंता" },
          insight: {
            en: "Significant learned helplessness and low agency impacting daily functioning and emotional well-being. Professional support (child counselor or psychologist) strongly recommended to address underlying patterns and rebuild self-efficacy through targeted interventions.",
            hi: "महत्वपूर्ण सीखी हुई असहायता और कम स्वायत्तता दैनिक कार्य और भावनात्मक कल्याण को प्रभावित कर रही है। अंतर्निहित पैटर्न को संबोधित करने और लक्षित हस्तक्षेपों से आत्म-प्रभावकारिता पुनर्निर्माण के लिए बाल काउंसलर या मनोवैज्ञानिक की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "foundational-learning-gaps",
    title: {
      en: "Foundational Learning Gaps & Poor Learning Readiness",
      hi: "मूलभूत सीखने में अंतराल और सीखने की तत्परता की कमी"
    },
    description: {
      en: "Early academic, cognitive, and conceptual gaps affecting long-term learning.",
      hi: "प्रारंभिक शैक्षिक, संज्ञानात्मक और वैचारिक अंतराल जो लंबे समय तक सीखने को प्रभावित करते हैं।"
    },
    questions: {
      parent: {
        en: [
          "My child struggles with basic reading skills.",
          "My child struggles with basic math skills.",
          "My child has difficulty recognizing letters, numbers, or patterns.",
          "My child lacks foundational problem-solving skills.",
          "My child struggles to follow instructions in class or homework.",
          "My child finds abstract concepts difficult to grasp.",
          "My child struggles to connect ideas logically.",
          "My child has difficulty remembering learned concepts.",
          "My child struggles to focus on learning tasks.",
          "My child finds learning new skills slow and challenging.",
          "My child avoids independent learning.",
          "My child lacks curiosity or motivation to learn.",
          "My child struggles to organize study materials.",
          "My child depends heavily on guidance for simple tasks.",
          "My child has difficulty maintaining attention during lessons.",
          "My child struggles to participate in group learning.",
          "My child finds it difficult to follow classroom rules.",
          "My child is reluctant to ask questions or express confusion.",
          "My child becomes frustrated easily during learning.",
          "My child lacks confidence in trying new learning activities.",
          "My child struggles to adapt to different learning environments.",
          "My child avoids challenging tasks.",
          "My child cannot apply learned concepts to real-life situations.",
          "My child shows slow progress despite repeated guidance.",
          "My child struggles to develop independent study strategies."
        ],
        hi: [
          "मेरा बच्चा बुनियादी पढ़ने के कौशलों में संघर्ष करता है।",
          "मेरा बच्चा बुनियादी गणित कौशलों में संघर्ष करता है।",
          "बच्चे को अक्षर, संख्याएँ या पैटर्न पहचानने में कठिनाई होती है।",
          "बच्चे में मूलभूत समस्या-समाधान कौशल की कमी है।",
          "कक्षा या होमवर्क में निर्देशों का पालन करने में बच्चा संघर्ष करता है।",
          "बच्चे को अमूर्त अवधारणाओं को समझने में कठिनाई होती है।",
          "बच्चा विचारों को तार्किक रूप से जोड़ने में संघर्ष करता है।",
          "सीखी गई अवधारणाओं को याद रखने में कठिनाई।",
          "सीखने के कार्यों पर ध्यान केंद्रित करने में संघर्ष।",
          "नए कौशल सीखना बच्चे के लिए धीमा और चुनौतीपूर्ण लगता है।",
          "बच्चा स्वतंत्र सीखने से बचता है।",
          "सीखने के लिए उत्सुकता या प्रेरणा की कमी।",
          "पढ़ाई की सामग्री को व्यवस्थित करने में संघर्ष।",
          "सरल कार्यों के लिए भारी मार्गदर्शन पर निर्भर।",
          "पाठ के दौरान ध्यान बनाए रखने में कठिनाई।",
          "समूह सीखने में भाग लेने में संघर्ष।",
          "कक्षा नियमों का पालन करने में कठिनाई।",
          "सवाल पूछने या भ्रम व्यक्त करने में संकोच।",
          "सीखने के दौरान आसानी से निराश हो जाता है।",
          "नई सीखने की गतिविधियाँ आजमाने में आत्मविश्वास की कमी।",
          "विभिन्न सीखने के वातावरण में ढलने में संघर्ष।",
          "चुनौतीपूर्ण कार्यों से बचता है।",
          "सीखी गई अवधारणाओं को वास्तविक जीवन में लागू नहीं कर पाता।",
          "बार-बार मार्गदर्शन के बावजूद धीमी प्रगति।",
          "स्वतंत्र अध्ययन रणनीतियाँ विकसित करने में संघर्ष।"
        ]
      },
      educator: {
        en: [
          "Difficulty with basic literacy/numeracy skills compared to age peers in class.",
          "Struggles to follow multi-step classroom instructions or routines.",
          "Limited participation in group discussions or collaborative activities.",
          "Frequently loses focus or appears disengaged during lessons.",
          "Shows slow acquisition of new concepts despite repeated teaching.",
          "Reluctant to attempt tasks without direct teacher support.",
          "Difficulty transferring learned skills to new or real-life contexts."
        ],
        hi: [
          "कक्षा में आयु के साथियों की तुलना में बुनियादी साक्षरता/संख्यात्मक कौशलों में कठिनाई।",
          "कक्षा निर्देशों या दिनचर्या के बहु-चरणों का पालन करने में संघर्ष।",
          "समूह चर्चा या सहयोगी गतिविधियों में सीमित भागीदारी।",
          "पाठ के दौरान अक्सर ध्यान खो देता है या उदासीन दिखता है।",
          "बार-बार पढ़ाने के बावजूद नई अवधारणाओं को धीरे ग्रहण करता है।",
          "शिक्षक के प्रत्यक्ष समर्थन के बिना कार्य करने से हिचकिचाता है।",
          "सीखे गए कौशलों को नए या वास्तविक जीवन संदर्भों में स्थानांतरित करने में कठिनाई।"
        ]
      },
      doctor: {
        en: [
          "Early developmental screening or school reports indicate gaps in pre-academic skills.",
          "History of delayed milestone achievement in language, cognition or fine motor areas.",
          "Persistent difficulty with working memory, attention or abstract reasoning observed.",
          "Slow progress in skill acquisition despite appropriate instruction and support."
        ],
        hi: [
          "प्रारंभिक विकास स्क्रीनिंग या स्कूल रिपोर्ट में प्री-एकेडमिक कौशलों में अंतराल संकेतित।",
          "भाषा, संज्ञान या फाइन मोटर क्षेत्रों में मील के पत्थरों में विलंब का इतिहास।",
          "कार्य स्मृति, ध्यान या अमूर्त तर्क में लगातार कठिनाई देखी गई।",
          "उचित निर्देश और समर्थन के बावजूद कौशल अर्जन में धीमी प्रगति।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Excellent / No concern, 3 = High concern) — Lower total score = better",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong / Healthy — minimal concern", hi: "मजबूत / स्वस्थ — न्यूनतम चिंता" },
          insight: {
            en: "Excellent foundational readiness. Child shows strong learning habits and cognitive flexibility. Continue rich exposure to books, play-based learning, and open-ended exploration to maintain this strong base.",
            hi: "उत्कृष्ट मूलभूत तत्परता। बच्चा मजबूत सीखने की आदतें और संज्ञानात्मक लचीलापन दिखाता है। किताबों, खेल-आधारित सीखने और खुले अंत वाली खोज की समृद्ध एक्सपोजर जारी रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild / Emerging concern", hi: "हल्की / उभरती चिंता" },
          insight: {
            en: "Minor gaps in foundational skills or learning habits beginning to show. Increase daily reading aloud, hands-on activities, and simple routines to strengthen basics before gaps widen.",
            hi: "मूलभूत कौशलों या सीखने की आदतों में छोटे अंतराल दिखने शुरू हो रहे हैं। रोज़ाना जोर से पढ़ना, हाथों से काम, और सरल दिनचर्या बढ़ाएँ ताकि अंतराल बढ़ने से पहले मजबूत हो जाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern", hi: "मध्यम चिंता" },
          insight: {
            en: "Noticeable foundational gaps affecting academic confidence and engagement. Introduce structured, playful learning support (e.g. phonics games, manipulatives, visual aids) and consider educational assessment to identify specific areas needing targeted help.",
            hi: "शैक्षिक आत्मविश्वास और जुड़ाव को प्रभावित करने वाले स्पष्ट मूलभूत अंतराल। संरचित, खेल-आधारित सीखने का समर्थन शुरू करें (फोनिक्स गेम्स, मैनिपुलेटिव्स, दृश्य सहायक) और विशिष्ट क्षेत्रों की पहचान के लिए शैक्षिक मूल्यांकन पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern", hi: "उच्च चिंता" },
          insight: {
            en: "Significant foundational and readiness gaps likely impacting long-term academic trajectory. Urgent professional evaluation (educational psychologist / special educator) recommended to identify underlying causes and design an intensive, individualized intervention plan.",
            hi: "महत्वपूर्ण मूलभूत और तत्परता अंतराल जो लंबे समय तक शैक्षिक प्रगति को प्रभावित कर रहे हैं। अंतर्निहित कारणों की पहचान और गहन, व्यक्तिगत हस्तक्षेप योजना बनाने के लिए तत्काल पेशेवर मूल्यांकन (शैक्षिक मनोवैज्ञानिक / विशेष शिक्षक) की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "adhd",
    title: {
      en: "Attention Deficit Hyperactivity Disorder (ADHD)",
      hi: "ध्यान-घाटा-हाइपरएक्टिविटी विकार (ADHD)"
    },
    description: {
      en: "Challenges in attention, hyperactivity, and impulsivity affecting academics and social interactions.",
      hi: "ध्यान, हाइपरएक्टिविटी और आवेगशीलता में चुनौतियाँ जो शैक्षिक और सामाजिक संपर्कों को प्रभावित करती हैं।"
    },
    questions: {
      parent: {
        en: [
          "My child struggles to sustain attention on tasks.",
          "My child is easily distracted by external stimuli.",
          "My child frequently switches tasks without finishing.",
          "My child misses details or makes careless mistakes.",
          "My child struggles to follow instructions consistently.",
          "My child fidgets or moves excessively during tasks.",
          "My child has difficulty remaining seated when required.",
          "My child talks excessively in inappropriate contexts.",
          "My child runs or climbs in situations where it’s not suitable.",
          "My child struggles to engage quietly in activities.",
          "My child interrupts conversations or games.",
          "My child acts without thinking of consequences.",
          "My child struggles to wait their turn.",
          "My child blurts out answers prematurely in class.",
          "My child engages in risky behaviors impulsively.",
          "My child struggles to complete homework on time.",
          "My child loses materials or misplaces assignments frequently.",
          "My child struggles to plan steps for complex tasks.",
          "My child requires constant reminders for tasks.",
          "My child’s academic performance is inconsistent.",
          "My child struggles to maintain friendships due to impulsivity.",
          "My child is frequently frustrated with peers or adults.",
          "My child experiences low self-esteem due to repeated struggles.",
          "My child avoids structured group activities.",
          "My child shows emotional outbursts when challenged or corrected."
        ],
        hi: [
          "मेरा बच्चा कार्यों पर ध्यान बनाए रखने में संघर्ष करता है।",
          "बाहरी उत्तेजनाओं से बच्चा आसानी से विचलित हो जाता है।",
          "बच्चा कार्य बिना पूरा किए बार-बार बदल देता है।",
          "विवरण छूट जाते हैं या लापरवाही से गलतियाँ हो जाती हैं।",
          "निर्देशों का लगातार पालन करने में संघर्ष।",
          "कार्यों के दौरान बच्चा बहुत अधिक हिलता-डुलता या फिजेट करता है।",
          "जरूरत पड़ने पर बैठे रहने में कठिनाई।",
          "अनुचित संदर्भों में अत्यधिक बात करता है।",
          "अनुपयुक्त स्थितियों में दौड़ता या चढ़ता है।",
          "शांत गतिविधियों में शामिल होने में संघर्ष।",
          "बातचीत या खेल में बीच में टोकता है।",
          "परिणामों के बारे में सोचे बिना कार्य करता है।",
          "बारी का इंतजार करने में संघर्ष।",
          "कक्षा में समय से पहले जवाब चिल्ला देता है।",
          "जोखिम भरे व्यवहार आवेग में करता है।",
          "होमवर्क समय पर पूरा करने में संघर्ष।",
          "सामग्री या असाइनमेंट बार-बार गुम कर देता है।",
          "जटिल कार्यों के चरणों की योजना बनाने में कठिनाई।",
          "कार्यों के लिए लगातार याद दिलाने की आवश्यकता।",
          "शैक्षिक प्रदर्शन असंगत रहता है।",
          "आवेगशीलता के कारण दोस्ती बनाए रखने में संघर्ष।",
          "साथियों या वयस्कों के साथ बार-बार निराशा।",
          "बार-बार संघर्षों के कारण कम आत्म-सम्मान।",
          "संरचित समूह गतिविधियों से बचता है।",
          "चुनौती या सुधार पर भावनात्मक विस्फोट दिखाता है।"
        ]
      },
      educator: {
        en: [
          "Frequently off-task or distracted during independent or group work.",
          "Impulsive blurting, interrupting, or difficulty waiting turn in class.",
          "Excessive fidgeting, leaving seat, or restlessness during lessons.",
          "Incomplete assignments, careless errors, or inconsistent performance.",
          "Challenges following classroom rules or multi-step directions.",
          "Social difficulties: interrupts peers, struggles with turn-taking in games.",
          "Requires frequent redirection or reminders to stay engaged."
        ],
        hi: [
          "स्वतंत्र या समूह कार्य के दौरान अक्सर ऑफ-टास्क या विचलित।",
          "कक्षा में आवेगी चिल्लाहट, बीच में टोकना या बारी का इंतजार न कर पाना।",
          "पाठ के दौरान अत्यधिक फिजेटिंग, सीट छोड़ना या बेचैनी।",
          "अधूरे असाइनमेंट, लापरवाही से गलतियाँ या असंगत प्रदर्शन।",
          "कक्षा नियमों या बहु-चरण निर्देशों का पालन करने में चुनौतियाँ।",
          "सामाजिक कठिनाइयाँ: साथियों को टोकना, खेल में बारी लेने में संघर्ष।",
          "जुड़े रहने के लिए बार-बार रीडायरेक्शन या याद दिलाने की जरूरत।"
        ]
      },
      doctor: {
        en: [
          "Behavioral observations consistent with inattention, hyperactivity, and/or impulsivity across multiple settings.",
          "History of difficulties with sustained attention, impulse control, and/or motor restlessness since early childhood.",
          "Parent and teacher reports indicate impairment in academic, social, and/or home functioning.",
          "No clear medical or environmental cause fully explains symptoms (e.g., no untreated sleep/thyroid issue)."
        ],
        hi: [
          "एकाधिक सेटिंग्स में ध्यान की कमी, हाइपरएक्टिविटी और/या आवेगशीलता के साथ व्यवहारिक अवलोकन।",
          "बचपन से ही निरंतर ध्यान, आवेग नियंत्रण और/या मोटर बेचैनी में कठिनाइयों का इतिहास।",
          "अभिभावक और शिक्षक रिपोर्ट से शैक्षिक, सामाजिक और/या घरेलू कार्यक्षमता में हानि संकेतित।",
          "लक्षणों को पूरी तरह से समझाने वाला कोई स्पष्ट चिकित्सकीय या पर्यावरणीय कारण नहीं (जैसे अनुपचारित नींद/थायरॉइड समस्या नहीं)।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Excellent / No concern, 3 = High concern) — Lower total score = better",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong / Healthy — minimal concern", hi: "मजबूत / स्वस्थ — न्यूनतम चिंता" },
          insight: {
            en: "Excellent attention, self-control and behavioral regulation. Child manages tasks, transitions and social situations well. Continue positive reinforcement and structured routines to support ongoing strengths.",
            hi: "उत्कृष्ट ध्यान, आत्म-नियंत्रण और व्यवहारिक नियमन। बच्चा कार्य, संक्रमण और सामाजिक स्थितियों को अच्छी तरह संभालता है। निरंतर ताकतों के समर्थन के लिए सकारात्मक सुदृढ़ीकरण और संरचित दिनचर्या जारी रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild / Emerging concern", hi: "हल्की / उभरती चिंता" },
          insight: {
            en: "Occasional inattention, fidgeting or impulsivity noticeable but not severely disruptive. Strengthen external structure (visual schedules, timers, clear rules) and teach simple self-regulation strategies (e.g., breathing breaks, fidget tools).",
            hi: "कभी-कभी ध्यान की कमी, बेचैनी या आवेगशीलता दिखाई देती है लेकिन गंभीर रूप से बाधक नहीं। बाहरी संरचना मजबूत करें (दृश्य शेड्यूल, टाइमर, स्पष्ट नियम) और सरल आत्म-नियमन रणनीतियाँ सिखाएँ (साँस लेने के ब्रेक, फिजेट टूल्स)।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern", hi: "मध्यम चिंता" },
          insight: {
            en: "Noticeable challenges with focus, impulse control and hyperactivity impacting school performance and relationships. Implement consistent home-school strategies (daily planners, reward systems, movement breaks) and consider screening/assessment for ADHD or related needs.",
            hi: "फोकस, आवेग नियंत्रण और हाइपरएक्टिविटी से स्कूल प्रदर्शन और संबंध प्रभावित। घर-स्कूल सुसंगत रणनीतियाँ लागू करें (दैनिक प्लानर, पुरस्कार प्रणाली, मूवमेंट ब्रेक) और ADHD या संबंधित आवश्यकताओं के लिए स्क्रीनिंग/मूल्यांकन पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern", hi: "उच्च चिंता" },
          insight: {
            en: "Significant and pervasive difficulties with attention, hyperactivity and impulsivity across settings, likely affecting learning, self-esteem and social functioning. Professional evaluation by a child psychiatrist, developmental pediatrician or clinical psychologist is strongly recommended for accurate diagnosis and evidence-based intervention planning.",
            hi: "ध्यान, हाइपरएक्टिविटी और आवेगशीलता में महत्वपूर्ण और व्यापक कठिनाइयाँ, जो सीखने, आत्म-सम्मान और सामाजिक कार्यक्षमता को प्रभावित कर रही हैं। सटीक निदान और साक्ष्य-आधारित हस्तक्षेप योजना के लिए बाल मनोचिकित्सक, विकासात्मक बाल रोग विशेषज्ञ या क्लिनिकल मनोवैज्ञानिक द्वारा पेशेवर मूल्यांकन की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "reducing-academic-pressure",
    title: {
      en: "Reducing Academic Pressure",
      hi: "शैक्षिक दबाव कम करना"
    },
    description: {
      en: "Awareness of academic expectations, pressure signs in routines, emotional responses, health impact, and protective coping factors.",
      hi: "शैक्षिक अपेक्षाओं की जागरूकता, दिनचर्या में दबाव के संकेत, भावनात्मक प्रतिक्रियाएँ, स्वास्थ्य पर प्रभाव और सुरक्षात्मक coping कारक।"
    },
    questions: {
      parent: {
        en: [
          "My child understands why they are studying their subjects, beyond marks or grades.",
          "My child can clearly explain what is expected of them academically at school.",
          "My child knows the difference between doing their best and being perfect.",
          "My child feels comfortable asking teachers or parents when academic expectations are unclear.",
          "My child understands that mistakes and low scores are part of learning, not failure.",
          "My child studies for long hours without adequate breaks.",
          "My child skips playtime, hobbies or relaxation due to academic workload.",
          "My child feels the need to study even when physically or mentally exhausted.",
          "My child rushes through meals or daily activities because of academic tasks.",
          "My child studies mainly due to fear of consequences, not interest or curiosity.",
          "My child appears anxious or tense when discussing studies or exams.",
          "My child becomes irritable, withdrawn or emotional during exam periods.",
          "My child shows fear of disappointing parents or teachers academically.",
          "My child compares their academic performance negatively with peers.",
          "My child expresses feelings like “I am not good enough” related to studies.",
          "My child’s sleep routine gets disturbed due to homework, exams or studying.",
          "My child complains of headaches, stomach aches or fatigue during academic stress.",
          "My child shows reduced appetite or unhealthy eating during exam or result periods.",
          "My child lacks energy or enthusiasm during school days because of academic load.",
          "My child has little time for physical activity due to study-related commitments.",
          "My child feels safe sharing academic worries with me or another trusted adult.",
          "My child knows healthy ways to relax when academic pressure increases.",
          "Our family discusses effort and learning, not just marks or ranks.",
          "My child receives encouragement even when academic performance is below expectations.",
          "My child is able to recover emotionally after poor academic results."
        ],
        hi: [
          "मेरा बच्चा अंकों या ग्रेड से परे विषय पढ़ने का कारण समझता है।",
          "बच्चा स्कूल में शैक्षिक अपेक्षाओं को स्पष्ट रूप से बता सकता है।",
          "बच्चा अपना सर्वश्रेष्ठ करने और परफेक्ट होने के बीच अंतर जानता है।",
          "शैक्षिक अपेक्षाएँ अस्पष्ट होने पर बच्चा शिक्षकों या माता-पिता से पूछने में सहज महसूस करता है।",
          "बच्चा समझता है कि गलतियाँ और कम अंक सीखने का हिस्सा हैं, असफलता नहीं।",
          "बच्चा पर्याप्त ब्रेक के बिना लंबे समय तक पढ़ाई करता है।",
          "शैक्षिक कार्यभार के कारण खेलने, शौक या आराम छोड़ देता है।",
          "शारीरिक या मानसिक थकान के बावजूद पढ़ाई करने की जरूरत महसूस करता है।",
          "शैक्षिक कार्यों के कारण भोजन या दैनिक गतिविधियों में जल्दबाजी करता है।",
          "रुचि या जिज्ञासा से नहीं, परिणामों के डर से मुख्य रूप से पढ़ता है।",
          "पढ़ाई या परीक्षा की चर्चा में बच्चा चिंतित या तनावग्रस्त दिखता है।",
          "परीक्षा अवधि में चिड़चिड़ा, अलग-थलग या भावुक हो जाता है।",
          "शैक्षिक रूप से माता-पिता या शिक्षकों को निराश करने का डर दिखाता है।",
          "अपने शैक्षिक प्रदर्शन की साथियों से नकारात्मक तुलना करता है।",
          "पढ़ाई से जुड़े “मैं पर्याप्त अच्छा नहीं हूँ” जैसे भाव व्यक्त करता है।",
          "होमवर्क, परीक्षा या पढ़ाई के कारण नींद की दिनचर्या बिगड़ जाती है।",
          "शैक्षिक तनाव में सिरदर्द, पेट दर्द या थकान की शिकायत करता है।",
          "परीक्षा या रिजल्ट अवधि में भूख कम या अस्वास्थ्यकर खान-पान।",
          "शैक्षिक बोझ के कारण स्कूल के दिनों में ऊर्जा या उत्साह की कमी।",
          "पढ़ाई से जुड़े कमिटमेंट के कारण शारीरिक गतिविधि के लिए बहुत कम समय।",
          "शैक्षिक चिंताएँ मुझसे या किसी विश्वसनीय वयस्क से साझा करने में सुरक्षित महसूस करता है।",
          "शैक्षिक दबाव बढ़ने पर बच्चा स्वस्थ तरीके से रिलैक्स करना जानता है।",
          "हमारा परिवार अंक या रैंक की बजाय प्रयास और सीखने पर चर्चा करता है।",
          "अपेक्षाओं से कम प्रदर्शन पर भी बच्चा प्रोत्साहन प्राप्त करता है।",
          "खराब शैक्षिक परिणामों के बाद भावनात्मक रूप से उबरने में सक्षम है।"
        ]
      },
      educator: {
        en: [
          "Shows signs of stress/anxiety during tests or when discussing performance.",
          "Overly focused on marks/grades rather than understanding concepts.",
          "Frequently rushes through work or appears exhausted during school day.",
          "Avoids asking questions in class due to fear of judgment.",
          "Compares self negatively to classmates during group or competitive activities.",
          "Difficulty recovering emotionally after low performance feedback."
        ],
        hi: [
          "टेस्ट या प्रदर्शन चर्चा के दौरान तनाव/चिंता के संकेत दिखाता है।",
          "अवधारणाओं को समझने की बजाय अंकों/ग्रेड पर अत्यधिक फोकस।",
          "स्कूल के दिन में काम जल्दबाजी में करता है या थका हुआ दिखता है।",
          "निर्णय के डर से कक्षा में सवाल पूछने से बचता है।",
          "समूह या प्रतिस्पर्धी गतिविधियों में खुद की साथियों से नकारात्मक तुलना।",
          "कम प्रदर्शन फीडबैक के बाद भावनात्मक रूप से उबरने में कठिनाई।"
        ]
      },
      doctor: {
        en: [
          "Reports or observations of stress-related somatic complaints (headaches, stomach issues) linked to academic periods.",
          "History of sleep disturbance, appetite changes or fatigue during exam/high-pressure school times.",
          "Emotional signs of perfectionism, fear of failure or external validation dependence noted in consultation."
        ],
        hi: [
          "शैक्षिक अवधियों से जुड़ी तनाव-संबंधी शारीरिक शिकायतें (सिरदर्द, पेट की समस्या) की रिपोर्ट/अवलोकन।",
          "परीक्षा/उच्च दबाव वाले स्कूल समय में नींद विघटन, भूख परिवर्तन या थकान का इतिहास।",
          "परामर्श में परफेक्शनिज़्म, असफलता का डर या बाहरी मान्यता पर निर्भरता के भावनात्मक संकेत।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Not at all / Never / No concern, 3 = Almost always / High concern) — Lower total score = healthier situation",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy academic balance", hi: "स्वस्थ शैक्षिक संतुलन" },
          insight: {
            en: "Child maintains good perspective on learning and healthy balance. Family focus on effort, curiosity and well-being is working well — keep nurturing intrinsic motivation and open communication.",
            hi: "बच्चा सीखने पर अच्छा दृष्टिकोण और स्वस्थ संतुलन बनाए रखता है। परिवार का प्रयास, जिज्ञासा और कल्याण पर फोकस अच्छा काम कर रहा है — आंतरिक प्रेरणा और खुली बातचीत को बढ़ावा देते रहें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild pressure, preventive guidance helpful", hi: "हल्का दबाव, निवारक मार्गदर्शन उपयोगी" },
          insight: {
            en: "Early signs of pressure emerging (occasional stress, reduced play). Strengthen protective factors: regular breaks, family discussions on effort vs. outcome, and healthy relaxation routines to prevent escalation.",
            hi: "दबाव के शुरुआती संकेत (कभी-कभी तनाव, कम खेल)। सुरक्षात्मक कारकों को मजबूत करें: नियमित ब्रेक, प्रयास बनाम परिणाम पर परिवार चर्चा, और स्वस्थ रिलैक्सेशन दिनचर्या से वृद्धि रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate academic stress, needs structured support", hi: "मध्यम शैक्षिक तनाव, संरचित समर्थन की आवश्यकता" },
          insight: {
            en: "Clear impact on emotional health, sleep, and balance from academic load. Create a family academic wellness plan: fixed study-break schedules, no-study zones, emphasis on hobbies, and regular check-ins to reduce fear-based motivation.",
            hi: "शैक्षिक बोझ से भावनात्मक स्वास्थ्य, नींद और संतुलन पर स्पष्ट प्रभाव। परिवार शैक्षिक कल्याण प्लान बनाएँ: निश्चित पढ़ाई-ब्रेक शेड्यूल, नो-स्टडी जोन, शौक पर जोर, और डर-आधारित प्रेरणा कम करने के लिए नियमित चेक-इन।"
          }
        },
        {
          range: "51–75",
          label: { en: "High academic pressure, intervention strongly recommended", hi: "उच्च शैक्षिक दबाव, हस्तक्षेप की मजबूत सिफारिश" },
          insight: {
            en: "Significant stress symptoms affecting physical health, self-worth and daily functioning. Urgent action needed: consult school counselor or child psychologist for stress management strategies, consider workload adjustments with school, and prioritize rest/recovery over performance.",
            hi: "शारीरिक स्वास्थ्य, आत्म-मूल्य और दैनिक कार्यक्षमता पर महत्वपूर्ण तनाव लक्षण। तत्काल कार्रवाई आवश्यक: स्कूल काउंसलर या बाल मनोवैज्ञानिक से तनाव प्रबंधन रणनीतियों के लिए परामर्श, स्कूल के साथ कार्यभार समायोजन पर विचार, और प्रदर्शन से ज्यादा आराम/रिकवरी को प्राथमिकता दें।"
          }
        }
      ]
    }
  },
  {
    id: "time-management",
    title: {
      en: "Time Management",
      hi: "समय प्रबंधन"
    },
    description: {
      en: "Understanding of time, priorities, planning habits, execution, emotional response to pressure, and growing independence in managing routines.",
      hi: "समय, प्राथमिकताओं, योजना आदतों, निष्पादन, समय दबाव के प्रति भावनात्मक प्रतिक्रिया और दिनचर्या प्रबंधन में बढ़ती स्वतंत्रता की समझ।"
    },
    questions: {
      parent: {
        en: [
          "My child understands how much time different daily activities usually take.",
          "My child is aware of deadlines for homework, projects and exams.",
          "My child understands the importance of balancing study, play and rest.",
          "My child can identify which tasks are more important and which can wait.",
          "My child understands the consequences of poor time management.",
          "My child plans their study time in advance rather than at the last minute.",
          "My child keeps track of homework, tests and project deadlines.",
          "My child breaks large tasks into smaller, manageable steps.",
          "My child uses a timetable, planner or reminders (with or without help).",
          "My child prepares school materials (books, bag, uniform) on time.",
          "My child starts tasks on time without repeated reminders.",
          "My child stays focused on a task without frequent distractions.",
          "My child completes homework within a reasonable time.",
          "My child switches between tasks without wasting excessive time.",
          "My child avoids procrastinating until the last moment.",
          "My child becomes anxious when tasks pile up or deadlines approach.",
          "My child gets frustrated when unable to finish tasks on time.",
          "My child reacts emotionally (anger, tears, withdrawal) due to lack of time.",
          "My child blames themselves harshly for poor time use.",
          "My child avoids tasks because they feel overwhelmed by time pressure.",
          "My child accepts guidance on planning time without resistance.",
          "My child shows improvement in time management when given structure.",
          "My child can manage daily routines with minimal supervision.",
          "Our family models healthy time management and realistic schedules.",
          "My child is learning skills to manage time independently as they grow."
        ],
        hi: [
          "मेरा बच्चा विभिन्न दैनिक गतिविधियों में आमतौर पर कितना समय लगता है, यह समझता है।",
          "बच्चा होमवर्क, प्रोजेक्ट और परीक्षाओं की डेडलाइन से अवगत है।",
          "पढ़ाई, खेल और आराम के बीच संतुलन के महत्व को बच्चा समझता है।",
          "बच्चा पहचान सकता है कि कौन से कार्य अधिक महत्वपूर्ण हैं और कौन से इंतजार कर सकते हैं।",
          "खराब समय प्रबंधन के परिणामों को बच्चा समझता है।",
          "बच्चा पढ़ाई का समय पहले से प्लान करता है, आखिरी मिनट में नहीं।",
          "होमवर्क, टेस्ट और प्रोजेक्ट डेडलाइन को ट्रैक रखता है।",
          "बड़े कार्यों को छोटे, प्रबंधनीय चरणों में तोड़ता है।",
          "टाइमटेबल, प्लानर या रिमाइंडर (सहायता के साथ या बिना) का उपयोग करता है।",
          "स्कूल सामग्री (किताबें, बैग, यूनिफॉर्म) समय पर तैयार करता है।",
          "बार-बार याद दिलाए बिना कार्य समय पर शुरू करता है।",
          "बार-बार distractions के बिना कार्य पर फोकस रहता है।",
          "होमवर्क उचित समय में पूरा करता है।",
          "कार्यों के बीच स्विच करते समय अत्यधिक समय बर्बाद नहीं करता।",
          "आखिरी क्षण तक टालमटोल से बचता है।",
          "कार्य जमा होने या डेडलाइन नजदीक आने पर चिंतित हो जाता है।",
          "समय पर कार्य पूरा न कर पाने पर निराश हो जाता है।",
          "समय की कमी के कारण भावनात्मक प्रतिक्रिया (गुस्सा, आँसू, अलग-थलग) देता है।",
          "खराब समय उपयोग के लिए खुद को कठोरता से दोष देता है।",
          "समय दबाव से अभिभूत महसूस करके कार्यों से बचता है।",
          "समय योजना पर मार्गदर्शन बिना प्रतिरोध के स्वीकार करता है।",
          "संरचना देने पर समय प्रबंधन में सुधार दिखाता है।",
          "न्यूनतम निगरानी के साथ दैनिक दिनचर्या संभाल सकता है।",
          "हमारा परिवार स्वस्थ समय प्रबंधन और यथार्थवादी शेड्यूल का मॉडल प्रस्तुत करता है।",
          "बढ़ते हुए बच्चा समय स्वतंत्र रूप से प्रबंधित करने के कौशल सीख रहा है।"
        ]
      },
      educator: {
        en: [
          "Frequently late in submitting homework or arriving prepared for class.",
          "Struggles to complete classwork within allocated time without reminders.",
          "Difficulty transitioning between activities or subjects without losing time.",
          "Shows signs of rushing or panic as deadlines approach.",
          "Procrastinates on assignments visible in class (starts late, incomplete work).",
          "Requires frequent prompts to stay on task during independent work periods."
        ],
        hi: [
          "होमवर्क समय पर जमा करने या कक्षा के लिए तैयार आने में अक्सर देरी।",
          "रिमाइंडर के बिना आवंटित समय में कक्षा कार्य पूरा करने में संघर्ष।",
          "गतिविधियों या विषयों के बीच संक्रमण में समय खो देता है।",
          "डेडलाइन नजदीक आने पर जल्दबाजी या घबराहट के संकेत।",
          "कक्षा में दिखाई देने वाले असाइनमेंट पर टालमटोल (देर से शुरू, अधूरा कार्य)।",
          "स्वतंत्र कार्य अवधि के दौरान कार्य पर बने रहने के लिए बार-बार प्रॉम्प्ट की जरूरत।"
        ]
      },
      doctor: {
        en: [
          "History or observation of poor time estimation and planning difficulties.",
          "Reports of anxiety or emotional distress specifically tied to deadlines/time pressure.",
          "Patterns of procrastination or avoidance linked to executive function challenges.",
          "No clear medical cause (e.g., untreated ADHD, anxiety disorder) fully explains difficulties."
        ],
        hi: [
          "समय अनुमान और योजना बनाने में कठिनाइयों का इतिहास या अवलोकन।",
          "डेडलाइन/समय दबाव से विशेष रूप से जुड़ी चिंता या भावनात्मक संकट की रिपोर्ट।",
          "कार्यकारी कार्य चुनौतियों से जुड़ा टालमटोल या बचाव का पैटर्न।",
          "कठिनाइयों को पूरी तरह समझाने वाला कोई स्पष्ट चिकित्सकीय कारण नहीं (जैसे अनुपचारित ADHD, चिंता विकार)।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / No difficulty, 3 = Almost always / Severe difficulty) — Lower total score = better time-management health",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong time management", hi: "मजबूत समय प्रबंधन" },
          insight: {
            en: "Child demonstrates excellent awareness, planning and execution of time. Family modeling and natural skill-building are effective — maintain realistic routines and celebrate independence to reinforce this strength.",
            hi: "बच्चा समय की उत्कृष्ट जागरूकता, योजना और निष्पादन दिखाता है। परिवार मॉडलिंग और प्राकृतिक कौशल निर्माण प्रभावी हैं — यथार्थवादी दिनचर्या बनाए रखें और स्वतंत्रता का जश्न मनाकर इस ताकत को मजबूत करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Developing skills, light guidance helpful", hi: "विकसित हो रहे कौशल, हल्का मार्गदर्शन उपयोगी" },
          insight: {
            en: "Emerging strengths with occasional lapses in planning or follow-through. Introduce simple tools (visual timers, daily checklists) and gently teach prioritization to build confidence and consistency without pressure.",
            hi: "योजना या फॉलो-थ्रू में कभी-कभी चूक के साथ उभरती ताकतें। सरल टूल (दृश्य टाइमर, दैनिक चेकलिस्ट) शुरू करें और प्राथमिकता सिखाने में हल्के हाथ से मदद करें ताकि आत्मविश्वास और निरंतरता बिना दबाव के बढ़े।"
          }
        },
        {
          range: "31–50",
          label: { en: "Frequent difficulties, needs structured routines", hi: "बार-बार कठिनाइयाँ, संरचित दिनचर्या की आवश्यकता" },
          insight: {
            en: "Noticeable challenges in planning, execution or emotional handling of time demands. Implement consistent family-school structures (shared planners, set homework times, break reminders) and explicitly teach time-blocking and self-monitoring skills.",
            hi: "योजना, निष्पादन या समय मांगों के भावनात्मक हैंडलिंग में स्पष्ट चुनौतियाँ। सुसंगत परिवार-स्कूल संरचनाएँ लागू करें (साझा प्लानर, निश्चित होमवर्क समय, ब्रेक रिमाइंडर) और समय-ब्लॉकिंग तथा आत्म-निगरानी कौशल स्पष्ट रूप से सिखाएँ।"
          }
        },
        {
          range: "51–75",
          label: { en: "Severe challenges, intervention recommended", hi: "गंभीर चुनौतियाँ, हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Significant impairment in time awareness, organization and emotional regulation around deadlines, likely impacting academics and well-being. Professional support (school counselor, occupational therapist or psychologist) recommended to assess underlying executive function or anxiety factors and create a tailored skill-building plan.",
            hi: "समय जागरूकता, संगठन और डेडलाइन के आसपास भावनात्मक नियमन में महत्वपूर्ण हानि, जो शैक्षिक और कल्याण को प्रभावित कर रही है। अंतर्निहित कार्यकारी कार्य या चिंता कारकों का मूल्यांकन करने और व्यक्तिगत कौशल-निर्माण योजना बनाने के लिए पेशेवर समर्थन (स्कूल काउंसलर, ऑक्यूपेशनल थेरेपिस्ट या मनोवैज्ञानिक) की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "technology-overuse",
    title: {
      en: "Technology Overuse",
      hi: "प्रौद्योगिकी का अत्यधिक उपयोग"
    },
    description: {
      en: "Awareness of screen time, usage patterns, emotional/behavioral dependence, impact on health/academics/sleep, and family boundaries for digital balance.",
      hi: "स्क्रीन समय की जागरूकता, उपयोग पैटर्न, भावनात्मक/व्यवहारिक निर्भरता, स्वास्थ्य/शैक्षिक/नींद पर प्रभाव और डिजिटल संतुलन के लिए परिवार की सीमाएँ।"
    },
    questions: {
      parent: {
        en: [
          "My child is aware of how much time they spend on screens each day.",
          "My child understands the difference between productive and non-productive screen use.",
          "My child can stop using devices when reminded without resistance.",
          "My child understands why limits on screen time are necessary.",
          "My child recognizes when screen use is affecting their mood or energy.",
          "My child uses screens immediately after waking up or before sleeping.",
          "My child exceeds agreed screen-time limits on most days.",
          "My child uses multiple devices simultaneously (phone, TV, tablet, laptop).",
          "My child chooses screen activities over outdoor play or hobbies.",
          "My child loses track of time while using digital devices.",
          "My child becomes irritable, angry or restless when asked to stop using devices.",
          "My child uses screens to escape boredom, stress or uncomfortable emotions.",
          "My child shows reduced interest in non-screen activities.",
          "My child becomes defensive or secretive about online activities.",
          "My child feels unhappy or empty when not using digital devices.",
          "My child’s academic performance is affected by excessive screen time.",
          "My child’s sleep routine is disturbed due to device use.",
          "My child experiences eye strain, headaches or fatigue from screen use.",
          "My child rushes homework to return to screens.",
          "My child has reduced physical activity due to screen engagement.",
          "Our family has clear and consistent rules around screen usage.",
          "My child follows screen-time rules even when unsupervised.",
          "My child can engage meaningfully in offline activities without screens.",
          "We discuss online safety, content and behavior openly at home.",
          "My child is learning healthy digital habits appropriate for their age."
        ],
        hi: [
          "मेरा बच्चा रोज़ाना स्क्रीन पर कितना समय बिताता है, इसकी जागरूकता रखता है।",
          "बच्चा उत्पादक और गैर-उत्पादक स्क्रीन उपयोग के बीच अंतर समझता है।",
          "याद दिलाने पर बिना विरोध के डिवाइस बंद कर देता है।",
          "स्क्रीन समय सीमा की आवश्यकता क्यों है, बच्चा समझता है।",
          "स्क्रीन उपयोग से मूड या ऊर्जा प्रभावित होने पर बच्चा पहचानता है।",
          "उठने के तुरंत बाद या सोने से पहले स्क्रीन उपयोग करता है।",
          "अधिकांश दिनों में सहमत स्क्रीन-समय सीमा से अधिक उपयोग करता है।",
          "एक साथ कई डिवाइस (फोन, टीवी, टैबलेट, लैपटॉप) इस्तेमाल करता है।",
          "आउटडोर खेल या शौक की बजाय स्क्रीन गतिविधियाँ चुनता है।",
          "डिजिटल डिवाइस उपयोग के दौरान समय का पता नहीं चलता।",
          "डिवाइस बंद करने को कहने पर चिड़चिड़ा, गुस्सैल या बेचैन हो जाता है।",
          "बोरियत, तनाव या असहज भावनाओं से बचने के लिए स्क्रीन का उपयोग करता है।",
          "गैर-स्क्रीन गतिविधियों में रुचि कम हो गई है।",
          "ऑनलाइन गतिविधियों को लेकर रक्षात्मक या गुप्त रहता है।",
          "डिजिटल डिवाइस न उपयोग करने पर दुखी या खाली महसूस करता है।",
          "अत्यधिक स्क्रीन समय से शैक्षिक प्रदर्शन प्रभावित होता है।",
          "डिवाइस उपयोग से नींद की दिनचर्या बिगड़ जाती है।",
          "स्क्रीन उपयोग से आँखों में तनाव, सिरदर्द या थकान होती है।",
          "स्क्रीन पर वापस लौटने के लिए होमवर्क जल्दबाजी में करता है।",
          "स्क्रीन जुड़ाव के कारण शारीरिक गतिविधि कम हो गई है।",
          "हमारे परिवार में स्क्रीन उपयोग के लिए स्पष्ट और सुसंगत नियम हैं।",
          "निगरानी के बिना भी स्क्रीन-समय नियमों का पालन करता है।",
          "स्क्रीन के बिना ऑफलाइन गतिविधियों में अर्थपूर्ण रूप से शामिल हो सकता है।",
          "घर पर ऑनलाइन सुरक्षा, सामग्री और व्यवहार पर खुलकर चर्चा करते हैं।",
          "बच्चा अपनी आयु के अनुरूप स्वस्थ डिजिटल आदतें सीख रहा है।"
        ]
      },
      educator: {
        en: [
          "Frequently distracted by phone/tablet during class or transitions.",
          "Shows signs of fatigue, eye strain or irritability after heavy device use at home.",
          "Rushes or completes minimal work to return to personal device during breaks.",
          "Difficulty staying engaged in non-digital classroom activities.",
          "Defensive or secretive when questioned about device use or online behavior.",
          "Reduced participation in group discussions or hands-on tasks compared to peers."
        ],
        hi: [
          "कक्षा या संक्रमण के दौरान फोन/टैबलेट से बार-बार विचलित।",
          "घर पर भारी डिवाइस उपयोग के बाद थकान, आँखों का तनाव या चिड़चिड़ापन दिखाता है।",
          "ब्रेक के दौरान व्यक्तिगत डिवाइस पर वापस लौटने के लिए काम जल्दबाजी या न्यूनतम करता है।",
          "गैर-डिजिटल कक्षा गतिविधियों में जुड़े रहने में कठिनाई।",
          "डिवाइस उपयोग या ऑनलाइन व्यवहार पर सवाल करने पर रक्षात्मक या गुप्त।",
          "साथियों की तुलना में समूह चर्चा या हाथों से काम में कम भागीदारी।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of excessive screen time correlating with sleep disruption, fatigue or mood changes.",
          "History of eye strain, headaches, poor posture or reduced physical activity linked to device use.",
          "Signs of compulsive checking or withdrawal symptoms when device access is limited.",
          "No primary medical cause (e.g., untreated sleep disorder) fully accounts for symptoms."
        ],
        hi: [
          "अभिभावक/शिक्षक रिपोर्ट से अत्यधिक स्क्रीन समय का नींद विघटन, थकान या मूड बदलाव से संबंध।",
          "डिवाइस उपयोग से जुड़ा आँखों का तनाव, सिरदर्द, खराब पोस्चर या कम शारीरिक गतिविधि का इतिहास।",
          "कम्पल्सिव चेकिंग या डिवाइस पहुंच सीमित होने पर वापसी लक्षण।",
          "लक्षणों को पूरी तरह समझाने वाला कोई प्राथमिक चिकित्सकीय कारण नहीं (जैसे अनुपचारित नींद विकार)।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / No concern, 3 = Almost always / High concern) — Lower total score = healthier tech use",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy digital balance", hi: "स्वस्थ डिजिटल संतुलन" },
          insight: {
            en: "Child shows strong self-regulation and balanced tech habits. Family rules and open discussions are effective — continue modeling healthy use, encouraging offline activities, and maintaining consistent boundaries to sustain this positive pattern.",
            hi: "बच्चा मजबूत आत्म-नियमन और संतुलित टेक आदतें दिखाता है। परिवार के नियम और खुली चर्चाएँ प्रभावी हैं — स्वस्थ उपयोग का मॉडल बनाए रखें, ऑफलाइन गतिविधियों को प्रोत्साहित करें और सुसंगत सीमाएँ बनाए रखकर इस सकारात्मक पैटर्न को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild overuse, preventive guidance useful", hi: "हल्का अत्यधिक उपयोग, निवारक मार्गदर्शन उपयोगी" },
          insight: {
            en: "Occasional signs of habit formation or minor dependence. Reinforce family media plan: clear daily limits, device-free zones/times, and regular check-ins to build awareness and prevent escalation into problematic use.",
            hi: "आदत निर्माण या छोटी निर्भरता के कभी-कभी संकेत। परिवार मीडिया प्लान मजबूत करें: स्पष्ट दैनिक सीमाएँ, डिवाइस-मुक्त क्षेत्र/समय और नियमित चेक-इन से जागरूकता बढ़ाएँ और समस्याग्रस्त उपयोग में वृद्धि रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Problematic use, structured limits needed", hi: "समस्याग्रस्त उपयोग, संरचित सीमाओं की आवश्यकता" },
          insight: {
            en: "Clear indicators of dependence, mood impact and reduced offline engagement. Establish stricter, consistent rules (e.g., no screens 1 hour before bed, supervised use), increase rewarding offline activities, and monitor for withdrawal signs; consider school counselor input if academic/social effects persist.",
            hi: "निर्भरता, मूड प्रभाव और ऑफलाइन जुड़ाव में कमी के स्पष्ट संकेत। सख्त, सुसंगत नियम स्थापित करें (सोने से 1 घंटा पहले कोई स्क्रीन नहीं, निगरानी में उपयोग), पुरस्कृत ऑफलाइन गतिविधियाँ बढ़ाएँ और वापसी संकेतों पर नजर रखें; यदि शैक्षिक/सामाजिक प्रभाव बने रहें तो स्कूल काउंसलर से इनपुट लें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High dependency, intervention recommended", hi: "उच्च निर्भरता, हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Significant dependency affecting sleep, mood, academics, physical health and social development. Urgent professional support recommended (child psychologist or digital wellness specialist) for structured detox plan, underlying emotional/attention assessment, and family-based behavior change strategies.",
            hi: "नींद, मूड, शैक्षिक, शारीरिक स्वास्थ्य और सामाजिक विकास को प्रभावित करने वाली महत्वपूर्ण निर्भरता। संरचित detox प्लान, अंतर्निहित भावनात्मक/ध्यान मूल्यांकन और परिवार-आधारित व्यवहार परिवर्तन रणनीतियों के लिए तत्काल पेशेवर समर्थन (बाल मनोवैज्ञानिक या डिजिटल वेलनेस विशेषज्ञ) की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "peer-pressure",
    title: {
      en: "Peer Pressure",
      hi: "साथियों का दबाव"
    },
    description: {
      en: "Awareness of self-identity, conformity responses, emotional impact of social comparison, risk-taking under influence, and protective confidence/resistance skills.",
      hi: "स्व-परिचय की जागरूकता, अनुरूपता प्रतिक्रियाएँ, सामाजिक तुलना का भावनात्मक प्रभाव, प्रभाव में जोखिम लेना, और सुरक्षात्मक आत्मविश्वास/प्रतिरोध कौशल।"
    },
    questions: {
      parent: {
        en: [
          "My child is aware of their own likes, dislikes and values.",
          "My child can express opinions even if friends disagree.",
          "My child understands that it is okay to say “no” to peers.",
          "My child recognizes when friends influence their decisions.",
          "My child understands the difference between healthy and unhealthy friendships.",
          "My child changes behavior to fit in with friends.",
          "My child agrees to things just to avoid being left out.",
          "My child struggles to make decisions without peer approval.",
          "My child follows group behavior even when uncomfortable.",
          "My child avoids activities they like because friends may judge them.",
          "My child worries a lot about what friends think of them.",
          "My child feels anxious or stressed in group situations.",
          "My child feels bad about themselves after comparing with peers.",
          "My child feels lonely even when surrounded by friends.",
          "My child’s mood is strongly affected by peer approval or rejection.",
          "My child feels pressured to engage in risky behaviors to fit in.",
          "My child hides activities from family due to peer influence.",
          "My child adopts language, habits or behaviors they normally wouldn’t.",
          "My child ignores rules or values to gain peer acceptance.",
          "My child fears being teased, bullied or excluded.",
          "My child feels comfortable discussing peer-related problems with family.",
          "My child has at least one trusted friend who supports positive choices.",
          "My child can resist peer pressure without feeling guilty.",
          "My child receives guidance on handling social situations respectfully.",
          "My child is developing confidence to stand by their values."
        ],
        hi: [
          "मेरा बच्चा अपनी पसंद, नापसंद और मूल्यों के प्रति जागरूक है।",
          "दोस्त असहमत होने पर भी बच्चा अपनी राय व्यक्त कर सकता है।",
          "बच्चा समझता है कि साथियों को 'नहीं' कहना ठीक है।",
          "दोस्तों के प्रभाव को बच्चा पहचानता है जब वे उसके निर्णय प्रभावित करते हैं।",
          "स्वस्थ और अस्वस्थ दोस्ती के बीच अंतर बच्चा समझता है।",
          "दोस्तों के साथ फिट होने के लिए व्यवहार बदल लेता है।",
          "छूट जाने के डर से चीजों से सहमत हो जाता है।",
          "साथियों की मंजूरी के बिना निर्णय लेने में संघर्ष करता है।",
          "असहज होने पर भी समूह व्यवहार का अनुसरण करता है।",
          "दोस्त जज कर सकते हैं, इस डर से पसंदीदा गतिविधियों से बचता है।",
          "दोस्त क्या सोचते हैं, इसकी बहुत चिंता करता है।",
          "समूह स्थितियों में चिंतित या तनावग्रस्त महसूस करता है।",
          "साथियों से तुलना करने के बाद खुद के बारे में बुरा महसूस करता है।",
          "दोस्तों से घिरा होने पर भी अकेलापन महसूस करता है।",
          "साथियों की मंजूरी या अस्वीकृति से मूड बहुत प्रभावित होता है।",
          "फिट होने के लिए जोखिम भरे व्यवहार करने का दबाव महसूस करता है।",
          "साथियों के प्रभाव से परिवार से गतिविधियाँ छिपाता है।",
          "ऐसी भाषा, आदतें या व्यवहार अपनाता है जो सामान्यतः नहीं करता।",
          "साथी स्वीकृति पाने के लिए नियम या मूल्यों को नजरअंदाज करता है।",
          "चिढ़ाने, धमकाने या बहिष्कार के डर से प्रभावित होता है।",
          "साथी-संबंधित समस्याओं पर परिवार से खुलकर बात करने में सहज महसूस करता है।",
          "कम से कम एक विश्वसनीय दोस्त है जो सकारात्मक विकल्पों का समर्थन करता है।",
          "अपराधबोध महसूस किए बिना साथियों के दबाव का प्रतिरोध कर सकता है।",
          "सामाजिक स्थितियों को सम्मानजनक ढंग से संभालने पर मार्गदर्शन प्राप्त करता है।",
          "अपने मूल्यों पर अडिग रहने का आत्मविश्वास विकसित कर रहा है।"
        ]
      },
      educator: {
        en: [
          "Frequently conforms to group behavior even when it contradicts classroom values/rules.",
          "Shows reluctance to express independent opinions during discussions or group work.",
          "Becomes visibly anxious or withdrawn in peer group settings.",
          "Engages in minor rule-breaking or off-task behavior when influenced by peers.",
          "Compares own work/performance negatively to classmates, leading to disengagement.",
          "Rarely stands up for positive choices when peers suggest otherwise."
        ],
        hi: [
          "कक्षा मूल्यों/नियमों के विपरीत होने पर भी अक्सर समूह व्यवहार अपनाता है।",
          "चर्चा या समूह कार्य में स्वतंत्र राय व्यक्त करने में संकोच दिखाता है।",
          "साथी समूह सेटिंग में स्पष्ट रूप से चिंतित या अलग-थलग दिखता है।",
          "साथियों के प्रभाव में छोटे नियम उल्लंघन या ऑफ-टास्क व्यवहार करता है।",
          "अपने कार्य/प्रदर्शन की साथियों से नकारात्मक तुलना कर उदासीन हो जाता है।",
          "साथी अन्यथा सुझाव देने पर सकारात्मक विकल्पों के लिए कम ही खड़ा होता है।"
        ]
      },
      doctor: {
        en: [
          "Reports of social anxiety, withdrawal or mood changes linked to peer interactions.",
          "History of adopting risky or uncharacteristic behaviors under peer influence.",
          "Signs of low self-worth or fear of exclusion evident in developmental history.",
          "No primary internalizing disorder fully explains the degree of conformity/dependence."
        ],
        hi: [
          "साथी अंतर्क्रियाओं से जुड़ी सामाजिक चिंता, वापसी या मूड परिवर्तन की रिपोर्ट।",
          "साथी प्रभाव में जोखिम भरे या असामान्य व्यवहार अपनाने का इतिहास।",
          "विकास इतिहास में कम आत्म-मूल्य या बहिष्कार के डर के संकेत।",
          "अनुरूपता/निर्भरता की डिग्री को पूरी तरह समझाने वाला कोई प्राथमिक आंतरिक विकार नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Not at all / No concern, 3 = Almost always / Strong influence) — Lower total score = healthier independence and confidence",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong self-confidence & healthy peer relations", hi: "मजबूत आत्मविश्वास और स्वस्थ साथी संबंध" },
          insight: {
            en: "Child has solid self-identity and positive peer dynamics. Family support and open dialogue are effective — continue reinforcing values, encouraging independent thinking, and celebrating authentic choices to maintain strong resilience.",
            hi: "बच्चे में मजबूत स्व-परिचय और सकारात्मक साथी गतिशीलता है। परिवार समर्थन और खुली बातचीत प्रभावी हैं — मूल्यों को मजबूत करना, स्वतंत्र सोच को प्रोत्साहित करना और प्रामाणिक विकल्पों का जश्न मनाकर मजबूत लचीलापन बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild influence, guidance beneficial", hi: "हल्का प्रभाव, मार्गदर्शन लाभदायक" },
          insight: {
            en: "Occasional conformity or worry about peer opinions emerging. Strengthen protective factors: role-play 'saying no', discuss real-life scenarios, and build confidence through family affirmation and positive friendship modeling.",
            hi: "साथी राय की कभी-कभी चिंता या अनुरूपता उभर रही है। सुरक्षात्मक कारकों को मजबूत करें: 'नहीं' कहने का रोल-प्ले, वास्तविक परिदृश्यों पर चर्चा, और परिवार की पुष्टि तथा सकारात्मक दोस्ती मॉडलिंग से आत्मविश्वास बढ़ाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Significant pressure, social skill-building needed", hi: "महत्वपूर्ण दबाव, सामाजिक कौशल निर्माण की आवश्यकता" },
          insight: {
            en: "Noticeable impact on decisions, mood and behavior from peer influence. Implement structured social skill practice (assertiveness training, boundary-setting conversations), monitor friendships closely, and consider school counselor involvement for group dynamics support.",
            hi: "साथी प्रभाव से निर्णय, मूड और व्यवहार पर स्पष्ट प्रभाव। संरचित सामाजिक कौशल अभ्यास लागू करें (दृढ़ता प्रशिक्षण, सीमा-निर्धारण बातचीत), दोस्ती पर नजर रखें और समूह गतिशीलता समर्थन के लिए स्कूल काउंसलर की भागीदारी पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High vulnerability, intervention recommended", hi: "उच्च संवेदनशीलता, हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Significant dependence on peer approval leading to risky choices, emotional distress or loss of self-identity. Professional intervention strongly recommended (child psychologist or counselor) for targeted assertiveness/resilience building, family therapy to strengthen home support, and possible school-based anti-pressure programs.",
            hi: "साथी मंजूरी पर महत्वपूर्ण निर्भरता से जोखिम भरे विकल्प, भावनात्मक संकट या स्व-परिचय की हानि। लक्षित दृढ़ता/लचीलापन निर्माण, परिवार थेरेपी से घरेलू समर्थन मजबूत करने और स्कूल-आधारित एंटी-प्रेशर कार्यक्रमों के लिए बाल मनोवैज्ञानिक या काउंसलर द्वारा पेशेवर हस्तक्षेप की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "homework-management",
    title: {
      en: "Homework Management",
      hi: "होमवर्क प्रबंधन"
    },
    description: {
      en: "Understanding homework purpose, organization/planning, execution/independence, emotional response to homework, and supportive family environment for skill development.",
      hi: "होमवर्क के उद्देश्य की समझ, संगठन/योजना, निष्पादन/स्वतंत्रता, होमवर्क के प्रति भावनात्मक प्रतिक्रिया और कौशल विकास के लिए सहायक परिवार वातावरण।"
    },
    questions: {
      parent: {
        en: [
          "My child understands why homework is given and how it helps learning.",
          "My child knows what homework needs to be completed each day.",
          "My child understands deadlines and submission requirements.",
          "My child knows how homework performance affects learning, not just marks.",
          "My child understands the importance of completing homework independently.",
          "My child keeps track of homework assignments consistently.",
          "My child plans homework time in advance.",
          "My child prioritizes homework among other daily activities.",
          "My child brings home the required books and materials.",
          "My child submits homework on time.",
          "My child starts homework without repeated reminders.",
          "My child completes homework without constant supervision.",
          "My child attempts difficult questions before asking for help.",
          "My child stays focused while doing homework.",
          "My child completes homework within a reasonable time.",
          "My child becomes anxious or upset when homework is assigned.",
          "My child avoids homework due to fear of mistakes.",
          "My child gets frustrated or angry while doing homework.",
          "My child shows low confidence in their ability to complete homework.",
          "Homework time creates tension or conflict at home.",
          "My child feels comfortable asking for help when needed.",
          "Our family encourages effort rather than perfection in homework.",
          "My child receives clear feedback on homework from adults.",
          "My child is gradually becoming more independent with homework.",
          "My child recovers emotionally after incomplete or incorrect homework."
        ],
        hi: [
          "मेरा बच्चा समझता है कि होमवर्क क्यों दिया जाता है और यह सीखने में कैसे मदद करता है।",
          "बच्चा जानता है कि रोज़ाना कौन सा होमवर्क पूरा करना है।",
          "डेडलाइन और जमा करने की आवश्यकताओं को बच्चा समझता है।",
          "होमवर्क प्रदर्शन सीखने को कैसे प्रभावित करता है, न कि सिर्फ अंकों को, बच्चा जानता है।",
          "होमवर्क स्वतंत्र रूप से पूरा करने के महत्व को बच्चा समझता है।",
          "होमवर्क असाइनमेंट को बच्चा लगातार ट्रैक रखता है।",
          "होमवर्क समय को बच्चा पहले से प्लान करता है।",
          "अन्य दैनिक गतिविधियों के बीच होमवर्क को प्राथमिकता देता है।",
          "आवश्यक किताबें और सामग्री घर लाता है।",
          "होमवर्क समय पर जमा करता है।",
          "बार-बार याद दिलाए बिना होमवर्क शुरू करता है।",
          "निरंतर निगरानी के बिना होमवर्क पूरा करता है।",
          "मुश्किल सवालों पर मदद मांगने से पहले प्रयास करता है।",
          "होमवर्क करते समय फोकस रहता है।",
          "होमवर्क उचित समय में पूरा करता है।",
          "होमवर्क दिए जाने पर चिंतित या परेशान हो जाता है।",
          "गलती के डर से होमवर्क से बचता है।",
          "होमवर्क करते समय निराश या गुस्सैल हो जाता है।",
          "होमवर्क पूरा करने की क्षमता में कम आत्मविश्वास दिखाता है।",
          "होमवर्क समय घर में तनाव या विवाद पैदा करता है।",
          "जरूरत पड़ने पर मदद मांगने में बच्चा सहज महसूस करता है।",
          "हमारा परिवार होमवर्क में परफेक्शन की बजाय प्रयास को प्रोत्साहित करता है।",
          "वयस्कों से होमवर्क पर स्पष्ट फीडबैक प्राप्त करता है।",
          "होमवर्क के साथ बच्चा धीरे-धीरे अधिक स्वतंत्र हो रहा है।",
          "अधूरा या गलत होमवर्क के बाद भावनात्मक रूप से उबर लेता है।"
        ]
      },
      educator: {
        en: [
          "Homework frequently submitted late, incomplete or missing despite reminders.",
          "Struggles to recall or explain homework instructions in class.",
          "Shows visible frustration, avoidance or low confidence when discussing homework.",
          "Requires repeated prompts to complete in-class follow-up or revision tasks.",
          "Difficulty prioritizing homework-related prep (e.g., bringing materials, organizing notes).",
          "Emotional signs (anxiety, withdrawal) noticeable around homework deadlines or feedback."
        ],
        hi: [
          "होमवर्क अक्सर देर से, अधूरा या याद दिलाने के बावजूद गुम जमा होता है।",
          "कक्षा में होमवर्क निर्देशों को याद करने या समझाने में संघर्ष।",
          "होमवर्क चर्चा में स्पष्ट निराशा, बचाव या कम आत्मविश्वास दिखाई देता है।",
          "इन-क्लास फॉलो-अप या रिवीजन कार्य पूरा करने के लिए बार-बार प्रॉम्प्ट की जरूरत।",
          "सामग्री लाना, नोट्स व्यवस्थित करना जैसे होमवर्क तैयारी को प्राथमिकता देने में कठिनाई।",
          "होमवर्क डेडलाइन या फीडबैक के आसपास चिंता, अलग-थलग जैसे भावनात्मक संकेत।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of persistent homework avoidance linked to anxiety or low confidence.",
          "History of emotional distress (frustration, tears, conflict) specifically around homework time.",
          "Patterns of dependency or executive function challenges affecting independent task completion.",
          "No primary learning disability or untreated condition fully explains the homework-related difficulties."
        ],
        hi: [
          "चिंता या कम आत्मविश्वास से जुड़े लगातार होमवर्क बचाव की अभिभावक/शिक्षक रिपोर्ट।",
          "होमवर्क समय के आसपास विशेष रूप से भावनात्मक संकट (निराशा, आँसू, विवाद) का इतिहास।",
          "स्वतंत्र कार्य पूरा करने में निर्भरता या कार्यकारी कार्य चुनौतियों का पैटर्न।",
          "होमवर्क-संबंधित कठिनाइयों को पूरी तरह समझाने वाला कोई प्राथमिक सीखने की अक्षमता या अनुपचारित स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / No difficulty, 3 = Almost always / High difficulty) — Lower total score = healthier homework habits",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong homework habits", hi: "मजबूत होमवर्क आदतें" },
          insight: {
            en: "Child shows excellent understanding, independence and positive emotional response to homework. Family support and routines are working well — continue encouraging effort, autonomy and open feedback to sustain healthy habits.",
            hi: "बच्चा उत्कृष्ट समझ, स्वतंत्रता और होमवर्क के प्रति सकारात्मक भावनात्मक प्रतिक्रिया दिखाता है। परिवार समर्थन और दिनचर्या अच्छा काम कर रही हैं — प्रयास, स्वायत्तता और खुली फीडबैक को प्रोत्साहित करके स्वस्थ आदतें बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor challenges, routine refinement helpful", hi: "छोटी चुनौतियाँ, दिनचर्या सुधार उपयोगी" },
          insight: {
            en: "Occasional lapses in planning, focus or mild stress around homework. Fine-tune routines: set consistent homework slot, use visual checklists, and reinforce independence with minimal prompts to strengthen habits without creating tension.",
            hi: "योजना, फोकस या होमवर्क के आसपास हल्का तनाव में कभी-कभी चूक। दिनचर्या को बेहतर बनाएँ: निश्चित होमवर्क स्लॉट सेट करें, दृश्य चेकलिस्ट का उपयोग करें और न्यूनतम प्रॉम्प्ट से स्वतंत्रता मजबूत करें ताकि तनाव न बने।"
          }
        },
        {
          range: "31–50",
          label: { en: "Ongoing struggles, structured support needed", hi: "लगातार संघर्ष, संरचित समर्थन की आवश्यकता" },
          insight: {
            en: "Noticeable difficulties in organization, execution or emotional handling of homework impacting completion and family dynamics. Implement structured supports (daily planner, timed sessions, break rules, positive reinforcement) and reduce over-helping to build confidence and reduce conflict.",
            hi: "संगठन, निष्पादन या होमवर्क हैंडलिंग में स्पष्ट कठिनाइयाँ जो पूरा होने और परिवार गतिशीलता को प्रभावित कर रही हैं। संरचित समर्थन लागू करें (दैनिक प्लानर, टाइम्ड सेशन, ब्रेक नियम, सकारात्मक सुदृढ़ीकरण) और अत्यधिक मदद कम करके आत्मविश्वास बढ़ाएँ और विवाद कम करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High difficulty, intervention recommended", hi: "उच्च कठिनाई, हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Significant challenges in awareness, independence and emotional regulation around homework, likely creating persistent stress and conflict. Professional input strongly recommended (school counselor, educational therapist or child psychologist) to assess underlying factors (anxiety, executive function, learning gaps) and design a targeted homework support plan.",
            hi: "होमवर्क के आसपास जागरूकता, स्वतंत्रता और भावनात्मक नियमन में महत्वपूर्ण चुनौतियाँ, जो लगातार तनाव और विवाद पैदा कर रही हैं। अंतर्निहित कारकों (चिंता, कार्यकारी कार्य, सीखने के अंतराल) का मूल्यांकन करने और लक्षित होमवर्क समर्थन योजना बनाने के लिए पेशेवर इनपुट (स्कूल काउंसलर, शैक्षिक थेरेपिस्ट या बाल मनोवैज्ञानिक) की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "behavioral-issues",
    title: {
      en: "Behavioral Issues",
      hi: "व्यवहार संबंधी मुद्दे"
    },
    description: {
      en: "Awareness and self-control of behavior, patterns and triggers, emotional regulation, impact on learning/relationships, and family/environmental supports for skill-building.",
      hi: "व्यवहार की जागरूकता और आत्म-नियंत्रण, पैटर्न और ट्रिगर्स, भावनात्मक नियमन, सीखने/संबंधों पर प्रभाव, और कौशल-निर्माण के लिए परिवार/पर्यावरणीय समर्थन।"
    },
    questions: {
      parent: {
        en: [
          "My child is aware when their behavior is inappropriate.",
          "My child can recognize emotional triggers before reacting.",
          "My child understands the consequences of their actions.",
          "My child attempts to correct behavior after making a mistake.",
          "My child shows age-appropriate self-control in daily situations.",
          "My child has frequent emotional outbursts (anger, crying, yelling).",
          "My child reacts impulsively without thinking.",
          "My child struggles to follow rules consistently.",
          "My child shows defiant behavior when given instructions.",
          "My child’s behavior worsens during stress, fatigue or transitions.",
          "My child has difficulty calming down after becoming upset.",
          "My child expresses frustration through aggression or withdrawal.",
          "My child struggles to express feelings in words.",
          "My child feels overwhelmed by strong emotions.",
          "My child’s mood changes quickly and intensely.",
          "My child’s behavior interferes with learning or classroom participation.",
          "My child has conflicts with peers due to behavior.",
          "My child receives frequent behavioral complaints from school.",
          "My child avoids situations where behavior might be judged.",
          "Behavioral issues create stress within the family.",
          "My child responds positively to clear routines and boundaries.",
          "My child benefits from calm and consistent discipline.",
          "My child is learning strategies to manage emotions.",
          "Our family focuses on teaching skills rather than punishment.",
          "My child shows gradual improvement in behavior over time."
        ],
        hi: [
          "मेरा बच्चा जानता है कि उसका व्यवहार अनुचित कब है।",
          "प्रतिक्रिया देने से पहले बच्चा भावनात्मक ट्रिगर्स पहचान सकता है।",
          "अपने कार्यों के परिणामों को बच्चा समझता है।",
          "गलती करने के बाद व्यवहार सुधारने का प्रयास करता है।",
          "दैनिक स्थितियों में आयु-अनुसार आत्म-नियंत्रण दिखाता है।",
          "बार-बार भावनात्मक विस्फोट (गुस्सा, रोना, चिल्लाना)।",
          "सोचे बिना आवेग में प्रतिक्रिया देता है।",
          "नियमों का लगातार पालन करने में संघर्ष।",
          "निर्देश दिए जाने पर विद्रोही व्यवहार दिखाता है।",
          "तनाव, थकान या संक्रमण के दौरान व्यवहार बिगड़ जाता है।",
          "परेशान होने के बाद शांत होने में कठिनाई।",
          "निराशा को आक्रामकता या वापसी से व्यक्त करता है।",
          "भावनाओं को शब्दों में व्यक्त करने में संघर्ष।",
          "मजबूत भावनाओं से अभिभूत महसूस करता है।",
          "मूड तेज़ी से और तीव्रता से बदलता है।",
          "व्यवहार सीखने या कक्षा भागीदारी में बाधा डालता है।",
          "व्यवहार के कारण साथियों से विवाद।",
          "स्कूल से बार-बार व्यवहार संबंधी शिकायतें।",
          "व्यवहार पर जजमेंट हो सकता है, ऐसी स्थितियों से बचता है।",
          "व्यवहार संबंधी मुद्दे परिवार में तनाव पैदा करते हैं।",
          "स्पष्ट दिनचर्या और सीमाओं पर सकारात्मक प्रतिक्रिया देता है।",
          "शांत और सुसंगत अनुशासन से लाभान्वित होता है।",
          "भावनाओं को प्रबंधित करने की रणनीतियाँ सीख रहा है।",
          "हमारा परिवार दंड की बजाय कौशल सिखाने पर फोकस करता है।",
          "समय के साथ व्यवहार में धीरे-धीरे सुधार दिखाता है।"
        ]
      },
      educator: {
        en: [
          "Frequent disruptions or off-task behavior during lessons or transitions.",
          "Impulsive reactions or difficulty following classroom rules/expectations.",
          "Emotional outbursts, aggression or withdrawal impacting group activities.",
          "Receives regular behavioral reminders or consequences in school.",
          "Struggles to calm down or re-engage after incidents of frustration.",
          "Conflicts with peers noticeable in play or collaborative settings."
        ],
        hi: [
          "पाठ या संक्रमण के दौरान बार-बार व्यवधान या ऑफ-टास्क व्यवहार।",
          "आवेगी प्रतिक्रियाएँ या कक्षा नियमों/अपेक्षाओं का पालन करने में कठिनाई।",
          "समूह गतिविधियों को प्रभावित करने वाले भावनात्मक विस्फोट, आक्रामकता या वापसी।",
          "स्कूल में नियमित व्यवहार रिमाइंडर या परिणाम प्राप्त करता है।",
          "घटनाओं के बाद शांत होने या पुनः जुड़ने में संघर्ष।",
          "खेल या सहयोगी सेटिंग में साथियों से विवाद दिखाई देते हैं।"
        ]
      },
      doctor: {
        en: [
          "History or observations of frequent emotional dysregulation, impulsivity or oppositional patterns across settings.",
          "Reports of behavioral escalation during stress, transitions or unmet needs.",
          "Signs of underlying emotional overwhelm or poor self-regulation noted in consultation.",
          "No primary medical/neurological cause (e.g., untreated ADHD, sensory issues) fully explains the behavioral concerns."
        ],
        hi: [
          "विभिन्न सेटिंग्स में बार-बार भावनात्मक असंतुलन, आवेगशीलता या विरोधी पैटर्न का इतिहास/अवलोकन।",
          "तनाव, संक्रमण या अपूर्ण आवश्यकताओं के दौरान व्यवहार वृद्धि की रिपोर्ट।",
          "परामर्श में अंतर्निहित भावनात्मक अभिभूत या खराब आत्म-नियमन के संकेत।",
          "व्यवहार संबंधी चिंताओं को पूरी तरह समझाने वाला कोई प्राथमिक चिकित्सकीय/न्यूरोलॉजिकल कारण नहीं (जैसे अनुपचारित ADHD, संवेदी मुद्दे)।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / No concern, 3 = Almost always / High concern) — Lower total score = healthier behavioral regulation",
      bands: [
        {
          range: "0–15",
          label: { en: "Well-regulated behavior", hi: "अच्छी तरह नियंत्रित व्यवहार" },
          insight: {
            en: "Child demonstrates strong self-awareness, emotional control and positive response to boundaries. Family focus on teaching and consistency is highly effective — continue reinforcing skills, routines and calm responses to sustain healthy regulation.",
            hi: "बच्चा मजबूत स्व-जागरूकता, भावनात्मक नियंत्रण और सीमाओं पर सकारात्मक प्रतिक्रिया दिखाता है। कौशल सिखाने और सुसंगतता पर परिवार का फोकस बहुत प्रभावी है — कौशलों, दिनचर्या और शांत प्रतिक्रियाओं को मजबूत करके स्वस्थ नियमन बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Occasional challenges, guidance helpful", hi: "कभी-कभी चुनौतियाँ, मार्गदर्शन उपयोगी" },
          insight: {
            en: "Mild or situational difficulties in regulation or impulse control. Strengthen proactive supports: clear daily routines, emotion naming/coaching moments, and positive reinforcement for calm choices to prevent escalation.",
            hi: "नियमन या आवेग नियंत्रण में हल्की या परिस्थितिजन्य कठिनाइयाँ। सक्रिय समर्थन मजबूत करें: स्पष्ट दैनिक दिनचर्या, भावना नामकरण/कोचिंग क्षण, और शांत विकल्पों के लिए सकारात्मक सुदृढ़ीकरण से वृद्धि रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Persistent difficulties, structured support needed", hi: "लगातार कठिनाइयाँ, संरचित समर्थन की आवश्यकता" },
          insight: {
            en: "Noticeable patterns of dysregulation, defiance or emotional spillover affecting school, relationships and home. Implement consistent behavior support plan (visual rules, calm-down spaces, skill-teaching moments) and reduce punitive responses; consider school counselor collaboration for classroom strategies.",
            hi: "नियमन की कमी, विद्रोह या भावनात्मक स्पिलओवर के स्पष्ट पैटर्न जो स्कूल, संबंधों और घर को प्रभावित कर रहे हैं। सुसंगत व्यवहार समर्थन प्लान लागू करें (दृश्य नियम, शांत होने की जगह, कौशल-सिखाने के क्षण) और दंडात्मक प्रतिक्रियाएँ कम करें; कक्षा रणनीतियों के लिए स्कूल काउंसलर सहयोग पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant concerns, professional evaluation recommended", hi: "महत्वपूर्ण चिंताएँ, पेशेवर मूल्यांकन की सिफारिश" },
          insight: {
            en: "Severe and pervasive behavioral challenges impacting multiple domains (learning, social, family functioning). Urgent professional assessment recommended (child psychologist, behavioral therapist or developmental pediatrician) to identify underlying factors (emotional regulation, executive function, trauma, neurodevelopmental needs) and develop a comprehensive, evidence-based intervention plan.",
            hi: "एकाधिक क्षेत्रों (सीखना, सामाजिक, परिवार कार्यक्षमता) को प्रभावित करने वाली गंभीर और व्यापक व्यवहार चुनौतियाँ। अंतर्निहित कारकों (भावनात्मक नियमन, कार्यकारी कार्य, आघात, न्यूरो-विकासात्मक आवश्यकताएँ) की पहचान और व्यापक, साक्ष्य-आधारित हस्तक्षेप योजना बनाने के लिए तत्काल पेशेवर मूल्यांकन (बाल मनोवैज्ञानिक, व्यवहार थेरेपिस्ट या विकासात्मक बाल रोग विशेषज्ञ) की सिफारिश।"
          }
        }
      ]
    }
  },  
  {
    id: "emotional-well-being",
    title: {
      en: "Emotional Well-being",
      hi: "भावनात्मक कल्याण"
    },
    description: {
      en: "Emotional awareness & expression, regulation & coping, stability & mood patterns, self-worth & inner confidence, and emotional support & safety.",
      hi: "भावनात्मक जागरूकता एवं अभिव्यक्ति, नियमन एवं coping, स्थिरता एवं मूड पैटर्न, आत्म-मूल्य एवं आंतरिक आत्मविश्वास, तथा भावनात्मक समर्थन एवं सुरक्षा।"
    },
    questions: {
      parent: {
        en: [
          "My child can identify and name their emotions.",
          "My child expresses feelings in words rather than behavior.",
          "My child understands that all emotions are normal and acceptable.",
          "My child communicates emotional needs clearly.",
          "My child can describe what makes them feel happy, sad or upset.",
          "My child can calm themselves when feeling upset.",
          "My child uses healthy coping strategies (breathing, breaks, talking).",
          "My child recovers emotionally after disappointment or failure.",
          "My child handles frustration without losing control.",
          "My child adapts emotionally to changes or unexpected situations.",
          "My child’s mood is generally stable.",
          "My child experiences prolonged sadness or low mood.",
          "My child shows excessive worry or fear.",
          "My child appears emotionally withdrawn or disconnected.",
          "My child enjoys daily activities and interactions.",
          "My child feels good about who they are.",
          "My child speaks kindly about themselves.",
          "My child believes they can handle challenges.",
          "My child feels valued and accepted at home and school.",
          "My child handles criticism without emotional shutdown.",
          "My child feels emotionally safe at home.",
          "My child shares feelings with a trusted adult.",
          "Our family validates emotions rather than dismissing them.",
          "My child receives comfort when emotionally distressed.",
          "My child feels supported even during difficult emotional phases."
        ],
        hi: [
          "मेरा बच्चा अपनी भावनाओं को पहचान और नाम दे सकता है।",
          "बच्चा व्यवहार की बजाय शब्दों में भावनाएँ व्यक्त करता है।",
          "बच्चा समझता है कि सभी भावनाएँ सामान्य और स्वीकार्य हैं।",
          "भावनात्मक आवश्यकताओं को स्पष्ट रूप से संप्रेषित करता है।",
          "खुश, उदास या परेशान होने के कारण बता सकता है।",
          "परेशान होने पर खुद को शांत कर सकता है।",
          "स्वस्थ coping रणनीतियाँ (साँस लेना, ब्रेक, बात करना) इस्तेमाल करता है।",
          "निराशा या असफलता के बाद भावनात्मक रूप से उबर लेता है।",
          "निराशा को नियंत्रण खोए बिना संभालता है।",
          "परिवर्तन या अप्रत्याशित स्थितियों में भावनात्मक रूप से ढल जाता है।",
          "बच्चे का मूड आमतौर पर स्थिर रहता है।",
          "लंबे समय तक उदासी या कम मूड का अनुभव करता है।",
          "अत्यधिक चिंता या डर दिखाता है।",
          "भावनात्मक रूप से अलग-थलग या डिस्कनेक्टेड दिखता है।",
          "दैनिक गतिविधियों और अंतर्क्रियाओं का आनंद लेता है।",
          "अपने बारे में अच्छा महसूस करता है।",
          "खुद के बारे में दयालुता से बात करता है।",
          "चुनौतियों को संभालने में विश्वास करता है।",
          "घर और स्कूल में मूल्यवान और स्वीकार्य महसूस करता है।",
          "आलोचना को भावनात्मक बंद होने के बिना संभालता है।",
          "घर में भावनात्मक रूप से सुरक्षित महसूस करता है।",
          "विश्वसनीय वयस्क के साथ भावनाएँ साझा करता है।",
          "हमारा परिवार भावनाओं को खारिज करने की बजाय मान्यता देता है।",
          "भावनात्मक संकट में सांत्वना प्राप्त करता है।",
          "कठिन भावनात्मक चरणों में भी समर्थित महसूस करता है।"
        ]
      },
      educator: {
        en: [
          "Difficulty naming or discussing emotions during class or counseling moments.",
          "Shows prolonged low mood, withdrawal or disconnection from peers/activities.",
          "Frequent emotional escalation or shutdown when facing frustration/challenges.",
          "Struggles to use words to express feelings; relies on behavioral signals.",
          "Visible anxiety or worry impacting participation in group or academic tasks.",
          "Slow recovery after disappointment or peer conflict in school setting."
        ],
        hi: [
          "कक्षा या काउंसलिंग क्षणों में भावनाओं को नाम देने या चर्चा करने में कठिनाई।",
          "लंबे समय तक कम मूड, वापसी या साथियों/गतिविधियों से डिस्कनेक्शन।",
          "निराशा/चुनौतियों पर बार-बार भावनात्मक वृद्धि या बंद होना।",
          "भावनाओं को शब्दों में व्यक्त करने में संघर्ष; व्यवहारिक संकेतों पर निर्भर।",
          "समूह या शैक्षिक कार्यों में भागीदारी प्रभावित करने वाली दृश्य चिंता या चिंता।",
          "स्कूल सेटिंग में निराशा या साथी विवाद के बाद धीमी रिकवरी।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of persistent low mood, excessive worry or emotional lability.",
          "History of difficulty with emotional identification, expression or regulation.",
          "Signs of poor self-worth, withdrawal or disconnection in developmental/consultation observations.",
          "No primary medical condition (e.g., untreated thyroid, nutritional deficiency) fully explains emotional presentation."
        ],
        hi: [
          "लगातार कम मूड, अत्यधिक चिंता या भावनात्मक अस्थिरता की अभिभावक/शिक्षक रिपोर्ट।",
          "भावनात्मक पहचान, अभिव्यक्ति या नियमन में कठिनाई का इतिहास।",
          "विकास/परामर्श अवलोकनों में कम आत्म-मूल्य, वापसी या डिस्कनेक्शन के संकेत।",
          "भावनात्मक प्रस्तुति को पूरी तरह समझाने वाली कोई प्राथमिक चिकित्सकीय स्थिति (जैसे अनुपचारित थायरॉइड, पोषण कमी) नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Emotionally healthy, 3 = Almost always / High concern) — Lower total score = stronger emotional well-being",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong emotional well-being", hi: "मजबूत भावनात्मक कल्याण" },
          insight: {
            en: "Child exhibits excellent emotional awareness, regulation and secure support system. Family validation and skill-building are highly effective — continue nurturing open expression, healthy coping and unconditional acceptance to protect this strong foundation.",
            hi: "बच्चा उत्कृष्ट भावनात्मक जागरूकता, नियमन और सुरक्षित समर्थन प्रणाली दिखाता है। परिवार की मान्यता और कौशल-निर्माण अत्यधिक प्रभावी हैं — खुली अभिव्यक्ति, स्वस्थ coping और बिना शर्त स्वीकृति को बढ़ावा देकर इस मजबूत नींव की रक्षा करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild emotional stress, preventive support helpful", hi: "हल्का भावनात्मक तनाव, निवारक समर्थन उपयोगी" },
          insight: {
            en: "Occasional emotional lability or difficulty with regulation showing. Bolster protective factors: daily emotion check-ins, teach simple coping tools (breathing, journaling), and maintain consistent family validation to prevent escalation.",
            hi: "कभी-कभी भावनात्मक अस्थिरता या नियमन में कठिनाई दिख रही है। सुरक्षात्मक कारकों को मजबूत करें: दैनिक भावना चेक-इन, सरल coping टूल (साँस, जर्नलिंग) सिखाएँ और सुसंगत परिवार मान्यता बनाए रखकर वृद्धि रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Ongoing emotional difficulties, structured support needed", hi: "लगातार भावनात्मक कठिनाइयाँ, संरचित समर्थन की आवश्यकता" },
          insight: {
            en: "Noticeable patterns of mood instability, poor regulation or low self-worth affecting daily functioning and relationships. Implement structured emotional coaching (named feelings, coping menu, calm-down routines) at home and school; consider school counselor involvement for consistent support.",
            hi: "मूड अस्थिरता, खराब नियमन या कम आत्म-मूल्य के स्पष्ट पैटर्न जो दैनिक कार्य और संबंधों को प्रभावित कर रहे हैं। घर और स्कूल में संरचित भावनात्मक कोचिंग लागू करें (नामित भावनाएँ, coping मेनू, शांत होने की दिनचर्या); सुसंगत समर्थन के लिए स्कूल काउंसलर की भागीदारी पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant emotional concerns, professional support recommended", hi: "महत्वपूर्ण भावनात्मक चिंताएँ, पेशेवर समर्थन की सिफारिश" },
          insight: {
            en: "Severe emotional dysregulation, persistent low mood or disconnection impacting well-being across settings. Professional evaluation and support strongly recommended (child psychologist or play therapist) for in-depth assessment of underlying factors (anxiety, trauma, attachment) and development of a tailored emotional resilience plan.",
            hi: "गंभीर भावनात्मक असंतुलन, लगातार कम मूड या डिस्कनेक्शन जो विभिन्न सेटिंग्स में कल्याण को प्रभावित कर रहा है। अंतर्निहित कारकों (चिंता, आघात, लगाव) के गहन मूल्यांकन और व्यक्तिगत भावनात्मक लचीलापन योजना बनाने के लिए बाल मनोवैज्ञानिक या प्ले थेरेपिस्ट द्वारा पेशेवर मूल्यांकन और समर्थन की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "health-nutrition",
    title: {
      en: "Health & Nutrition",
      hi: "स्वास्थ्य और पोषण"
    },
    description: {
      en: "Nutritional awareness & choices, eating habits & routine, physical health & energy levels, physical activity & lifestyle balance, and family support & health practices.",
      hi: "पोषण जागरूकता एवं विकल्प, खाने की आदतें एवं दिनचर्या, शारीरिक स्वास्थ्य एवं ऊर्जा स्तर, शारीरिक गतिविधि एवं जीवनशैली संतुलन, तथा परिवार समर्थन एवं स्वास्थ्य प्रथाएँ।"
    },
    questions: {
      parent: {
        en: [
          "My child understands the importance of eating healthy food.",
          "My child can identify healthy and unhealthy food choices.",
          "My child understands the role of food in energy, growth and focus.",
          "My child makes balanced food choices when options are available.",
          "My child shows interest in learning about healthy eating.",
          "My child eats regular meals without frequently skipping them.",
          "My child eats a balanced breakfast on most days.",
          "My child consumes fruits and vegetables regularly.",
          "My child limits junk food, sugary snacks and soft drinks.",
          "My child eats meals without excessive screen distraction.",
          "My child generally has good energy levels throughout the day.",
          "My child complains of tiredness or weakness often.",
          "My child falls sick frequently or has low immunity.",
          "My child maintains a healthy weight for their age.",
          "My child recovers quickly from physical exertion or illness.",
          "My child engages in daily physical activity or active play.",
          "My child spends excessive time sitting or inactive.",
          "My child enjoys outdoor play or sports.",
          "My child avoids physical activity without medical reasons.",
          "My child balances physical activity with rest.",
          "Our family maintains regular meal times.",
          "We encourage healthy eating without force or punishment.",
          "My child drinks sufficient water daily.",
          "Our family models healthy lifestyle habits.",
          "My child is developing lifelong healthy eating habits."
        ],
        hi: [
          "मेरा बच्चा स्वस्थ भोजन खाने के महत्व को समझता है।",
          "बच्चा स्वस्थ और अस्वास्थ्यकर भोजन विकल्पों की पहचान कर सकता है।",
          "भोजन ऊर्जा, विकास और फोकस में क्या भूमिका निभाता है, बच्चा समझता है।",
          "विकल्प उपलब्ध होने पर संतुलित भोजन विकल्प चुनता है।",
          "स्वस्थ खान-पान के बारे में सीखने में रुचि दिखाता है।",
          "बच्चा नियमित भोजन करता है, बार-बार छोड़ता नहीं।",
          "अधिकांश दिनों में संतुलित नाश्ता करता है।",
          "फल और सब्जियाँ नियमित रूप से खाता है।",
          "जंक फूड, मीठे स्नैक्स और सॉफ्ट ड्रिंक्स को सीमित करता है।",
          "अत्यधिक स्क्रीन distraction के बिना भोजन करता है।",
          "दिन भर में सामान्य रूप से अच्छी ऊर्जा स्तर रहते हैं।",
          "अक्सर थकान या कमजोरी की शिकायत करता है।",
          "बार-बार बीमार पड़ता है या कम इम्यूनिटी है।",
          "आयु के अनुसार स्वस्थ वजन बनाए रखता है।",
          "शारीरिक परिश्रम या बीमारी से जल्दी ठीक होता है।",
          "दैनिक शारीरिक गतिविधि या सक्रिय खेल में शामिल होता है।",
          "अत्यधिक समय बैठे या निष्क्रिय रहता है।",
          "आउटडोर खेल या स्पोर्ट्स का आनंद लेता है।",
          "चिकित्सकीय कारणों के बिना शारीरिक गतिविधि से बचता है।",
          "शारीरिक गतिविधि और आराम के बीच संतुलन बनाता है।",
          "हमारा परिवार नियमित भोजन समय बनाए रखता है।",
          "जबरदस्ती या दंड के बिना स्वस्थ खान-पान को प्रोत्साहित करते हैं।",
          "बच्चा रोज़ाना पर्याप्त पानी पीता है।",
          "हमारा परिवार स्वस्थ जीवनशैली आदतों का मॉडल प्रस्तुत करता है।",
          "बच्चा जीवनभर की स्वस्थ खाने की आदतें विकसित कर रहा है।"
        ]
      },
      educator: {
        en: [
          "Noticeable low energy, tiredness or difficulty concentrating during school day.",
          "Frequently complains of hunger, skips snacks/meals or brings unhealthy options.",
          "Limited participation in physical education or active play due to low stamina.",
          "Signs of poor hydration (dry lips, frequent requests for water) or fatigue.",
          "Behavioral or mood changes possibly linked to skipped breakfast or poor nutrition.",
          "Struggles with sustained attention in longer lessons (possible blood sugar/energy dips)."
        ],
        hi: [
          "स्कूल के दिन में स्पष्ट कम ऊर्जा, थकान या एकाग्रता में कठिनाई।",
          "बार-बार भूख की शिकायत, स्नैक्स/भोजन छोड़ना या अस्वास्थ्यकर विकल्प लाना।",
          "कम स्टैमिना के कारण शारीरिक शिक्षा या सक्रिय खेल में सीमित भागीदारी।",
          "खराब हाइड्रेशन (सूखे होंठ, बार-बार पानी मांगना) या थकान के संकेत।",
          "नाश्ता छोड़ने या खराब पोषण से जुड़े व्यवहारिक या मूड परिवर्तन।",
          "लंबे पाठों में निरंतर ध्यान बनाए रखने में संघर्ष (संभावित ब्लड शुगर/ऊर्जा गिरावट)।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of irregular meals, excessive junk food or poor hydration habits.",
          "History of recurrent illness, slow recovery, low energy or growth concerns linked to nutrition.",
          "Signs of sedentary lifestyle with limited physical activity noted in consultation.",
          "No primary medical condition (e.g., untreated anemia, thyroid issue) fully explains low energy/immunity."
        ],
        hi: [
          "अनियमित भोजन, अत्यधिक जंक फूड या खराब हाइड्रेशन आदतों की अभिभावक रिपोर्ट।",
          "पोषण से जुड़ी बार-बार बीमारी, धीमी रिकवरी, कम ऊर्जा या विकास चिंताओं का इतिहास।",
          "परामर्श में सीमित शारीरिक गतिविधि वाले निष्क्रिय जीवनशैली के संकेत।",
          "कम ऊर्जा/इम्यूनिटी को पूरी तरह समझाने वाली कोई प्राथमिक चिकित्सकीय स्थिति (जैसे अनुपचारित एनीमिया, थायरॉइड समस्या) नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Healthy habit, 3 = Almost always / High concern) — Lower total score = healthier nutrition & physical well-being",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy lifestyle foundation", hi: "स्वस्थ जीवनशैली नींव" },
          insight: {
            en: "Excellent nutritional habits, energy levels and balanced activity. Family modeling and routines are strong — continue encouraging variety, hydration, movement and positive food attitudes to build lifelong health resilience.",
            hi: "उत्कृष्ट पोषण आदतें, ऊर्जा स्तर और संतुलित गतिविधि। परिवार मॉडलिंग और दिनचर्या मजबूत हैं — विविधता, हाइड्रेशन, मूवमेंट और सकारात्मक भोजन दृष्टिकोण को प्रोत्साहित करके जीवनभर स्वास्थ्य लचीलापन बनाएँ।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor gaps, gentle habit-building needed", hi: "छोटे अंतराल, हल्का आदत-निर्माण आवश्यक" },
          insight: {
            en: "Small inconsistencies in meals, activity or awareness appearing. Gently strengthen habits: add fun fruit/veggie challenges, family walks, set meal times and model balanced choices without pressure to close gaps early.",
            hi: "भोजन, गतिविधि या जागरूकता में छोटी असंगतियाँ दिख रही हैं। आदतों को हल्के ढंग से मजबूत करें: मजेदार फल/सब्जी चुनौतियाँ, परिवार की सैर, निश्चित भोजन समय और दबाव रहित संतुलित विकल्पों का मॉडल बनाकर अंतराल जल्दी बंद करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Ongoing health concerns, structured routines needed", hi: "लगातार स्वास्थ्य चिंताएँ, संरचित दिनचर्या की आवश्यकता" },
          insight: {
            en: "Noticeable patterns of poor nutrition, low energy or sedentary behavior affecting daily functioning. Establish structured routines (regular meals, screen-free eating, daily activity slots) and involve child in planning/choosing healthy options to build ownership and motivation.",
            hi: "खराब पोषण, कम ऊर्जा या निष्क्रिय व्यवहार के स्पष्ट पैटर्न जो दैनिक कार्य को प्रभावित कर रहे हैं। संरचित दिनचर्या स्थापित करें (नियमित भोजन, स्क्रीन-मुक्त खाना, दैनिक गतिविधि स्लॉट) और बच्चे को स्वस्थ विकल्प चुनने/योजना बनाने में शामिल करें ताकि स्वामित्व और प्रेरणा बने।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant issues, professional guidance recommended", hi: "महत्वपूर्ण मुद्दे, पेशेवर मार्गदर्शन की सिफारिश" },
          insight: {
            en: "Severe gaps in nutrition, physical activity or energy impacting growth, immunity, focus and well-being. Professional consultation strongly recommended (pediatrician, nutritionist or child health specialist) for thorough assessment and personalized plan addressing diet, activity and potential underlying medical factors.",
            hi: "पोषण, शारीरिक गतिविधि या ऊर्जा में गंभीर अंतराल जो विकास, इम्यूनिटी, फोकस और कल्याण को प्रभावित कर रहे हैं। गहन मूल्यांकन और व्यक्तिगत योजना (आहार, गतिविधि और संभावित अंतर्निहित चिकित्सकीय कारकों) के लिए बाल रोग विशेषज्ञ, न्यूट्रिशनिस्ट या बाल स्वास्थ्य विशेषज्ञ से परामर्श की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "sleep-routine",
    title: {
      en: "Sleep Routine",
      hi: "नींद की दिनचर्या"
    },
    description: {
      en: "Awareness of sleep importance, timing & consistency, environment & habits, quality & night disruptions, daytime impact, and family support for healthy sleep.",
      hi: "नींद के महत्व की जागरूकता, समय एवं निरंतरता, वातावरण एवं आदतें, गुणवत्ता एवं रात्रि विघटन, दिन के प्रभाव, तथा स्वस्थ नींद के लिए परिवार समर्थन।"
    },
    questions: {
      parent: {
        en: [
          "My child understands why sleep is important for health and learning.",
          "My child knows how much sleep they need for their age.",
          "My child understands the impact of poor sleep on mood and focus.",
          "My child recognizes when they are sleep-deprived.",
          "My child values sleep as part of daily routine.",
          "My child goes to bed at a consistent time on school days.",
          "My child wakes up at a consistent time on school days.",
          "My child’s sleep schedule changes significantly on weekends.",
          "My child delays bedtime unnecessarily.",
          "My child struggles to fall asleep within a reasonable time.",
          "My child uses screens (phone, TV, tablet) close to bedtime.",
          "My child sleeps in a calm, comfortable and dark environment.",
          "My child follows a calming pre-sleep routine.",
          "My child eats heavy meals or sugary snacks close to bedtime.",
          "My child needs external stimulation (TV, phone, noise) to fall asleep.",
          "My child wakes up frequently during the night.",
          "My child has nightmares or night anxiety.",
          "My child wakes up feeling tired despite adequate sleep time.",
          "My child experiences sleep-related fears or resistance.",
          "My child snores loudly or has breathing difficulties during sleep.",
          "My child feels alert and energetic during the day.",
          "My child shows irritability or mood swings due to lack of sleep.",
          "My child has difficulty focusing at school due to poor sleep.",
          "Our family enforces consistent sleep routines.",
          "My child is learning healthy sleep habits for long-term well-being."
        ],
        hi: [
          "मेरा बच्चा स्वास्थ्य और सीखने के लिए नींद क्यों महत्वपूर्ण है, यह समझता है।",
          "बच्चा अपनी आयु के अनुसार कितनी नींद चाहिए, यह जानता है।",
          "खराब नींद का मूड और फोकस पर प्रभाव बच्चा समझता है।",
          "नींद की कमी होने पर बच्चा पहचानता है।",
          "बच्चा दैनिक दिनचर्या का हिस्सा नींद को महत्व देता है।",
          "स्कूल के दिनों में बच्चा लगातार समय पर सोने जाता है।",
          "स्कूल के दिनों में बच्चा लगातार समय पर जागता है।",
          "वीकेंड पर नींद का शेड्यूल काफी बदल जाता है।",
          "बच्चा अनावश्यक रूप से बेडटाइम टालता है।",
          "उचित समय में सोने में संघर्ष करता है।",
          "सोने से पहले स्क्रीन (फोन, टीवी, टैबलेट) का उपयोग करता है।",
          "शांत, आरामदायक और अंधेरे वातावरण में सोता है।",
          "सोने से पहले शांत करने वाली दिनचर्या का पालन करता है।",
          "सोने से पहले भारी भोजन या मीठे स्नैक्स खाता है।",
          "सोने के लिए बाहरी उत्तेजना (टीवी, फोन, शोर) की जरूरत पड़ती है।",
          "रात में बार-बार जाग जाता है।",
          "दुःस्वप्न या रात्रि चिंता होती है।",
          "पर्याप्त नींद के बावजूद थका हुआ जागता है।",
          "नींद से जुड़े डर या प्रतिरोध का अनुभव करता है।",
          "जोर से खर्राटे लेता है या सांस लेने में कठिनाई होती है।",
          "दिन में सतर्क और ऊर्जावान महसूस करता है।",
          "नींद की कमी से चिड़चिड़ापन या मूड स्विंग दिखाता है।",
          "खराब नींद के कारण स्कूल में फोकस करने में कठिनाई।",
          "हमारा परिवार सुसंगत नींद दिनचर्या लागू करता है।",
          "बच्चा लंबे समय के कल्याण के लिए स्वस्थ नींद आदतें सीख रहा है।"
        ]
      },
      educator: {
        en: [
          "Frequently appears tired, yawning or low energy during morning classes.",
          "Difficulty sustaining attention or staying alert in longer lessons.",
          "Irritability, mood swings or emotional dysregulation noticeable in school.",
          "Reports or signs of weekend sleep pattern disruption affecting Monday performance.",
          "Struggles to engage fully in activities after inconsistent sleep nights.",
          "Visible signs of sleep deprivation (dark circles, slow responses) in classroom."
        ],
        hi: [
          "सुबह की कक्षाओं में अक्सर थका, जम्हाई लेता या कम ऊर्जा वाला दिखता है।",
          "लंबे पाठों में ध्यान बनाए रखने या सतर्क रहने में कठिनाई।",
          "स्कूल में चिड़चिड़ापन, मूड स्विंग या भावनात्मक असंतुलन दिखाई देता है।",
          "वीकेंड नींद पैटर्न विघटन से सोमवार प्रदर्शन प्रभावित होने की रिपोर्ट/संकेत।",
          "असंगत नींद वाली रातों के बाद गतिविधियों में पूर्ण जुड़ाव में संघर्ष।",
          "कक्षा में नींद की कमी के दृश्य संकेत (काले घेरे, धीमी प्रतिक्रियाएँ)।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of inconsistent sleep schedule, delayed bedtime or frequent night wakings.",
          "History of screen exposure near bedtime, poor sleep hygiene or anxiety-driven resistance.",
          "Signs of daytime sleepiness, irritability or cognitive/focus difficulties linked to sleep quality.",
          "No primary medical sleep disorder (e.g., untreated sleep apnea, restless legs) fully explains the routine concerns."
        ],
        hi: [
          "असंगत नींद शेड्यूल, देरी से बेडटाइम या बार-बार रात्रि जागने की अभिभावक रिपोर्ट।",
          "बेडटाइम के पास स्क्रीन एक्सपोजर, खराब नींद स्वच्छता या चिंता-प्रेरित प्रतिरोध का इतिहास।",
          "दिन की नींद आना, चिड़चिड़ापन या संज्ञानात्मक/फोकस कठिनाइयाँ नींद गुणवत्ता से जुड़ी।",
          "नींद दिनचर्या चिंताओं को पूरी तरह समझाने वाला कोई प्राथमिक चिकित्सकीय नींद विकार (जैसे अनुपचारित स्लीप एप्निया, restless legs) नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Healthy habit, 3 = Almost always / Severe issue) — Lower total score = healthier sleep routine",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy sleep foundation", hi: "स्वस्थ नींद नींव" },
          insight: {
            en: "Excellent sleep awareness, consistency and quality. Family routines and habits are protective — continue enforcing consistent bed/wake times, screen-free wind-down and calming rituals to maintain this strong sleep health.",
            hi: "उत्कृष्ट नींद जागरूकता, निरंतरता और गुणवत्ता। परिवार दिनचर्या और आदतें सुरक्षात्मक हैं — लगातार सोने/जागने का समय, स्क्रीन-मुक्त वाइंड-डाउन और शांत रिचुअल्स लागू करके इस मजबूत नींद स्वास्थ्य को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild disruptions, routine adjustment helpful", hi: "हल्के विघटन, दिनचर्या समायोजन उपयोगी" },
          insight: {
            en: "Minor inconsistencies in timing, habits or quality emerging. Strengthen sleep hygiene: fixed bedtime routine, no screens 1 hour before bed, consistent wake time even on weekends, and gentle monitoring to prevent mild issues from growing.",
            hi: "समय, आदतों या गुणवत्ता में छोटी असंगतियाँ उभर रही हैं। नींद स्वच्छता मजबूत करें: निश्चित बेडटाइम रूटीन, सोने से 1 घंटा पहले कोई स्क्रीन नहीं, वीकेंड पर भी सुसंगत जागने का समय, और हल्की निगरानी से हल्की समस्याएँ बढ़ने से रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Ongoing sleep problems, structured intervention needed", hi: "लगातार नींद समस्याएँ, संरचित हस्तक्षेप आवश्यक" },
          insight: {
            en: "Noticeable disruptions in schedule, environment or quality affecting daytime energy, mood and focus. Create a structured sleep plan: blackout curtains/dark room, calming pre-bed ritual, no caffeine/sugar after evening, and track sleep log for 2 weeks to identify patterns; involve school if daytime impact persists.",
            hi: "शेड्यूल, वातावरण या गुणवत्ता में स्पष्ट विघटन जो दिन की ऊर्जा, मूड और फोकस को प्रभावित कर रहे हैं। संरचित नींद प्लान बनाएँ: ब्लैकआउट पर्दे/अंधेरा कमरा, शांत प्री-बेड रिचुअल, शाम के बाद कैफीन/चीनी नहीं, और पैटर्न पहचानने के लिए 2 सप्ताह नींद लॉग ट्रैक करें; दिन के प्रभाव बने रहने पर स्कूल को शामिल करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant sleep concerns, professional evaluation recommended", hi: "महत्वपूर्ण नींद चिंताएँ, पेशेवर मूल्यांकन की सिफारिश" },
          insight: {
            en: "Severe sleep hygiene issues, frequent disruptions or resistance impacting health, behavior, learning and emotional well-being. Professional evaluation strongly recommended (pediatrician or pediatric sleep specialist) to rule out underlying conditions (sleep apnea, anxiety, circadian misalignment) and develop a comprehensive, evidence-based sleep intervention plan.",
            hi: "गंभीर नींद स्वच्छता मुद्दे, बार-बार विघटन या प्रतिरोध जो स्वास्थ्य, व्यवहार, सीखने और भावनात्मक कल्याण को प्रभावित कर रहे हैं। अंतर्निहित स्थितियों (स्लीप एप्निया, चिंता, सर्कैडियन असंतुलन) को नकारने और व्यापक, साक्ष्य-आधारित नींद हस्तक्षेप योजना बनाने के लिए बाल रोग विशेषज्ञ या बाल नींद विशेषज्ञ द्वारा पेशेवर मूल्यांकन की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "communication-skills",
    title: {
      en: "Communication Skills",
      hi: "संचार कौशल"
    },
    description: {
      en: "Expressive communication, receptive/listening skills, confidence in social/academic settings, emotional & conflict communication, and family/language environment supporting growth.",
      hi: "अभिव्यंजक संचार, ग्रहणात्मक/सुनने के कौशल, सामाजिक/शैक्षिक सेटिंग में आत्मविश्वास, भावनात्मक एवं संघर्ष संचार, तथा विकास का समर्थन करने वाला परिवार/भाषा वातावरण।"
    },
    questions: {
      parent: {
        en: [
          "My child can clearly express their thoughts.",
          "My child communicates needs without frustration.",
          "My child speaks up when they need help.",
          "My child expresses emotions using words.",
          "My child explains ideas in an age-appropriate manner.",
          "My child listens attentively when others speak.",
          "My child follows verbal instructions accurately.",
          "My child asks questions when they do not understand.",
          "My child avoids interrupting others while they speak.",
          "My child understands tone, body language and cues.",
          "My child speaks confidently in front of peers.",
          "My child participates in class discussions.",
          "My child communicates comfortably with adults.",
          "My child avoids speaking due to fear or shyness.",
          "My child handles disagreements respectfully.",
          "My child communicates calmly when upset.",
          "My child avoids shouting, blaming or shutting down.",
          "My child explains their side during conflicts.",
          "My child understands others’ perspectives.",
          "My child resolves misunderstandings through discussion.",
          "My child feels safe expressing opinions at home.",
          "Our family encourages open conversations.",
          "My child is improving communication skills over time.",
          "My child receives guidance on respectful communication.",
          "My child adapts communication style across situations."
        ],
        hi: [
          "मेरा बच्चा अपनी बातें स्पष्ट रूप से व्यक्त कर सकता है।",
          "बच्चा बिना निराशा के अपनी आवश्यकताएँ संप्रेषित करता है।",
          "जरूरत पड़ने पर मदद मांगने के लिए बोलता है।",
          "भावनाओं को शब्दों में व्यक्त करता है।",
          "आयु-अनुसार विचारों को समझाता है।",
          "दूसरे बोलते समय ध्यान से सुनता है।",
          "मौखिक निर्देशों का सटीक पालन करता है।",
          "समझ न आने पर सवाल पूछता है।",
          "दूसरे बोलते समय बीच में नहीं टोकता।",
          "लहजा, बॉडी लैंग्वेज और संकेतों को समझता है।",
          "साथियों के सामने आत्मविश्वास से बोलता है।",
          "कक्षा चर्चा में भाग लेता है।",
          "वयस्कों से सहज संवाद करता है।",
          "डर या शर्म के कारण बोलने से बचता है।",
          "असहमति को सम्मानजनक ढंग से संभालता है।",
          "परेशान होने पर शांतिपूर्वक संवाद करता है।",
          "चिल्लाना, दोष देना या बंद हो जाना से बचता है।",
          "संघर्ष के दौरान अपनी बात रखता है।",
          "दूसरों के दृष्टिकोण को समझता है।",
          "गलतफहमियों को चर्चा से सुलझाता है।",
          "घर पर राय व्यक्त करने में सुरक्षित महसूस करता है।",
          "हमारा परिवार खुली बातचीत को प्रोत्साहित करता है।",
          "समय के साथ संचार कौशल में सुधार हो रहा है।",
          "सम्मानजनक संचार पर मार्गदर्शन प्राप्त करता है।",
          "विभिन्न स्थितियों में संचार शैली को अनुकूलित करता है।"
        ]
      },
      educator: {
        en: [
          "Difficulty clearly expressing thoughts or answering questions in class.",
          "Rarely participates in discussions or asks clarifying questions.",
          "Shows hesitation, shyness or withdrawal during oral activities.",
          "Struggles to follow multi-step verbal instructions accurately.",
          "Interrupts peers or teacher frequently during lessons.",
          "Limited ability to explain ideas or contribute to group work verbally."
        ],
        hi: [
          "कक्षा में विचारों को स्पष्ट रूप से व्यक्त करने या सवालों के जवाब देने में कठिनाई।",
          "चर्चा में भाग लेने या स्पष्टीकरण सवाल पूछने में कम सक्रिय।",
          "मौखिक गतिविधियों के दौरान संकोच, शर्म या वापसी दिखाता है।",
          "बहु-चरण मौखिक निर्देशों का सटीक पालन करने में संघर्ष।",
          "पाठ के दौरान साथियों या शिक्षक को बार-बार टोकता है।",
          "समूह कार्य में विचारों को मौखिक रूप से समझाने या योगदान देने में सीमित क्षमता।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of limited expressive language, poor listening or social communication challenges.",
          "History of difficulty with emotional expression or understanding non-verbal cues.",
          "Signs of anxiety/shyness significantly impacting verbal participation in settings.",
          "No primary language disorder or hearing issue fully accounts for the communication difficulties."
        ],
        hi: [
          "अभिव्यंजक भाषा सीमित, खराब सुनना या सामाजिक संचार चुनौतियों की अभिभावक/शिक्षक रिपोर्ट।",
          "भावनात्मक अभिव्यक्ति या गैर-मौखिक संकेत समझने में कठिनाई का इतिहास।",
          "सेटिंग्स में मौखिक भागीदारी को काफी प्रभावित करने वाली चिंता/शर्म के संकेत।",
          "संचार कठिनाइयों को पूरी तरह समझाने वाला कोई प्राथमिक भाषा विकार या सुनने की समस्या नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Strong skill, 3 = Almost always / High difficulty) — Lower total score = stronger communication skills",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong communication foundation", hi: "मजबूत संचार नींव" },
          insight: {
            en: "Child demonstrates excellent expressive, receptive and social communication skills. Family encouragement and rich language exposure are highly effective — continue fostering open dialogue, active listening and confident expression to maintain this strength.",
            hi: "बच्चा उत्कृष्ट अभिव्यंजक, ग्रहणात्मक और सामाजिक संचार कौशल दिखाता है। परिवार का प्रोत्साहन और समृद्ध भाषा एक्सपोजर अत्यधिक प्रभावी हैं — खुली बातचीत, सक्रिय सुनना और आत्मविश्वासपूर्ण अभिव्यक्ति को बढ़ावा देकर इस ताकत को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor gaps, practice helpful", hi: "छोटे अंतराल, अभ्यास उपयोगी" },
          insight: {
            en: "Occasional hesitations, interruptions or mild difficulty in expression/listening. Build skills through daily practice: family conversation games, role-play scenarios, and modeling clear, respectful communication to close small gaps naturally.",
            hi: "कभी-कभी संकोच, बीच में टोकना या अभिव्यक्ति/सुनने में हल्की कठिनाई। दैनिक अभ्यास से कौशल मजबूत करें: परिवार बातचीत खेल, रोल-प्ले परिदृश्य, और स्पष्ट, सम्मानजनक संचार का मॉडल बनाकर छोटे अंतराल स्वाभाविक रूप से बंद करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Noticeable difficulties, skill-building needed", hi: "स्पष्ट कठिनाइयाँ, कौशल-निर्माण आवश्यक" },
          insight: {
            en: "Clear challenges in confidence, emotional expression or listening impacting social/academic participation. Introduce structured activities (storytelling, turn-taking games, emotion charades) and provide gentle guidance/feedback; consider school speech-language support if expressive/receptive gaps persist.",
            hi: "आत्मविश्वास, भावनात्मक अभिव्यक्ति या सुनने में स्पष्ट चुनौतियाँ जो सामाजिक/शैक्षिक भागीदारी को प्रभावित कर रही हैं। संरचित गतिविधियाँ शुरू करें (कहानी सुनाना, बारी-बारी खेल, इमोशन चार्ड्स) और हल्का मार्गदर्शन/फीडबैक दें; यदि अभिव्यंजक/ग्रहणात्मक अंतराल बने रहें तो स्कूल स्पीच-लैंग्वेज समर्थन पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant challenges, professional support recommended", hi: "महत्वपूर्ण चुनौतियाँ, पेशेवर समर्थन की सिफारिश" },
          insight: {
            en: "Severe difficulties in expression, listening, social confidence or conflict resolution affecting relationships and learning. Professional evaluation recommended (speech-language pathologist, child psychologist or developmental specialist) to assess underlying factors (language delay, social anxiety, auditory processing) and create a targeted communication skill-building plan.",
            hi: "अभिव्यक्ति, सुनने, सामाजिक आत्मविश्वास या संघर्ष समाधान में गंभीर कठिनाइयाँ जो संबंधों और सीखने को प्रभावित कर रही हैं। अंतर्निहित कारकों (भाषा विलंब, सामाजिक चिंता, श्रवण प्रसंस्करण) का मूल्यांकन करने और लक्षित संचार कौशल-निर्माण योजना बनाने के लिए स्पीच-लैंग्वेज पैथोलॉजिस्ट, बाल मनोवैज्ञानिक या विकास विशेषज्ञ द्वारा पेशेवर मूल्यांकन की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "financial-literacy",
    title: {
      en: "Financial Literacy",
      hi: "वित्तीय साक्षरता"
    },
    description: {
      en: "Basic money awareness & understanding, spending behavior & decision-making, saving habits & goal orientation, responsibility & ethical money use, and family guidance & skill development for healthy financial habits.",
      hi: "मूलभूत धन जागरूकता एवं समझ, खर्च व्यवहार एवं निर्णय-निर्माण, बचत आदतें एवं लक्ष्य अभिविन्यास, जिम्मेदारी एवं नैतिक धन उपयोग, तथा स्वस्थ वित्तीय आदतों के लिए परिवार मार्गदर्शन एवं कौशल विकास।"
    },
    questions: {
      parent: {
        en: [
          "My child understands that money is earned through work or effort.",
          "My child understands the difference between needs and wants.",
          "My child understands that money is limited.",
          "My child understands basic spending and saving concepts.",
          "My child understands that financial choices have consequences.",
          "My child spends money thoughtfully rather than impulsively.",
          "My child asks for unnecessary items frequently.",
          "My child compares options before spending.",
          "My child regrets purchases soon after buying.",
          "My child understands the value of delayed gratification.",
          "My child saves money for future use or goals.",
          "My child shows patience when saving for something they want.",
          "My child sets small financial goals.",
          "My child understands the purpose of saving.",
          "My child resists spending saved money impulsively.",
          "My child takes responsibility for their belongings.",
          "My child handles money honestly.",
          "My child understands sharing, charity or helping others.",
          "My child understands consequences of losing or misusing money.",
          "My child respects family financial boundaries.",
          "Our family discusses money in age-appropriate ways.",
          "My child receives guidance on making financial choices.",
          "My child learns from financial mistakes without shame.",
          "My child is becoming more responsible with money over time.",
          "My child is developing healthy financial habits for adulthood."
        ],
        hi: [
          "मेरा बच्चा समझता है कि पैसा मेहनत या काम से कमाया जाता है।",
          "बच्चा जरूरतों और इच्छाओं के बीच अंतर समझता है।",
          "बच्चा समझता है कि पैसा सीमित है।",
          "बच्चा बुनियादी खर्च और बचत अवधारणाओं को समझता है।",
          "बच्चा समझता है कि वित्तीय विकल्पों के परिणाम होते हैं।",
          "बच्चा आवेग में नहीं बल्कि सोच-समझकर पैसा खर्च करता है।",
          "बच्चा अनावश्यक चीजों के लिए बार-बार मांग करता है।",
          "खर्च करने से पहले विकल्पों की तुलना करता है।",
          "खरीदारी के तुरंत बाद खरीद पर पछतावा करता है।",
          "बच्चा विलंबित संतुष्टि (delayed gratification) के मूल्य को समझता है।",
          "बच्चा भविष्य के उपयोग या लक्ष्यों के लिए पैसा बचाता है।",
          "कुछ चाहिए होने पर बचत में धैर्य दिखाता है।",
          "छोटे वित्तीय लक्ष्य निर्धारित करता है।",
          "बचत के उद्देश्य को समझता है।",
          "बचाए गए पैसे को आवेग में खर्च करने से बचता है।",
          "अपनी चीजों की जिम्मेदारी लेता है।",
          "पैसे को ईमानदारी से संभालता है।",
          "साझा करना, दान या दूसरों की मदद समझता है।",
          "पैसे खोने या दुरुपयोग के परिणाम समझता है।",
          "परिवार की वित्तीय सीमाओं का सम्मान करता है।",
          "हमारा परिवार आयु-अनुसार पैसों पर चर्चा करता है।",
          "वित्तीय विकल्प बनाने पर बच्चा मार्गदर्शन प्राप्त करता है।",
          "वित्तीय गलतियों से बिना शर्म के सीखता है।",
          "समय के साथ पैसों के साथ अधिक जिम्मेदार बन रहा है।",
          "बच्चा वयस्कता के लिए स्वस्थ वित्तीय आदतें विकसित कर रहा है।"
        ]
      },
      educator: {
        en: [
          "Shows impulsivity in classroom resource use (e.g., quickly uses supplies without planning).",
          "Difficulty understanding delayed rewards or consequences in academic/group tasks.",
          "Rarely contributes thoughtfully to discussions about fairness, sharing or responsibility.",
          "Struggles with long-term project planning or saving time/materials for completion.",
          "Occasional complaints about 'not fair' resource distribution among peers.",
          "Limited grasp of cause-effect in classroom economy/reward systems."
        ],
        hi: [
          "कक्षा संसाधन उपयोग में आवेगशीलता दिखाता है (जल्दी आपूर्ति उपयोग बिना योजना के)।",
          "शैक्षिक/समूह कार्यों में विलंबित पुरस्कार या परिणाम समझने में कठिनाई।",
          "निष्पक्षता, साझा करने या जिम्मेदारी पर चर्चा में विचारशील योगदान कम।",
          "लंबी अवधि प्रोजेक्ट योजना या पूरा करने के लिए समय/सामग्री बचाने में संघर्ष।",
          "साथियों के बीच संसाधन वितरण पर 'निष्पक्ष नहीं' की कभी-कभी शिकायत।",
          "कक्षा अर्थव्यवस्था/पुरस्कार प्रणाली में कारण-प्रभाव की सीमित समझ।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of impulsive spending requests or difficulty with delayed gratification.",
          "History of limited understanding of value, scarcity or consequences in age-appropriate discussions.",
          "Signs of family financial stress or inconsistent money-related boundaries observed.",
          "No primary developmental delay or neurocognitive issue fully explains gaps in financial concepts."
        ],
        hi: [
          "आवेगी खर्च मांग या विलंबित संतुष्टि में कठिनाई की अभिभावक रिपोर्ट।",
          "आयु-अनुसार चर्चाओं में मूल्य, कमी या परिणामों की सीमित समझ का इतिहास।",
          "परिवार वित्तीय तनाव या असंगत धन-संबंधी सीमाओं के संकेत देखे गए।",
          "वित्तीय अवधारणाओं में अंतराल को पूरी तरह समझाने वाला कोई प्राथमिक विकासात्मक विलंब या न्यूरोकॉग्निटिव मुद्दा नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Strong habit, 3 = Almost always / High gap) — Lower total score = healthier financial understanding & habits",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong financial foundation", hi: "मजबूत वित्तीय नींव" },
          insight: {
            en: "Child shows excellent awareness, responsible habits and understanding of money concepts. Family discussions and modeling are highly effective — continue age-appropriate money talks, small goal-setting and real-life examples to reinforce lifelong financial intelligence.",
            hi: "बच्चा उत्कृष्ट जागरूकता, जिम्मेदार आदतें और धन अवधारणाओं की समझ दिखाता है। परिवार चर्चा और मॉडलिंग अत्यधिक प्रभावी हैं — आयु-अनुसार धन बातचीत, छोटे लक्ष्य निर्धारण और वास्तविक जीवन उदाहरणों को जारी रखकर जीवनभर वित्तीय बुद्धिमत्ता मजबूत करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Developing skills, guidance helpful", hi: "विकसित हो रहे कौशल, मार्गदर्शन उपयोगी" },
          insight: {
            en: "Emerging understanding with occasional impulsivity or gaps in concepts. Build habits gently: introduce allowance/pocket money systems, discuss needs vs wants in shopping, set small savings goals and praise thoughtful choices to accelerate development.",
            hi: "उभरती समझ के साथ कभी-कभी आवेगशीलता या अवधारणा अंतराल। आदतें हल्के ढंग से बनाएँ: भत्ता/जेब खर्च प्रणाली शुरू करें, खरीदारी में जरूरत बनाम इच्छा पर चर्चा, छोटे बचत लक्ष्य सेट करें और विचारशील विकल्पों की प्रशंसा करके विकास तेज करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Weak habits, structured learning needed", hi: "कमजोर आदतें, संरचित सीखने की आवश्यकता" },
          insight: {
            en: "Noticeable impulsivity, limited saving or poor understanding of consequences affecting responsibility. Implement structured learning: regular family money talks, visual savings jars/charts, role-play spending decisions, and link choices to real outcomes to strengthen foundational skills.",
            hi: "आवेगशीलता, सीमित बचत या परिणामों की कम समझ से जिम्मेदारी प्रभावित। संरचित सीखना लागू करें: नियमित परिवार धन चर्चा, दृश्य बचत जार/चार्ट, खर्च निर्णयों का रोल-प्ले, और विकल्पों को वास्तविक परिणामों से जोड़कर मूलभूत कौशल मजबूत करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern, targeted financial education recommended", hi: "उच्च चिंता, लक्षित वित्तीय शिक्षा की सिफारिश" },
          insight: {
            en: "Significant gaps in awareness, responsibility and impulse control around money, potentially leading to future challenges. Professional or structured guidance recommended (financial educator, child psychologist or family counselor) to assess underlying patterns (impulsivity, family modeling) and create an age-appropriate, hands-on financial literacy program.",
            hi: "धन के आसपास जागरूकता, जिम्मेदारी और आवेग नियंत्रण में महत्वपूर्ण अंतराल, जो भविष्य में चुनौतियाँ पैदा कर सकते हैं। अंतर्निहित पैटर्न (आवेगशीलता, परिवार मॉडलिंग) का मूल्यांकन करने और आयु-अनुसार, हाथों से काम करने वाली वित्तीय साक्षरता कार्यक्रम बनाने के लिए पेशेवर या संरचित मार्गदर्शन (वित्तीय शिक्षक, बाल मनोवैज्ञानिक या परिवार काउंसलर) की सिफारिश।"
          }
        }
      ]
    }
  }
];

export const CHILD_ISSUES_PART2 = [
  {
    id: "safety-security",
    title: {
      en: "Safety & Security",
      hi: "सुरक्षा और संरक्षा"
    },
    description: {
      en: "(Physical, emotional, digital and environmental safety — from a parent’s perspective)",
      hi: "(शारीरिक, भावनात्मक, डिजिटल और पर्यावरणीय सुरक्षा — माता-पिता के दृष्टिकोण से)"
    },
    questions: {
      parent: {
        en: [
          "My child understands basic safety rules at home and outside.",
          "My child knows whom to approach for help in unsafe situations.",
          "My child understands the concept of personal boundaries.",
          "My child is aware of basic online safety rules.",
          "My child can recognize unsafe situations.",
          "My child follows safety rules while traveling or playing outside.",
          "My child feels safe at home.",
          "My child feels safe at school.",
          "My child takes precautions to avoid physical harm.",
          "My child informs adults about injuries or unsafe incidents.",
          "My child feels emotionally safe expressing fears or concerns.",
          "My child trusts family members for protection and support.",
          "My child feels secure even when mistakes are made.",
          "My child does not fear punishment for speaking honestly.",
          "My child feels protected and cared for by family.",
          "My child follows rules for safe internet and device use.",
          "My child avoids sharing personal information online.",
          "My child informs adults about uncomfortable online experiences.",
          "My child is exposed to age-inappropriate online content.",
          "My child uses devices under appropriate supervision.",
          "Our family has clear safety rules and routines.",
          "We regularly talk about safety without creating fear.",
          "My child knows emergency contacts and procedures.",
          "Our family monitors risks without being overly controlling.",
          "My child feels confident that family will protect them."
        ],
        hi: [
          "मेरा बच्चा घर और बाहर बुनियादी सुरक्षा नियम समझता है।",
          "असुरक्षित स्थितियों में मदद के लिए किससे संपर्क करना है, बच्चा जानता है।",
          "व्यक्तिगत सीमाओं (personal boundaries) की अवधारणा समझता है।",
          "बुनियादी ऑनलाइन सुरक्षा नियमों से अवगत है।",
          "असुरक्षित स्थितियों को पहचान सकता है।",
          "यात्रा या बाहर खेलते समय सुरक्षा नियमों का पालन करता है।",
          "घर पर सुरक्षित महसूस करता है।",
          "स्कूल में सुरक्षित महसूस करता है।",
          "शारीरिक नुकसान से बचने के लिए सावधानियाँ बरतता है।",
          "चोट या असुरक्षित घटनाओं के बारे में वयस्कों को बताता है।",
          "डर या चिंताएँ व्यक्त करने में भावनात्मक रूप से सुरक्षित महसूस करता है।",
          "सुरक्षा और समर्थन के लिए परिवार के सदस्यों पर भरोसा करता है।",
          "गलतियाँ करने पर भी सुरक्षित महसूस करता है।",
          "ईमानदारी से बोलने के लिए दंड का डर नहीं होता।",
          "परिवार द्वारा सुरक्षित और देखभाल महसूस करता है।",
          "सुरक्षित इंटरनेट और डिवाइस उपयोग के नियमों का पालन करता है।",
          "ऑनलाइन व्यक्तिगत जानकारी साझा करने से बचता है।",
          "असहज ऑनलाइन अनुभवों के बारे में वयस्कों को बताता है।",
          "आयु-अनुपयुक्त ऑनलाइन सामग्री के संपर्क में आता है।",
          "उचित निगरानी में डिवाइस का उपयोग करता है।",
          "हमारे परिवार में स्पष्ट सुरक्षा नियम और दिनचर्या हैं।",
          "डर पैदा किए बिना हम नियमित रूप से सुरक्षा पर बात करते हैं।",
          "आपातकालीन संपर्क और प्रक्रियाओं को जानता है।",
          "हम परिवार जोखिमों की निगरानी करता है बिना अत्यधिक नियंत्रण के।",
          "बच्चा विश्वास करता है कि परिवार उनकी रक्षा करेगा।"
        ]
      },
      educator: {
        en: [
          "Child shows limited awareness of school safety rules or emergency procedures.",
          "Hesitant or unsure about reporting unsafe incidents or bullying to adults.",
          "Difficulty recognizing or respecting personal/physical boundaries in peer interactions.",
          "Reports or signs of exposure to inappropriate online content discussed in school.",
          "Visible anxiety or withdrawal in group activities or transitions.",
          "Needs frequent reminders about playground, hallway or digital device safety."
        ],
        hi: [
          "बच्चा स्कूल सुरक्षा नियमों या आपातकालीन प्रक्रियाओं की सीमित जागरूकता दिखाता है।",
          "असुरक्षित घटनाओं या धमकी की रिपोर्ट करने में संकोच या अनिश्चितता।",
          "साथी अंतर्क्रियाओं में व्यक्तिगत/शारीरिक सीमाओं को पहचानने या सम्मान करने में कठिनाई।",
          "स्कूल में चर्चित अनुचित ऑनलाइन सामग्री के संपर्क के संकेत/रिपोर्ट।",
          "समूह गतिविधियों या संक्रमण में दृश्य चिंता या वापसी।",
          "प्लेग्राउंड, हॉलवे या डिजिटल डिवाइस सुरक्षा के लिए बार-बार रिमाइंडर की जरूरत।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of frequent minor injuries, unsafe risk-taking or poor boundary recognition.",
          "History of emotional distress linked to unsafe experiences (home, school, online).",
          "Signs of anxiety, hypervigilance or avoidance behaviors related to safety concerns.",
          "No primary medical/developmental condition fully explains the safety awareness gaps."
        ],
        hi: [
          "बार-बार छोटी चोटें, असुरक्षित जोखिम लेना या खराब सीमा पहचान की अभिभावक रिपोर्ट।",
          "असुरक्षित अनुभवों (घर, स्कूल, ऑनलाइन) से जुड़े भावनात्मक संकट का इतिहास।",
          "सुरक्षा चिंताओं से संबंधित चिंता, हाइपरविजिलेंस या बचाव व्यवहार के संकेत।",
          "सुरक्षा जागरूकता अंतराल को पूरी तरह समझाने वाली कोई प्राथमिक चिकित्सकीय/विकासात्मक स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Safe & secure, 3 = Almost always / High concern) — Lower total score = stronger sense of safety and security",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong safety foundation", hi: "मजबूत सुरक्षा नींव" },
          insight: {
            en: "Child has excellent awareness, secure feelings and strong protective family systems. Continue open safety talks, consistent rules and modeling confident responses to maintain this robust foundation across physical, emotional and digital domains.",
            hi: "बच्चे में उत्कृष्ट जागरूकता, सुरक्षित भावनाएँ और मजबूत सुरक्षात्मक परिवार प्रणाली है। खुली सुरक्षा बातचीत, सुसंगत नियम और आत्मविश्वासपूर्ण प्रतिक्रियाओं का मॉडल बनाकर शारीरिक, भावनात्मक और डिजिटल क्षेत्रों में इस मजबूत नींव को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor gaps, awareness reinforcement helpful", hi: "छोटे अंतराल, जागरूकता सुदृढ़ीकरण उपयोगी" },
          insight: {
            en: "Small inconsistencies in rules, awareness or emotional security appearing. Reinforce gently: role-play safety scenarios, review emergency contacts, discuss online boundaries and increase family safety check-ins without creating fear.",
            hi: "नियमों, जागरूकता या भावनात्मक सुरक्षा में छोटी असंगतियाँ दिख रही हैं। हल्के ढंग से सुदृढ़ करें: सुरक्षा परिदृश्यों का रोल-प्ले, आपातकालीन संपर्कों की समीक्षा, ऑनलाइन सीमाओं पर चर्चा और डर पैदा किए बिना परिवार सुरक्षा चेक-इन बढ़ाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Ongoing safety concerns, structured guidance needed", hi: "लगातार सुरक्षा चिंताएँ, संरचित मार्गदर्शन आवश्यक" },
          insight: {
            en: "Noticeable gaps in awareness, behavior or emotional trust impacting sense of security. Create structured safety plan: clear family rules/posters, regular safety talks, supervised digital use, and teach assertive 'no' and help-seeking skills; monitor closely and involve school if needed.",
            hi: "जागरूकता, व्यवहार या भावनात्मक विश्वास में स्पष्ट अंतराल जो सुरक्षा भाव को प्रभावित कर रहे हैं। संरचित सुरक्षा प्लान बनाएँ: स्पष्ट परिवार नियम/पोस्टर, नियमित सुरक्षा बातचीत, निगरानी में डिजिटल उपयोग, और दृढ़ 'नहीं' तथा मदद मांगने के कौशल सिखाएँ; निकट निगरानी रखें और जरूरत पड़ने पर स्कूल को शामिल करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High risk, immediate intervention recommended", hi: "उच्च जोखिम, तत्काल हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Significant safety vulnerabilities across physical, emotional or digital domains, potentially affecting well-being and development. Immediate professional guidance strongly recommended (child psychologist, school counselor or child protection specialist) for thorough assessment, safety planning and family-based intervention to address risks and rebuild security.",
            hi: "शारीरिक, भावनात्मक या डिजिटल क्षेत्रों में महत्वपूर्ण सुरक्षा कमजोरियाँ, जो कल्याण और विकास को प्रभावित कर सकती हैं। गहन मूल्यांकन, सुरक्षा योजना और परिवार-आधारित हस्तक्षेप के लिए तत्काल पेशेवर मार्गदर्शन (बाल मनोवैज्ञानिक, स्कूल काउंसलर या बाल संरक्षण विशेषज्ञ) की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "independence-responsibility",
    title: {
      en: "Independence & Responsibility",
      hi: "स्वतंत्रता और जिम्मेदारी"
    },
    description: {
      en: "Awareness of personal responsibility, daily habits & execution, decision-making & problem-solving, emotional independence & confidence, and family support & boundaries fostering autonomy.",
      hi: "व्यक्तिगत जिम्मेदारी की जागरूकता, दैनिक आदतें एवं निष्पादन, निर्णय-निर्माण एवं समस्या-समाधान, भावनात्मक स्वतंत्रता एवं आत्मविश्वास, तथा स्वायत्तता को बढ़ावा देने वाला परिवार समर्थन एवं सीमाएँ।"
    },
    questions: {
      parent: {
        en: [
          "My child understands their basic responsibilities at home.",
          "My child understands the consequences of their actions.",
          "My child shows awareness of personal limits and abilities.",
          "My child can make simple decisions independently.",
          "My child takes ownership of personal tasks.",
          "My child completes age-appropriate chores regularly.",
          "My child manages personal belongings responsibly.",
          "My child remembers daily routines without constant reminders.",
          "My child completes tasks they start.",
          "My child follows through on commitments.",
          "My child attempts to solve problems before seeking help.",
          "My child makes thoughtful choices rather than impulsive ones.",
          "My child handles small failures without giving up.",
          "My child accepts responsibility for mistakes.",
          "My child shows initiative in learning or tasks.",
          "My child feels confident doing things on their own.",
          "My child avoids over-dependence on adults for reassurance.",
          "My child handles separation or new situations calmly.",
          "My child expresses opinions respectfully.",
          "My child manages age-appropriate risks sensibly.",
          "Our family encourages independence while providing guidance.",
          "We allow age-appropriate choices and mistakes.",
          "Expectations at home are clear and consistent.",
          "My child receives encouragement for responsible behavior.",
          "My child is gradually becoming more independent over time."
        ],
        hi: [
          "मेरा बच्चा घर की बुनियादी जिम्मेदारियों को समझता है।",
          "अपने कार्यों के परिणामों को बच्चा समझता है।",
          "व्यक्तिगत सीमाओं और क्षमताओं की जागरूकता दिखाता है।",
          "सरल निर्णय स्वतंत्र रूप से ले सकता है।",
          "व्यक्तिगत कार्यों की स्वामित्व लेता है।",
          "आयु-अनुसार घर के काम नियमित रूप से पूरा करता है।",
          "व्यक्तिगत सामान को जिम्मेदारी से संभालता है।",
          "लगातार याद दिलाए बिना दैनिक दिनचर्या याद रखता है।",
          "शुरू किए कार्यों को पूरा करता है।",
          "प्रतिबद्धताओं का पालन करता है।",
          "मदद मांगने से पहले समस्याएँ हल करने का प्रयास करता है।",
          "आवेगी की बजाय विचारशील विकल्प चुनता है।",
          "छोटी असफलताओं को बिना हार माने संभालता है।",
          "गलतियों की जिम्मेदारी स्वीकार करता है।",
          "सीखने या कार्यों में पहल दिखाता है।",
          "अकेले चीजें करने में आत्मविश्वास महसूस करता है।",
          "आश्वासन के लिए वयस्कों पर अत्यधिक निर्भरता से बचता है।",
          "अलगाव या नई स्थितियों को शांतिपूर्वक संभालता है।",
          "राय सम्मानजनक ढंग से व्यक्त करता है।",
          "आयु-अनुसार जोखिमों को समझदारी से प्रबंधित करता है।",
          "हमारा परिवार मार्गदर्शन देते हुए स्वतंत्रता को प्रोत्साहित करता है।",
          "आयु-अनुसार विकल्प और गलतियाँ करने की अनुमति देते हैं।",
          "घर की अपेक्षाएँ स्पष्ट और सुसंगत हैं।",
          "जिम्मेदार व्यवहार के लिए बच्चा प्रोत्साहन प्राप्त करता है।",
          "समय के साथ बच्चा धीरे-धीरे अधिक स्वतंत्र हो रहा है।"
        ]
      },
      educator: {
        en: [
          "Rarely takes initiative in classroom tasks or group projects without prompting.",
          "Struggles to complete assignments or chores independently in school.",
          "Shows hesitation or seeks frequent reassurance before attempting new activities.",
          "Difficulty accepting responsibility for mistakes or incomplete work.",
          "Limited participation in decision-making during group or leadership roles.",
          "Needs repeated reminders for routines, materials or transitions."
        ],
        hi: [
          "प्रॉम्प्ट के बिना कक्षा कार्यों या समूह प्रोजेक्ट में पहल कम करता है।",
          "स्कूल में असाइनमेंट या काम स्वतंत्र रूप से पूरा करने में संघर्ष।",
          "नई गतिविधियाँ करने से पहले संकोच या बार-बार आश्वासन मांगता है।",
          "गलतियों या अधूरे कार्य की जिम्मेदारी स्वीकार करने में कठिनाई।",
          "समूह या नेतृत्व भूमिकाओं में निर्णय-निर्माण में सीमित भागीदारी।",
          "दिनचर्या, सामग्री या संक्रमण के लिए बार-बार रिमाइंडर की आवश्यकता।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of excessive reliance on adults for basic tasks or decisions.",
          "History of low initiative, poor follow-through or emotional dependence in age-expected activities.",
          "Signs of limited self-efficacy or fear of failure impacting autonomy.",
          "No primary developmental or neurodevelopmental condition fully explains the delayed independence."
        ],
        hi: [
          "बुनियादी कार्यों या निर्णयों के लिए वयस्कों पर अत्यधिक निर्भरता की अभिभावक/शिक्षक रिपोर्ट।",
          "आयु-अनुसार गतिविधियों में कम पहल, खराब फॉलो-थ्रू या भावनात्मक निर्भरता का इतिहास।",
          "स्व-प्रभावकारिता की कमी या असफलता के डर से स्वायत्तता प्रभावित होने के संकेत।",
          "विलंबित स्वतंत्रता को पूरी तरह समझाने वाली कोई प्राथमिक विकासात्मक या न्यूरो-विकासात्मक स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Age-appropriate independence, 3 = Almost always / High concern) — Lower total score = healthier independence & responsibility",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy independence", hi: "स्वस्थ स्वतंत्रता" },
          insight: {
            en: "Child demonstrates strong self-reliance, responsibility and emotional autonomy. Family encouragement of choice and ownership is working well — continue providing age-appropriate responsibilities, positive reinforcement and safe space for mistakes to sustain this healthy development.",
            hi: "बच्चा मजबूत आत्म-निर्भरता, जिम्मेदारी और भावनात्मक स्वायत्तता दिखाता है। विकल्प और स्वामित्व को प्रोत्साहित करने वाला परिवार अच्छा काम कर रहा है — आयु-अनुसार जिम्मेदारियाँ देते रहें, सकारात्मक सुदृढ़ीकरण और गलतियों के लिए सुरक्षित स्थान बनाकर इस स्वस्थ विकास को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Developing autonomy, guidance helpful", hi: "विकसित हो रही स्वायत्तता, मार्गदर्शन उपयोगी" },
          insight: {
            en: "Emerging independence with occasional reliance or hesitation. Support growth gently: assign small daily chores, encourage problem-solving before helping, celebrate effort and independence, and model calm responses to mistakes to build confidence.",
            hi: "कभी-कभी निर्भरता या संकोच के साथ उभरती स्वतंत्रता। विकास को हल्के ढंग से समर्थन दें: छोटे दैनिक काम सौंपें, मदद से पहले समस्या-समाधान को प्रोत्साहित करें, प्रयास और स्वतंत्रता का जश्न मनाएँ, और गलतियों पर शांत प्रतिक्रिया का मॉडल बनाकर आत्मविश्वास बढ़ाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Delayed independence, structured support needed", hi: "विलंबित स्वतंत्रता, संरचित समर्थन आवश्यक" },
          insight: {
            en: "Noticeable dependence or avoidance of responsibility impacting daily functioning and confidence. Implement structured supports: visual chore charts, step-by-step task breakdowns, consistent routines, and gradual fading of adult help; praise initiative and link choices to natural consequences.",
            hi: "दैनिक कार्य और आत्मविश्वास को प्रभावित करने वाली स्पष्ट निर्भरता या जिम्मेदारी से बचाव। संरचित समर्थन लागू करें: दृश्य काम चार्ट, चरणबद्ध कार्य विभाजन, सुसंगत दिनचर्या, और वयस्क मदद का धीरे-धीरे कम होना; पहल की प्रशंसा करें और विकल्पों को प्राकृतिक परिणामों से जोड़ें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High dependency, intervention recommended", hi: "उच्च निर्भरता, हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Significant delays in independence and responsibility across home, school and emotional domains, likely affecting self-efficacy and future readiness. Professional evaluation recommended (child psychologist, occupational therapist or family counselor) to assess underlying factors (executive function, anxiety, parenting dynamics) and design a tailored autonomy-building plan with gradual, supported steps.",
            hi: "घर, स्कूल और भावनात्मक क्षेत्रों में स्वतंत्रता और जिम्मेदारी में महत्वपूर्ण विलंब, जो आत्म-प्रभावकारिता और भविष्य की तत्परता को प्रभावित कर रहा है। अंतर्निहित कारकों (कार्यकारी कार्य, चिंता, पेरेंटिंग गतिशीलता) का मूल्यांकन करने और क्रमिक, समर्थित चरणों वाली व्यक्तिगत स्वायत्तता-निर्माण योजना बनाने के लिए बाल मनोवैज्ञानिक, ऑक्यूपेशनल थेरेपिस्ट या परिवार काउंसलर द्वारा पेशेवर मूल्यांकन की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "cultural-identity",
    title: {
      en: "Cultural Identity",
      hi: "सांस्कृतिक पहचान"
    },
    description: {
      en: "Sense of belonging, values, roots and respectful integration",
      hi: "संबंध की भावना, मूल्य, जड़ें और सम्मानजनक एकीकरण"
    },
    questions: {
      parent: {
        en: [
          "My child is aware of their cultural background.",
          "My child understands basic family traditions and practices.",
          "My child shows curiosity about their roots and heritage.",
          "My child understands the importance of cultural values.",
          "My child can explain aspects of their culture in simple terms.",
          "My child feels proud of their cultural background.",
          "My child feels a sense of belonging within the family culture.",
          "My child feels comfortable identifying with their cultural roots.",
          "My child does not feel ashamed of cultural practices or identity.",
          "My child feels secure balancing cultural identity with modern life.",
          "My child respects cultural differences in others.",
          "My child interacts comfortably with peers from different backgrounds.",
          "My child adapts socially without rejecting their own culture.",
          "My child experiences confusion or conflict about cultural identity.",
          "My child feels accepted in school or social environments.",
          "My child participates willingly in cultural or family traditions.",
          "My child understands cultural values such as respect and empathy.",
          "My child shows respect for elders and family norms.",
          "My child expresses cultural identity confidently.",
          "My child applies cultural values in daily behavior.",
          "Our family discusses culture openly and positively.",
          "We encourage questions and conversations about identity.",
          "Cultural practices at home feel inclusive, not forced.",
          "My child receives guidance on balancing tradition and individuality.",
          "My child feels supported in forming their own cultural identity."
        ],
        hi: [
          "मेरा बच्चा अपनी सांस्कृतिक पृष्ठभूमि से अवगत है।",
          "बच्चा बुनियादी पारिवारिक परंपराओं और प्रथाओं को समझता है।",
          "जड़ों और विरासत के प्रति उत्सुकता दिखाता है।",
          "सांस्कृतिक मूल्यों के महत्व को समझता है।",
          "अपनी संस्कृति के पहलुओं को सरल शब्दों में समझा सकता है।",
          "अपनी सांस्कृतिक पृष्ठभूमि पर गर्व महसूस करता है।",
          "पारिवारिक संस्कृति में संबंध की भावना महसूस करता है।",
          "अपनी सांस्कृतिक जड़ों से जुड़ाव में सहज महसूस करता है।",
          "सांस्कृतिक प्रथाओं या पहचान पर शर्मिंदगी नहीं महसूस करता।",
          "आधुनिक जीवन के साथ सांस्कृतिक पहचान को संतुलित करने में सुरक्षित महसूस करता है।",
          "दूसरों के सांस्कृतिक अंतरों का सम्मान करता है।",
          "विभिन्न पृष्ठभूमि के साथियों से सहज अंतर्क्रिया करता है।",
          "अपनी संस्कृति को अस्वीकार किए बिना सामाजिक रूप से ढल जाता है।",
          "सांस्कृतिक पहचान को लेकर भ्रम या संघर्ष का अनुभव करता है।",
          "स्कूल या सामाजिक वातावरण में स्वीकार्य महसूस करता है।",
          "सांस्कृतिक या पारिवारिक परंपराओं में स्वेच्छा से भाग लेता है।",
          "सम्मान और सहानुभूति जैसे सांस्कृतिक मूल्यों को समझता है।",
          "बड़ों और पारिवारिक मानदंडों का सम्मान दिखाता है।",
          "सांस्कृतिक पहचान को आत्मविश्वास से व्यक्त करता है।",
          "दैनिक व्यवहार में सांस्कृतिक मूल्यों को लागू करता है।",
          "हमारा परिवार संस्कृति पर खुलकर और सकारात्मक चर्चा करता है।",
          "पहचान पर सवाल और बातचीत को प्रोत्साहित करते हैं।",
          "घर की सांस्कृतिक प्रथाएँ समावेशी लगती हैं, जबरदस्ती नहीं।",
          "परंपरा और व्यक्तित्व के संतुलन पर मार्गदर्शन प्राप्त करता है।",
          "अपनी सांस्कृतिक पहचान बनाने में समर्थित महसूस करता है।"
        ]
      },
      educator: {
        en: [
          "Shows limited knowledge or interest in discussing family traditions or heritage in class.",
          "Difficulty articulating cultural background or values when relevant to lessons.",
          "Hesitation or discomfort when topics involve cultural diversity or identity.",
          "Occasional confusion or withdrawal during multicultural group activities.",
          "Respects diverse peers but rarely shares own cultural perspective.",
          "Adapts well to school norms but may show signs of identity conflict in discussions."
        ],
        hi: [
          "कक्षा में पारिवारिक परंपराओं या विरासत पर चर्चा में सीमित ज्ञान या रुचि दिखाता है।",
          "पाठों से संबंधित होने पर सांस्कृतिक पृष्ठभूमि या मूल्यों को व्यक्त करने में कठिनाई।",
          "सांस्कृतिक विविधता या पहचान से जुड़े विषयों पर संकोच या असहजता।",
          "बहुसांस्कृतिक समूह गतिविधियों में कभी-कभी भ्रम या वापसी।",
          "विविध साथियों का सम्मान करता है लेकिन अपनी सांस्कृतिक दृष्टि कम साझा करता है।",
          "स्कूल मानदंडों से अच्छी तरह ढल जाता है लेकिन चर्चाओं में पहचान संघर्ष के संकेत।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of confusion, shame or conflict regarding cultural identity.",
          "History of withdrawal or anxiety in multicultural or identity-related contexts.",
          "Signs of difficulty balancing heritage with peer/school expectations observed.",
          "No primary psychological condition (e.g., anxiety disorder) fully explains identity-related distress."
        ],
        hi: [
          "सांस्कृतिक पहचान को लेकर भ्रम, शर्म या संघर्ष की अभिभावक रिपोर्ट।",
          "बहुसांस्कृतिक या पहचान-संबंधी संदर्भों में वापसी या चिंता का इतिहास।",
          "विरासत को साथी/स्कूल अपेक्षाओं से संतुलित करने में कठिनाई के संकेत।",
          "पहचान-संबंधी संकट को पूरी तरह समझाने वाला कोई प्राथमिक मनोवैज्ञानिक स्थिति (जैसे चिंता विकार) नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Healthy cultural grounding, 3 = Almost always / High concern) — Lower total score = stronger, healthier cultural identity",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong cultural grounding", hi: "मजबूत सांस्कृतिक आधार" },
          insight: {
            en: "Child has a secure, proud and well-integrated sense of cultural identity. Family openness and positive modeling are highly effective — continue encouraging curiosity, respectful sharing of traditions and inclusive discussions to nurture this strong foundation.",
            hi: "बच्चे में सुरक्षित, गर्वपूर्ण और अच्छी तरह एकीकृत सांस्कृतिक पहचान है। परिवार की खुलीपन और सकारात्मक मॉडलिंग अत्यधिक प्रभावी हैं — जिज्ञासा, परंपराओं का सम्मानजनक साझा करना और समावेशी चर्चाओं को प्रोत्साहित करके इस मजबूत आधार को पोषित करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild identity confusion, dialogue helpful", hi: "हल्का पहचान भ्रम, संवाद उपयोगी" },
          insight: {
            en: "Minor uncertainty or occasional discomfort in balancing heritage and modern contexts. Strengthen grounding through gentle family dialogue: share stories of roots, celebrate traditions inclusively, and affirm child's unique identity to resolve mild confusion early.",
            hi: "विरासत और आधुनिक संदर्भों के संतुलन में छोटी अनिश्चितता या कभी-कभी असहजता। हल्की परिवार संवाद से आधार मजबूत करें: जड़ों की कहानियाँ साझा करें, परंपराओं को समावेशी ढंग से मनाएँ और बच्चे की अनूठी पहचान की पुष्टि करके हल्का भ्रम जल्दी दूर करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Ongoing identity challenges, structured support needed", hi: "लगातार पहचान चुनौतियाँ, संरचित समर्थन आवश्यक" },
          insight: {
            en: "Noticeable confusion, conflict or withdrawal related to cultural identity affecting belonging and confidence. Create structured family support: regular positive cultural activities, open identity talks, explore heritage together, and teach respectful navigation of differences; consider school counselor if peer/school integration issues persist.",
            hi: "सांस्कृतिक पहचान से जुड़ा स्पष्ट भ्रम, संघर्ष या वापसी जो संबंध और आत्मविश्वास को प्रभावित कर रहा है। संरचित परिवार समर्थन बनाएँ: नियमित सकारात्मक सांस्कृतिक गतिविधियाँ, खुली पहचान बातचीत, साथ में विरासत खोजें, और अंतरों के सम्मानजनक नेविगेशन सिखाएँ; यदि साथी/स्कूल एकीकरण मुद्दे बने रहें तो स्कूल काउंसलर पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant conflict, professional or community guidance recommended", hi: "महत्वपूर्ण संघर्ष, पेशेवर या सामुदायिक मार्गदर्शन की सिफारिश" },
          insight: {
            en: "Severe identity conflict, shame, alienation or rejection impacting emotional well-being and social integration. Professional or community support strongly recommended (child psychologist, cultural counselor or family therapist) for in-depth exploration of roots, family dynamics and identity formation, along with strategies to build secure, integrated cultural pride.",
            hi: "गंभीर पहचान संघर्ष, शर्म, अलगाव या अस्वीकृति जो भावनात्मक कल्याण और सामाजिक एकीकरण को प्रभावित कर रहा है। जड़ों, परिवार गतिशीलता और पहचान निर्माण की गहन खोज और सुरक्षित, एकीकृत सांस्कृतिक गर्व बनाने की रणनीतियों के लिए बाल मनोवैज्ञानिक, सांस्कृतिक काउंसलर या परिवार थेरेपिस्ट द्वारा पेशेवर या सामुदायिक समर्थन की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "career-guidance",
    title: {
      en: "Career Guidance",
      hi: "करियर मार्गदर्शन"
    },
    description: {
      en: "Interests, strengths, exposure and decision-readiness",
      hi: "रुचियाँ, ताकतें, एक्सपोजर और निर्णय-तत्परता"
    },
    questions: {
      parent: {
        en: [
          "My child is aware of their interests and strengths.",
          "My child shows curiosity about different careers or professions.",
          "My child enjoys activities that reflect personal talents.",
          "My child understands that different careers require different skills.",
          "My child feels confident exploring personal interests.",
          "My child has been exposed to a variety of career options.",
          "My child asks questions about professions and work life.",
          "My child understands that success can take many forms.",
          "My child is open to non-traditional or emerging career paths.",
          "My child understands that career paths can change over time.",
          "My child feels pressured to choose a specific career.",
          "My child worries excessively about future career success.",
          "My child fears disappointing family regarding career choices.",
          "My child compares career prospects with peers.",
          "My child avoids thinking about the future due to anxiety.",
          "My child understands the importance of skill-building.",
          "My child is willing to work on improving abilities.",
          "My child sets realistic goals related to future plans.",
          "My child connects education with future opportunities.",
          "My child believes effort matters more than fixed talent.",
          "Our family encourages exploration over early fixation.",
          "We discuss careers without fear or pressure.",
          "My child feels supported in expressing career interests.",
          "Our family provides guidance without imposing choices.",
          "My child feels hopeful and motivated about the future."
        ],
        hi: [
          "मेरा बच्चा अपनी रुचियों और ताकतों से अवगत है।",
          "विभिन्न करियर या पेशों के प्रति उत्सुकता दिखाता है।",
          "व्यक्तिगत प्रतिभाओं को दर्शाने वाली गतिविधियों का आनंद लेता है।",
          "विभिन्न करियरों के लिए अलग-अलग कौशलों की आवश्यकता समझता है।",
          "व्यक्तिगत रुचियों की खोज में आत्मविश्वास महसूस करता है।",
          "विभिन्न करियर विकल्पों का एक्सपोजर प्राप्त किया है।",
          "पेशों और कार्य जीवन के बारे में सवाल पूछता है।",
          "सफलता के कई रूप हो सकते हैं, यह समझता है।",
          "गैर-पारंपरिक या उभरते करियर पथों के लिए खुला है।",
          "करियर पथ समय के साथ बदल सकते हैं, यह समझता है।",
          "विशिष्ट करियर चुनने का दबाव महसूस करता है।",
          "भविष्य के करियर सफलता को लेकर अत्यधिक चिंता करता है।",
          "करियर विकल्पों से परिवार को निराश करने का डर है।",
          "करियर संभावनाओं की साथियों से तुलना करता है।",
          "चिंता के कारण भविष्य के बारे में सोचने से बचता है।",
          "कौशल-निर्माण के महत्व को समझता है।",
          "क्षमताओं को सुधारने के लिए काम करने को तैयार है।",
          "भविष्य की योजनाओं से संबंधित यथार्थवादी लक्ष्य निर्धारित करता है।",
          "शिक्षा को भविष्य के अवसरों से जोड़ता है।",
          "प्रयास स्थिर प्रतिभा से अधिक मायने रखता है, यह मानता है।",
          "हमारा परिवार जल्दी fixation की बजाय खोज को प्रोत्साहित करता है।",
          "डर या दबाव के बिना करियर पर चर्चा करते हैं।",
          "करियर रुचियाँ व्यक्त करने में बच्चा समर्थित महसूस करता है।",
          "परिवार मार्गदर्शन देता है बिना विकल्प थोपे।",
          "भविष्य को लेकर आशावादी और प्रेरित महसूस करता है।"
        ]
      },
      educator: {
        en: [
          "Limited curiosity or questions about future professions during career talks or projects.",
          "Shows narrow view of success (e.g., only high-status jobs) in discussions.",
          "Hesitation or anxiety when exploring interests or skill-building activities.",
          "Difficulty connecting school subjects to real-world career applications.",
          "Pressure signs (worry, comparison) visible during goal-setting or future planning exercises.",
          "Rarely expresses personal interests or strengths in class presentations."
        ],
        hi: [
          "करियर बातचीत या प्रोजेक्ट्स के दौरान भविष्य के पेशों के प्रति सीमित उत्सुकता या सवाल।",
          "चर्चाओं में सफलता का संकीर्ण दृष्टिकोण (जैसे केवल उच्च-स्थिति वाले नौकरियाँ)।",
          "रुचियों या कौशल-निर्माण गतिविधियों की खोज में संकोच या चिंता।",
          "स्कूल विषयों को वास्तविक दुनिया करियर अनुप्रयोगों से जोड़ने में कठिनाई।",
          "लक्ष्य-निर्धारण या भविष्य योजना अभ्यासों में दबाव संकेत (चिंता, तुलना)।",
          "कक्षा प्रस्तुतियों में व्यक्तिगत रुचियाँ या ताकतें कम व्यक्त करता है।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of excessive future-related anxiety, pressure or career fixation.",
          "History of limited exposure to diverse professions or skill exploration.",
          "Signs of low self-efficacy or fear of failure impacting career openness.",
          "No primary anxiety or developmental condition fully explains the career-related distress."
        ],
        hi: [
          "अत्यधिक भविष्य-संबंधी चिंता, दबाव या करियर fixation की अभिभावक रिपोर्ट।",
          "विविध पेशों या कौशल खोज का सीमित एक्सपोजर का इतिहास।",
          "करियर खुलापन प्रभावित करने वाली कम आत्म-प्रभावकारिता या असफलता का डर।",
          "करियर-संबंधी संकट को पूरी तरह समझाने वाली कोई प्राथमिक चिंता या विकासात्मक स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Healthy career orientation, 3 = Almost always / High concern) — Lower total score = healthier career awareness & readiness",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy career orientation", hi: "स्वस्थ करियर अभिविन्यास" },
          insight: {
            en: "Child shows strong self-awareness, curiosity and balanced view of careers. Family support for exploration is excellent — continue exposing to diverse roles, discussing effort and adaptability, and encouraging interest-led activities to build confident, flexible readiness.",
            hi: "बच्चा मजबूत स्व-जागरूकता, उत्सुकता और करियरों का संतुलित दृष्टिकोण दिखाता है। खोज के लिए परिवार समर्थन उत्कृष्ट है — विविध भूमिकाओं का एक्सपोजर, प्रयास और अनुकूलन पर चर्चा, और रुचि-प्रेरित गतिविधियों को प्रोत्साहित करके आत्मविश्वासपूर्ण, लचीली तत्परता बनाएँ।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild uncertainty, exposure helpful", hi: "हल्की अनिश्चितता, एक्सपोजर उपयोगी" },
          insight: {
            en: "Emerging awareness with minor pressure or narrow views appearing. Boost readiness gently: introduce fun career stories, guest talks, interest inventories, and family discussions on multiple success paths to reduce uncertainty and broaden perspective.",
            hi: "उभरती जागरूकता के साथ छोटा दबाव या संकीर्ण दृष्टिकोण दिख रहा है। तत्परता को हल्के ढंग से बढ़ाएँ: मजेदार करियर कहानियाँ, अतिथि वार्ता, रुचि सूची, और कई सफलता पथों पर परिवार चर्चा से अनिश्चितता कम करें और दृष्टिकोण व्यापक करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "High pressure or confusion, structured guidance needed", hi: "उच्च दबाव या भ्रम, संरचित मार्गदर्शन आवश्यक" },
          insight: {
            en: "Noticeable anxiety, fixation or limited exploration impacting motivation and confidence. Implement structured guidance: regular career chats, exposure to varied professionals, skill-mapping exercises, and emphasis on effort over outcome; consider school counselor for group career activities if school-related pressure is evident.",
            hi: "प्रेरणा और आत्मविश्वास को प्रभावित करने वाली स्पष्ट चिंता, fixation या सीमित खोज। संरचित मार्गदर्शन लागू करें: नियमित करियर बातचीत, विविध पेशेवरों का एक्सपोजर, कौशल-मैपिंग अभ्यास, और परिणाम से ज्यादा प्रयास पर जोर; यदि स्कूल-संबंधी दबाव दिखे तो समूह करियर गतिविधियों के लिए स्कूल काउंसलर पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Significant distress, professional career counseling recommended", hi: "महत्वपूर्ण संकट, पेशेवर करियर काउंसलिंग की सिफारिश" },
          insight: {
            en: "Severe pressure, fear of failure or identity conflict around future careers affecting emotional well-being and academic engagement. Professional career counseling strongly recommended (child psychologist, career counselor or educational therapist) for in-depth exploration of interests, strengths, family expectations and anxiety management, leading to a personalized, low-pressure career readiness plan.",
            hi: "भविष्य के करियरों को लेकर गंभीर दबाव, असफलता का डर या पहचान संघर्ष जो भावनात्मक कल्याण और शैक्षिक जुड़ाव को प्रभावित कर रहा है। रुचियों, ताकतों, परिवार अपेक्षाओं और चिंता प्रबंधन की गहन खोज के लिए बाल मनोवैज्ञानिक, करियर काउंसलर या शैक्षिक थेरेपिस्ट द्वारा पेशेवर करियर काउंसलिंग की मजबूत सिफारिश, जिससे कम दबाव वाली व्यक्तिगत करियर तत्परता योजना बने।"
          }
        }
      ]
    }
  },
  {
    id: "time-for-self-care",
    title: {
      en: "Time for Self-Care",
      hi: "स्व-देखभाल के लिए समय"
    },
    description: {
      en: "Rest, relaxation, reflection and personal space for children",
      hi: "बच्चों के लिए आराम, विश्राम, चिंतन और व्यक्तिगत स्थान"
    },
    questions: {
      parent: {
        en: [
          "My child understands the importance of taking breaks.",
          "My child recognizes when they feel tired or overwhelmed.",
          "My child understands that rest is part of staying healthy.",
          "My child can identify activities that help them relax.",
          "My child feels allowed to take time for themselves.",
          "My child has time in the day for rest or relaxation.",
          "My child’s schedule allows for unstructured free time.",
          "My child is not overscheduled with classes or activities.",
          "My child gets time away from screens to relax.",
          "My child balances study, play and rest.",
          "My child uses healthy activities to cope with stress.",
          "My child relaxes without guilt or anxiety.",
          "My child can calm down after a stressful day.",
          "My child shows emotional recovery after setbacks.",
          "My child enjoys moments of quiet or reflection.",
          "My child rests adequately when tired.",
          "My child takes breaks during long study or activity periods.",
          "My child listens to body signals for rest.",
          "My child shows signs of exhaustion or burnout.",
          "My child has enough energy for daily activities.",
          "Our family respects the child’s need for rest.",
          "We do not label rest as laziness.",
          "Our family encourages balance, not constant productivity.",
          "My child feels safe asking for breaks.",
          "My child is learning lifelong self-care habits."
        ],
        hi: [
          "मेरा बच्चा ब्रेक लेने के महत्व को समझता है।",
          "थकान या अभिभूत महसूस होने पर बच्चा पहचानता है।",
          "आराम स्वस्थ रहने का हिस्सा है, यह बच्चा समझता है।",
          "आराम करने में मदद करने वाली गतिविधियाँ पहचान सकता है।",
          "खुद के लिए समय लेने की अनुमति महसूस करता है।",
          "दिन में आराम या विश्राम के लिए समय होता है।",
          "शेड्यूल में असंरचित फ्री टाइम की जगह है।",
          "क्लास या गतिविधियों से ओवरशेड्यूल नहीं है।",
          "रिलैक्स करने के लिए स्क्रीन से दूर समय मिलता है।",
          "पढ़ाई, खेल और आराम के बीच संतुलन बनाता है।",
          "तनाव से निपटने के लिए स्वस्थ गतिविधियाँ उपयोग करता है।",
          "अपराधबोध या चिंता के बिना रिलैक्स करता है।",
          "तनावपूर्ण दिन के बाद शांत हो सकता है।",
          "असफलताओं के बाद भावनात्मक रिकवरी दिखाता है।",
          "शांत या चिंतन के क्षणों का आनंद लेता है।",
          "थकान पर पर्याप्त आराम करता है।",
          "लंबे पढ़ाई या गतिविधि अवधि में ब्रेक लेता है।",
          "शरीर के आराम संकेतों को सुनता है।",
          "थकान या बर्नआउट के संकेत दिखाता है।",
          "दैनिक गतिविधियों के लिए पर्याप्त ऊर्जा रहती है।",
          "हमारा परिवार बच्चे की आराम की आवश्यकता का सम्मान करता है।",
          "आराम को आलस्य नहीं कहते।",
          "निरंतर उत्पादकता की बजाय संतुलन को प्रोत्साहित करते हैं।",
          "ब्रेक मांगने में बच्चा सुरक्षित महसूस करता है।",
          "बच्चा जीवनभर की स्व-देखभाल आदतें सीख रहा है।"
        ]
      },
      educator: {
        en: [
          "Shows signs of fatigue, low energy or disengagement during school day.",
          "Rarely takes natural breaks or appears overscheduled/overstimulated.",
          "Difficulty sustaining focus in longer lessons or activities.",
          "Visible irritability, withdrawal or emotional exhaustion after high-demand periods.",
          "Limited participation in unstructured play or downtime activities.",
          "Reports or signs of guilt/anxiety when taking rest during school breaks."
        ],
        hi: [
          "स्कूल के दिन में थकान, कम ऊर्जा या उदासीनता के संकेत।",
          "प्राकृतिक ब्रेक कम लेता है या ओवरशेड्यूल/ओवरस्टिमुलेटेड दिखता है।",
          "लंबे पाठों या गतिविधियों में फोकस बनाए रखने में कठिनाई।",
          "उच्च-मांग अवधियों के बाद चिड़चिड़ापन, वापसी या भावनात्मक थकान।",
          "असंरचित खेल या डाउनटाइम गतिविधियों में सीमित भागीदारी।",
          "स्कूल ब्रेक में आराम लेने पर अपराधबोध/चिंता की रिपोर्ट या संकेत।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of chronic overscheduling, inadequate rest or burnout signs.",
          "History of fatigue, mood changes or reduced resilience linked to lack of downtime.",
          "Signs of physical/emotional exhaustion or poor stress recovery observed.",
          "No primary medical condition (e.g., untreated anemia, thyroid) fully explains low energy/rest gaps."
        ],
        hi: [
          "क्रॉनिक ओवरशेड्यूलिंग, अपर्याप्त आराम या बर्नआउट संकेतों की अभिभावक रिपोर्ट।",
          "डाउनटाइम की कमी से जुड़ी थकान, मूड परिवर्तन या कम लचीलापन का इतिहास।",
          "शारीरिक/भावनात्मक थकान या खराब तनाव रिकवरी के संकेत।",
          "कम ऊर्जा/आराम अंतराल को पूरी तरह समझाने वाली कोई प्राथमिक चिकित्सकीय स्थिति (जैसे अनुपचारित एनीमिया, थायरॉइड) नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Never / Healthy self-care balance, 3 = Almost always / High gap) — Lower total score = healthier self-care habits",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy self-care foundation", hi: "स्वस्थ स्व-देखभाल नींव" },
          insight: {
            en: "Child has excellent awareness of rest needs, balanced routine and strong emotional/physical recharge. Family respect for downtime is protective — continue modeling balance, encouraging self-listening and unstructured play to sustain lifelong healthy habits.",
            hi: "बच्चे में आराम आवश्यकताओं की उत्कृष्ट जागरूकता, संतुलित दिनचर्या और मजबूत भावनात्मक/शारीरिक रिचार्ज है। डाउनटाइम का परिवार सम्मान सुरक्षात्मक है — संतुलन का मॉडल बनाए रखें, आत्म-सुनने और असंरचित खेल को प्रोत्साहित करके जीवनभर स्वस्थ आदतें बनाएँ।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor imbalance, routine adjustment helpful", hi: "छोटा असंतुलन, दिनचर्या समायोजन उपयोगी" },
          insight: {
            en: "Small gaps in rest, unstructured time or guilt around downtime appearing. Adjust gently: build daily quiet moments, reduce overscheduling, teach simple recharge activities (breathing, stretching) and affirm rest as essential to prevent minor issues from growing.",
            hi: "आराम, असंरचित समय या डाउनटाइम पर अपराधबोध में छोटे अंतराल दिख रहे हैं। हल्के ढंग से समायोजित करें: दैनिक शांत क्षण बनाएँ, ओवरशेड्यूलिंग कम करें, सरल रिचार्ज गतिविधियाँ (साँस, स्ट्रेचिंग) सिखाएँ और आराम को आवश्यक बताकर छोटी समस्याएँ बढ़ने से रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Chronic overload, structured changes needed", hi: "क्रॉनिक ओवरलोड, संरचित परिवर्तन आवश्यक" },
          insight: {
            en: "Noticeable overload signs affecting energy, mood and recovery, likely from packed schedules. Create structured self-care plan: fixed rest slots, screen-free evenings, no extracurricular stacking, and teach body-signal listening; monitor burnout risk and involve school if academic load contributes.",
            hi: "ऊर्जा, मूड और रिकवरी को प्रभावित करने वाले स्पष्ट ओवरलोड संकेत, संभवतः भरे शेड्यूल से। संरचित स्व-देखभाल प्लान बनाएँ: निश्चित आराम स्लॉट, स्क्रीन-मुक्त शामें, कोई अतिरिक्त गतिविधि स्टैकिंग नहीं, और शरीर संकेत सुनना सिखाएँ; बर्नआउट जोखिम की निगरानी करें और यदि शैक्षिक बोझ योगदान दे तो स्कूल को शामिल करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Burnout risk, immediate intervention recommended", hi: "बर्नआउट जोखिम, तत्काल हस्तक्षेप की सिफारिश" },
          insight: {
            en: "Severe overload, exhaustion or emotional/physical depletion impacting well-being and development. Immediate intervention strongly recommended (child psychologist, pediatrician or family counselor) for assessment of stress sources, structured rest recovery plan, schedule reduction, and family coaching on balance to prevent long-term burnout.",
            hi: "गंभीर ओवरलोड, थकान या भावनात्मक/शारीरिक क्षय जो कल्याण और विकास को प्रभावित कर रहा है। तनाव स्रोतों के मूल्यांकन, संरचित आराम रिकवरी प्लान, शेड्यूल कम करने और संतुलन पर परिवार कोचिंग के लिए बाल मनोवैज्ञानिक, बाल रोग विशेषज्ञ या परिवार काउंसलर द्वारा तत्काल हस्तक्षेप की मजबूत सिफारिश ताकि लंबे समय का बर्नआउट रोका जा सके।"
          }
        }
      ]
    }
  },
  {
    id: "language-skills",
    title: {
      en: "Language Skills",
      hi: "भाषा कौशल"
    },
    description: {
      en: "Listening, speaking, reading, writing & expressive confidence across home + school languages",
      hi: "सुनना, बोलना, पढ़ना, लिखना और घर + स्कूल भाषाओं में अभिव्यंजक आत्मविश्वास"
    },
    questions: {
      parent: {
        en: [
          "My child is exposed to meaningful conversations at home.",
          "My child hears complete sentences, not just instructions.",
          "My child is exposed to more than one language in a positive way.",
          "My child has access to books, stories or spoken content.",
          "Family members actively talk with the child, not only to the child.",
          "My child understands age-appropriate instructions.",
          "My child can follow multi-step directions.",
          "My child understands stories or explanations.",
          "My child asks for clarification when confused.",
          "My child struggles to understand spoken language.",
          "My child expresses ideas clearly using words.",
          "My child uses age-appropriate vocabulary.",
          "My child forms complete sentences while speaking.",
          "My child hesitates, stammers or avoids speaking.",
          "My child is confident speaking in front of others.",
          "My child shows interest in reading or books.",
          "My child recognizes letters, sounds or words (age-appropriate).",
          "My child can write or spell at an expected level.",
          "My child struggles with reading comprehension.",
          "My child avoids reading or writing tasks.",
          "My child feels confident expressing feelings with words.",
          "My child becomes frustrated when trying to explain something.",
          "My child avoids conversations due to language difficulty.",
          "Language challenges affect my child’s academic performance.",
          "My child is comfortable switching between home and school language."
        ],
        hi: [
          "मेरा बच्चा घर पर अर्थपूर्ण बातचीत के संपर्क में रहता है।",
          "बच्चा केवल निर्देश नहीं, बल्कि पूर्ण वाक्य सुनता है।",
          "बच्चा एक से अधिक भाषा के सकारात्मक संपर्क में है।",
          "बच्चे को किताबें, कहानियाँ या बोली गई सामग्री उपलब्ध है।",
          "परिवार के सदस्य बच्चे से सक्रिय रूप से बात करते हैं, केवल बच्चे को निर्देश नहीं देते।",
          "बच्चा आयु-अनुसार निर्देश समझता है।",
          "बहु-चरण निर्देशों का पालन कर सकता है।",
          "कहानियाँ या स्पष्टीकरण समझता है।",
          "भ्रम होने पर स्पष्टीकरण मांगता है।",
          "बोली गई भाषा समझने में संघर्ष करता है।",
          "विचारों को शब्दों में स्पष्ट रूप से व्यक्त करता है।",
          "आयु-अनुसार शब्दावली का उपयोग करता है।",
          "बोलते समय पूर्ण वाक्य बनाता है।",
          "संकोच, हकलाहट या बोलने से बचता है।",
          "दूसरों के सामने बोलने में आत्मविश्वास महसूस करता है।",
          "पढ़ने या किताबों में रुचि दिखाता है।",
          "अक्षर, ध्वनियाँ या शब्द (आयु-अनुसार) पहचानता है।",
          "अपेक्षित स्तर पर लिख या स्पेल कर सकता है।",
          "पढ़ने की समझ में संघर्ष करता है।",
          "पढ़ने या लिखने के कार्यों से बचता है।",
          "शब्दों से भावनाएँ व्यक्त करने में आत्मविश्वास महसूस करता है।",
          "कुछ समझाने की कोशिश में निराश हो जाता है।",
          "भाषा कठिनाई के कारण बातचीत से बचता है।",
          "भाषा चुनौतियाँ शैक्षिक प्रदर्शन को प्रभावित करती हैं।",
          "घर और स्कूल भाषा के बीच स्विच करने में सहज महसूस करता है।"
        ]
      },
      educator: {
        en: [
          "Difficulty following classroom instructions or multi-step directions.",
          "Limited verbal participation in discussions or answering questions.",
          "Struggles with age-appropriate vocabulary or sentence formation in spoken/written work.",
          "Hesitation, limited expression or avoidance of speaking in group settings.",
          "Challenges comprehending stories, explanations or peer conversations.",
          "Signs of frustration or withdrawal during language-heavy activities (reading aloud, writing)."
        ],
        hi: [
          "कक्षा निर्देशों या बहु-चरण दिशाओं का पालन करने में कठिनाई।",
          "चर्चा में मौखिक भागीदारी या सवालों के जवाब देने में सीमित।",
          "बोले/लिखे कार्य में आयु-अनुसार शब्दावली या वाक्य निर्माण में संघर्ष।",
          "समूह सेटिंग में संकोच, सीमित अभिव्यक्ति या बोलने से बचाव।",
          "कहानियाँ, स्पष्टीकरण या साथी बातचीत समझने में चुनौतियाँ।",
          "भाषा-भारी गतिविधियों (जोर से पढ़ना, लिखना) में निराशा या वापसी के संकेत।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of delayed language milestones, limited expression or comprehension difficulties.",
          "History of reduced language exposure, bilingual challenges or expressive hesitancy.",
          "Signs of frustration, low confidence or social withdrawal linked to language use.",
          "No primary hearing, neurological or developmental disorder fully explains the language gaps."
        ],
        hi: [
          "भाषा मील के पत्थरों में विलंब, सीमित अभिव्यक्ति या समझ कठिनाइयों की अभिभावक/शिक्षक रिपोर्ट।",
          "कम भाषा एक्सपोजर, द्विभाषी चुनौतियों या अभिव्यंजक संकोच का इतिहास।",
          "भाषा उपयोग से जुड़ी निराशा, कम आत्मविश्वास या सामाजिक वापसी के संकेत।",
          "भाषा अंतराल को पूरी तरह समझाने वाला कोई प्राथमिक सुनने, न्यूरोलॉजिकल या विकासात्मक विकार नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Age-appropriate / Strong, 3 = Significant difficulty) — Lower total score = stronger language foundation",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong language foundation", hi: "मजबूत भाषा आधार" },
          insight: {
            en: "Child demonstrates excellent listening, speaking, reading/writing readiness and expressive confidence. Rich language environment and family support are highly effective — continue meaningful conversations, story exposure, bilingual positivity and reading aloud to nurture this strong foundation.",
            hi: "बच्चा उत्कृष्ट सुनना, बोलना, पढ़ना/लिखना तत्परता और अभिव्यंजक आत्मविश्वास दिखाता है। समृद्ध भाषा वातावरण और परिवार समर्थन अत्यधिक प्रभावी हैं — अर्थपूर्ण बातचीत, कहानी एक्सपोजर, द्विभाषी सकारात्मकता और जोर से पढ़ना जारी रखकर इस मजबूत आधार को पोषित करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor gaps, enrichment recommended", hi: "छोटे अंतराल, संवर्धन की सिफारिश" },
          insight: {
            en: "Minor limitations in exposure, expression or comprehension beginning to show. Boost development gently: increase interactive reading/storytelling, encourage question-asking, model complete sentences and positive bilingual switching to close small gaps early.",
            hi: "एक्सपोजर, अभिव्यक्ति या समझ में छोटी सीमाएँ दिखने लगी हैं। विकास को हल्के ढंग से बढ़ाएँ: इंटरैक्टिव पढ़ना/कहानी सुनाना बढ़ाएँ, सवाल पूछने को प्रोत्साहित करें, पूर्ण वाक्य मॉडल करें और सकारात्मक द्विभाषी स्विचिंग से छोटे अंतराल जल्दी बंद करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern, targeted support needed", hi: "मध्यम चिंता, लक्षित समर्थन आवश्यक" },
          insight: {
            en: "Noticeable challenges in one or more areas (listening, speaking, literacy) affecting confidence and academic participation. Introduce targeted enrichment: daily shared reading, language games, speech practice, and home-school coordination; consider speech-language screening if gaps persist or cause frustration.",
            hi: "एक या अधिक क्षेत्रों (सुनना, बोलना, साक्षरता) में स्पष्ट चुनौतियाँ जो आत्मविश्वास और शैक्षिक भागीदारी को प्रभावित कर रही हैं। लक्षित संवर्धन शुरू करें: दैनिक साझा पढ़ना, भाषा खेल, भाषण अभ्यास, और घर-स्कूल समन्वय; यदि अंतराल बने रहें या निराशा पैदा करें तो स्पीच-लैंग्वेज स्क्रीनिंग पर विचार करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern, professional evaluation advised", hi: "उच्च चिंता, पेशेवर मूल्यांकन की सलाह" },
          insight: {
            en: "Significant delays or difficulties across listening, speaking, reading/writing impacting social, emotional and academic development. Professional evaluation strongly recommended (speech-language pathologist or developmental pediatrician) for comprehensive assessment of language exposure, bilingual factors, hearing and underlying needs, followed by a tailored intervention plan.",
            hi: "सुनने, बोलने, पढ़ने/लिखने में महत्वपूर्ण विलंब या कठिनाइयाँ जो सामाजिक, भावनात्मक और शैक्षिक विकास को प्रभावित कर रही हैं। भाषा एक्सपोजर, द्विभाषी कारकों, सुनने और अंतर्निहित आवश्यकताओं के व्यापक मूल्यांकन के लिए स्पीच-लैंग्वेज पैथोलॉजिस्ट या विकासात्मक बाल रोग विशेषज्ञ द्वारा पेशेवर मूल्यांकन की मजबूत सिफारिश, उसके बाद व्यक्तिगत हस्तक्षेप योजना।"
          }
        }
      ]
    }
  },
  {
    id: "academic-support",
    title: {
      en: "Academic Support",
      hi: "शैक्षिक समर्थन"
    },
    description: {
      en: "Home learning environment, guidance, resources & emotional backing",
      hi: "घरेलू सीखने का वातावरण, मार्गदर्शन, संसाधन और भावनात्मक समर्थन"
    },
    questions: {
      parent: {
        en: [
          "My child has a quiet, distraction-free place to study.",
          "Study time at home is predictable and consistent.",
          "My child has access to basic learning resources (books, internet, stationery).",
          "The home environment supports focus during study hours.",
          "My child often studies in chaotic or distracting surroundings.",
          "I am aware of what my child is learning at school.",
          "I help my child plan study tasks or exam preparation.",
          "I can explain concepts or guide my child to the right help.",
          "I regularly communicate with teachers or school.",
          "My child feels unsupported when facing academic difficulties.",
          "My child feels safe asking for academic help.",
          "Mistakes are treated as learning opportunities at home.",
          "Academic discussions often turn into stress or conflict.",
          "My child fears disappointing parents over marks.",
          "My child feels encouraged even when performance is low.",
          "My child’s learning style is understood at home.",
          "Academic expectations match my child’s ability level.",
          "My child struggles due to unrealistic expectations.",
          "Extra support is provided when needed (tutor, mentor, tools).",
          "My child’s non-academic strengths are also valued.",
          "Homework, tests and deadlines are regularly monitored.",
          "My child takes responsibility for academic tasks.",
          "Academic routines break down frequently.",
          "Feedback from school is acted upon at home.",
          "My child lacks structure or follow-up for schoolwork."
        ],
        hi: [
          "मेरा बच्चा पढ़ाई के लिए शांत, distraction-मुक्त जगह रखता है।",
          "घर पर पढ़ाई का समय पूर्वानुमानित और सुसंगत है।",
          "बच्चे को बुनियादी सीखने के संसाधन (किताबें, इंटरनेट, स्टेशनरी) उपलब्ध हैं।",
          "घर का वातावरण पढ़ाई के घंटों में फोकस का समर्थन करता है।",
          "बच्चा अक्सर अराजक या distracting परिवेश में पढ़ता है।",
          "मैं जानता हूँ कि बच्चा स्कूल में क्या सीख रहा है।",
          "मैं बच्चे को पढ़ाई कार्यों या परीक्षा तैयारी की योजना बनाने में मदद करता हूँ।",
          "मैं अवधारणाएँ समझा सकता हूँ या बच्चे को सही मदद तक पहुँचा सकता हूँ।",
          "मैं नियमित रूप से शिक्षकों या स्कूल से संवाद करता हूँ।",
          "शैक्षिक कठिनाइयों का सामना करने पर बच्चा असमर्थित महसूस करता है।",
          "शैक्षिक मदद मांगने में बच्चा सुरक्षित महसूस करता है।",
          "घर पर गलतियों को सीखने के अवसर के रूप में लिया जाता है।",
          "शैक्षिक चर्चाएँ अक्सर तनाव या विवाद में बदल जाती हैं।",
          "अंकों को लेकर माता-पिता को निराश करने का डर बच्चे को है।",
          "प्रदर्शन कम होने पर भी बच्चा प्रोत्साहित महसूस करता है।",
          "घर पर बच्चे की सीखने की शैली समझी जाती है।",
          "शैक्षिक अपेक्षाएँ बच्चे की क्षमता स्तर से मेल खाती हैं।",
          "अवास्तविक अपेक्षाओं के कारण बच्चा संघर्ष करता है।",
          "जरूरत पड़ने पर अतिरिक्त समर्थन दिया जाता है (ट्यूटर, मेंटर, टूल्स)।",
          "बच्चे की गैर-शैक्षिक ताकतों को भी महत्व दिया जाता है।",
          "होमवर्क, टेस्ट और डेडलाइन की नियमित निगरानी होती है।",
          "बच्चा शैक्षिक कार्यों की जिम्मेदारी लेता है।",
          "शैक्षिक दिनचर्या बार-बार टूट जाती है।",
          "स्कूल से फीडबैक पर घर में कार्रवाई होती है।",
          "स्कूलवर्क के लिए बच्चे के पास संरचना या फॉलो-अप की कमी है।"
        ]
      },
      educator: {
        en: [
          "Child frequently lacks required materials or preparation for classwork/homework.",
          "Limited parental follow-up visible in homework completion or feedback response.",
          "Signs of home environment stress (e.g., rushed work, low motivation) affecting school performance.",
          "Difficulty accessing resources or support when facing academic challenges.",
          "Inconsistent routines or structure impacting sustained focus in class.",
          "Emotional signs (anxiety, fear of disappointment) linked to parental expectations."
        ],
        hi: [
          "बच्चा अक्सर कक्षा कार्य/होमवर्क के लिए आवश्यक सामग्री या तैयारी की कमी रखता है।",
          "होमवर्क पूरा होने या फीडबैक प्रतिक्रिया में सीमित अभिभावक फॉलो-अप दिखाई देता है।",
          "घरेलू वातावरण तनाव के संकेत (जल्दबाजी में काम, कम प्रेरणा) स्कूल प्रदर्शन को प्रभावित करते हैं।",
          "शैक्षिक चुनौतियों का सामना करने पर संसाधनों या समर्थन तक पहुँचने में कठिनाई।",
          "असंगत दिनचर्या या संरचना से कक्षा में निरंतर फोकस प्रभावित।",
          "अभिभावक अपेक्षाओं से जुड़ी भावनात्मक संकेत (चिंता, निराशा का डर)।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of inconsistent home support, unrealistic expectations or resource gaps.",
          "History of academic stress, low motivation or emotional impact from home environment.",
          "Signs of mismatched learning needs or over-pressure affecting well-being.",
          "No primary learning disability or untreated condition fully explains support-related challenges."
        ],
        hi: [
          "असंगत घरेलू समर्थन, अवास्तविक अपेक्षाएँ या संसाधन अंतराल की अभिभावक रिपोर्ट।",
          "घरेलू वातावरण से शैक्षिक तनाव, कम प्रेरणा या भावनात्मक प्रभाव का इतिहास।",
          "सीखने की आवश्यकताओं का mismatch या अत्यधिक दबाव से कल्याण प्रभावित होने के संकेत।",
          "समर्थन-संबंधी चुनौतियों को पूरी तरह समझाने वाली कोई प्राथमिक सीखने की अक्षमता या अनुपचारित स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Strong / Well-supported, 3 = Significant lack of support) — Lower total score = healthier academic support system",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong academic support", hi: "मजबूत शैक्षिक समर्थन" },
          insight: {
            en: "Excellent home environment, guidance and emotional backing. Family-school alignment is strong — continue consistent routines, open communication with teachers, celebrating effort and providing resources to maintain this robust support system.",
            hi: "उत्कृष्ट घरेलू वातावरण, मार्गदर्शन और भावनात्मक समर्थन। परिवार-स्कूल संरेखण मजबूत है — सुसंगत दिनचर्या, शिक्षकों से खुला संवाद, प्रयास का जश्न और संसाधन प्रदान करके इस मजबूत समर्थन प्रणाली को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Adequate, with scope for improvement", hi: "पर्याप्त, सुधार की गुंजाइश" },
          insight: {
            en: "Minor gaps in consistency, resources or emotional support appearing. Refine gently: set dedicated study space/time, increase teacher communication, emphasize effort over marks, and ensure child feels safe asking for help to strengthen overall support.",
            hi: "निरंतरता, संसाधनों या भावनात्मक समर्थन में छोटे अंतराल दिख रहे हैं। हल्के ढंग से सुधारें: समर्पित पढ़ाई स्थान/समय सेट करें, शिक्षक संवाद बढ़ाएँ, अंकों से ज्यादा प्रयास पर जोर दें, और बच्चे को मदद मांगने में सुरक्षित महसूस कराकर समग्र समर्थन मजबूत करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Gaps affecting learning outcomes", hi: "सीखने के परिणामों को प्रभावित करने वाले अंतराल" },
          insight: {
            en: "Noticeable inconsistencies or emotional pressure impacting academic progress and confidence. Build structured improvements: create predictable routines, align expectations to child's pace/style, provide extra tools/support when needed, and reduce conflict through positive framing and team approach.",
            hi: "शैक्षिक प्रगति और आत्मविश्वास को प्रभावित करने वाली स्पष्ट असंगतियाँ या भावनात्मक दबाव। संरचित सुधार बनाएँ: पूर्वानुमानित दिनचर्या बनाएँ, अपेक्षाओं को बच्चे की गति/शैली से संरेखित करें, जरूरत पर अतिरिक्त टूल/समर्थन दें, और सकारात्मक फ्रेमिंग तथा टीम अप्रोच से विवाद कम करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High risk; intervention needed", hi: "उच्च जोखिम; हस्तक्षेप आवश्यक" },
          insight: {
            en: "Significant gaps in environment, guidance or emotional support creating high academic risk and stress. Immediate intervention recommended: consult school counselor or educational specialist for home-school alignment, realistic goal-setting, and family coaching to shift from pressure to supportive team dynamics.",
            hi: "वातावरण, मार्गदर्शन या भावनात्मक समर्थन में महत्वपूर्ण अंतराल से उच्च शैक्षिक जोखिम और तनाव। तत्काल हस्तक्षेप की सिफारिश: घर-स्कूल संरेखण, यथार्थवादी लक्ष्य-निर्धारण और परिवार कोचिंग के लिए स्कूल काउंसलर या शैक्षिक विशेषज्ञ से परामर्श लें ताकि दबाव से समर्थक टीम गतिशीलता में बदलाव आए।"
          }
        }
      ]
    }
  },
  {
    id: "bullying",
    title: {
      en: "Bullying",
      hi: "धमकाना"
    },
    description: {
      en: "Experiences, vulnerability, emotional impact & support response",
      hi: "अनुभव, संवेदनशीलता, भावनात्मक प्रभाव और समर्थन प्रतिक्रिया"
    },
    questions: {
      parent: {
        en: [
          "My child has been teased, mocked or excluded by peers.",
          "My child reports being bullied at school or online.",
          "My child witnesses bullying of others.",
          "Bullying incidents are frequent or recurring.",
          "My child avoids certain places or people due to fear.",
          "My child shows sudden mood changes.",
          "My child appears anxious, withdrawn or fearful.",
          "My child experiences unexplained anger or sadness.",
          "My child’s academic performance has declined.",
          "My child has physical complaints without clear cause.",
          "My child openly talks about school experiences.",
          "My child hides information about peers or school.",
          "My child fears retaliation if bullying is reported.",
          "My child trusts adults to handle bullying issues.",
          "My child minimizes or normalizes harmful behavior.",
          "Teachers or school authorities respond promptly.",
          "Anti-bullying policies are clearly communicated.",
          "Bullying complaints are taken seriously.",
          "Follow-up action is consistent and effective.",
          "My child feels protected by adults at school.",
          "My child has at least one trusted friend.",
          "My child knows how to seek help when bullied.",
          "My child’s self-esteem has been affected.",
          "My child avoids social situations due to fear.",
          "My child is learning assertive, safe responses."
        ],
        hi: [
          "मेरा बच्चा साथियों द्वारा चिढ़ाया, मजाक उड़ाया या बहिष्कृत किया गया है।",
          "बच्चा स्कूल या ऑनलाइन धमकाए जाने की रिपोर्ट करता है।",
          "बच्चा दूसरों के धमकाए जाने का साक्षी होता है।",
          "धमकाने की घटनाएँ बार-बार या आवर्ती होती हैं।",
          "डर के कारण कुछ जगहों या लोगों से बचता है।",
          "अचानक मूड परिवर्तन दिखाता है।",
          "चिंतित, अलग-थलग या भयभीत दिखता है।",
          "बिना स्पष्ट कारण के गुस्सा या उदासी का अनुभव करता है।",
          "शैक्षिक प्रदर्शन में गिरावट आई है।",
          "बिना स्पष्ट कारण के शारीरिक शिकायतें करता है।",
          "स्कूल अनुभवों के बारे में खुलकर बात करता है।",
          "साथियों या स्कूल की जानकारी छिपाता है।",
          "धमकाने की रिपोर्ट करने पर प्रतिशोध का डर होता है।",
          "धमकाने के मुद्दों को संभालने के लिए वयस्कों पर भरोसा करता है।",
          "हानिकारक व्यवहार को कम करके या सामान्य बताता है।",
          "शिक्षक या स्कूल प्राधिकरण तुरंत प्रतिक्रिया देते हैं।",
          "एंटी-बुलिंग नीतियाँ स्पष्ट रूप से संप्रेषित हैं।",
          "धमकाने की शिकायतों को गंभीरता से लिया जाता है।",
          "फॉलो-अप कार्रवाई सुसंगत और प्रभावी है।",
          "स्कूल में वयस्कों द्वारा सुरक्षित महसूस करता है।",
          "कम से कम एक विश्वसनीय दोस्त है।",
          "धमकाए जाने पर मदद मांगने का तरीका जानता है।",
          "आत्म-सम्मान प्रभावित हुआ है।",
          "डर के कारण सामाजिक स्थितियों से बचता है।",
          "दृढ़, सुरक्षित प्रतिक्रियाएँ सीख रहा है।"
        ]
      },
      educator: {
        en: [
          "Child shows visible signs of withdrawal, anxiety or sudden mood changes in class.",
          "Reports or observations of teasing, exclusion or relational aggression among peers.",
          "Academic decline, incomplete work or avoidance of group activities noticeable.",
          "Frequently reports feeling unsafe, targeted or fearful in school settings.",
          "Limited social engagement or avoidance of certain peers/places in school.",
          "Unexplained physical complaints (headaches, stomachaches) during school hours."
        ],
        hi: [
          "कक्षा में बच्चा वापसी, चिंता या अचानक मूड बदलाव के दृश्य संकेत दिखाता है।",
          "साथियों के बीच चिढ़ाने, बहिष्कार या संबंधपरक आक्रामकता की रिपोर्ट/अवलोकन।",
          "शैक्षिक गिरावट, अधूरा कार्य या समूह गतिविधियों से बचाव दिखाई देता है।",
          "स्कूल सेटिंग में असुरक्षित, लक्षित या भयभीत महसूस करने की बार-बार रिपोर्ट।",
          "स्कूल में कुछ साथियों/स्थानों से सीमित सामाजिक जुड़ाव या बचाव।",
          "स्कूल घंटों में बिना स्पष्टीकरण के शारीरिक शिकायतें (सिरदर्द, पेट दर्द)।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of repeated teasing, exclusion or fear-related avoidance behaviors.",
          "History of sudden mood changes, anxiety symptoms or somatic complaints linked to peer interactions.",
          "Signs of lowered self-esteem, social withdrawal or academic decline possibly due to bullying.",
          "No primary anxiety disorder, depression or medical condition fully explains the reported concerns."
        ],
        hi: [
          "बार-बार चिढ़ाने, बहिष्कार या डर-संबंधी बचाव व्यवहार की अभिभावक रिपोर्ट।",
          "साथी अंतर्क्रियाओं से जुड़े अचानक मूड बदलाव, चिंता लक्षण या शारीरिक शिकायतों का इतिहास।",
          "धमकाने से संभवतः कम आत्म-सम्मान, सामाजिक वापसी या शैक्षिक गिरावट के संकेत।",
          "रिपोर्ट की गई चिंताओं को पूरी तरह समझाने वाली कोई प्राथमिक चिंता विकार, अवसाद या चिकित्सकीय स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = No concern / well-handled, 3 = Serious or ongoing concern) — Lower total score = safer, more supportive environment",
      bands: [
        {
          range: "0–15",
          label: { en: "Safe environment, strong support", hi: "सुरक्षित वातावरण, मजबूत समर्थन" },
          insight: {
            en: "Child experiences minimal bullying with strong protective factors (trusted adults, friends, school response). Continue open communication, reinforcing help-seeking and monitoring peer dynamics to keep this safe, supportive foundation intact.",
            hi: "बच्चा न्यूनतम धमकाने का अनुभव करता है जिसमें मजबूत सुरक्षात्मक कारक (विश्वसनीय वयस्क, दोस्त, स्कूल प्रतिक्रिया) हैं। खुली बातचीत जारी रखें, मदद मांगने को मजबूत करें और साथी गतिशीलता की निगरानी करके इस सुरक्षित, समर्थक नींव को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Mild concerns; monitoring needed", hi: "हल्की चिंताएँ; निगरानी आवश्यक" },
          insight: {
            en: "Occasional mild teasing or exclusion with good coping and adult support. Increase proactive monitoring: regular check-ins, teach assertive responses, strengthen friendships, and maintain open school communication to prevent escalation.",
            hi: "अच्छे coping और वयस्क समर्थन के साथ कभी-कभी हल्का चिढ़ाना या बहिष्कार। सक्रिय निगरानी बढ़ाएँ: नियमित चेक-इन, दृढ़ प्रतिक्रियाएँ सिखाएँ, दोस्ती मजबूत करें और स्कूल से खुला संवाद बनाए रखकर वृद्धि रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Active bullying risk; intervention required", hi: "सक्रिय धमकाने का जोखिम; हस्तक्षेप आवश्यक" },
          insight: {
            en: "Repeated or noticeable bullying affecting mood, confidence and school engagement. Immediate structured intervention needed: document incidents, involve school authorities for consistent response, teach coping/resilience skills, and consider counselor support for child and family to restore safety.",
            hi: "मूड, आत्मविश्वास और स्कूल जुड़ाव को प्रभावित करने वाला बार-बार या स्पष्ट धमकाना। तत्काल संरचित हस्तक्षेप आवश्यक: घटनाओं का दस्तावेजीकरण, सुसंगत प्रतिक्रिया के लिए स्कूल प्राधिकरण शामिल करें, coping/लचीलापन कौशल सिखाएँ, और बच्चे व परिवार के लिए काउंसलर समर्थन पर विचार करके सुरक्षा बहाल करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Serious concern; immediate action advised", hi: "गंभीर चिंता; तत्काल कार्रवाई की सलाह" },
          insight: {
            en: "Severe, ongoing bullying causing significant emotional, academic and social harm. Urgent action required: report to school leadership immediately, seek professional support (child psychologist or counselor) for trauma-informed intervention, strengthen external protections, and prioritize child's safety and recovery through coordinated family-school-professional plan.",
            hi: "महत्वपूर्ण भावनात्मक, शैक्षिक और सामाजिक हानि पैदा करने वाला गंभीर, लगातार धमकाना। तत्काल कार्रवाई आवश्यक: स्कूल नेतृत्व को तुरंत रिपोर्ट करें, आघात-सूचित हस्तक्षेप के लिए पेशेवर समर्थन (बाल मनोवैज्ञानिक या काउंसलर) लें, बाहरी सुरक्षा मजबूत करें, और बच्चे की सुरक्षा व रिकवरी को परिवार-स्कूल-पेशेवर समन्वित योजना से प्राथमिकता दें।"
          }
        }
      ]
    }
  },
  {
    id: "substance-abuse",
    title: {
      en: "Substance Abuse",
      hi: "मादक द्रव्यों का दुरुपयोग"
    },
    description: {
      en: "Exposure, risk factors, early signals, family communication & safeguards",
      hi: "संपर्क, जोखिम कारक, प्रारंभिक संकेत, परिवार संवाद और सुरक्षा उपाय"
    },
    questions: {
      parent: {
        en: [
          "My child has been exposed to alcohol, tobacco or drugs.",
          "Substances are easily accessible in my child’s environment.",
          "My child has friends or peers who use substances.",
          "Media or social content normalizes substance use.",
          "My child has been offered substances directly.",
          "My child shows curiosity about substances.",
          "My child believes substance use is harmless.",
          "My child can clearly say “no” to peer pressure.",
          "My child understands the risks of substance use.",
          "My child views substance use as a way to cope.",
          "Sudden changes in friends or routines.",
          "Secrecy, lying or unusual privacy.",
          "Decline in academic or personal hygiene.",
          "Mood swings, irritability or withdrawal.",
          "Loss of interest in usual activities.",
          "Substance use is openly discussed at home.",
          "Clear family rules exist about substance use.",
          "Consequences are consistent and known.",
          "My child feels safe discussing mistakes.",
          "Substance use is avoided or responsibly modeled by adults.",
          "My child has strong self-esteem.",
          "My child has healthy coping mechanisms.",
          "My child participates in structured activities.",
          "Trusted adults are available outside the family.",
          "My child knows where to seek help if needed."
        ],
        hi: [
          "मेरा बच्चा शराब, तंबाकू या ड्रग्स के संपर्क में आया है।",
          "बच्चे के परिवेश में मादक द्रव्य आसानी से उपलब्ध हैं।",
          "बच्चे के दोस्त या साथी मादक द्रव्य का उपयोग करते हैं।",
          "मीडिया या सोशल कंटेंट मादक द्रव्य उपयोग को सामान्य दिखाता है।",
          "बच्चे को सीधे मादक द्रव्य ऑफर किए गए हैं।",
          "बच्चा मादक द्रव्यों के प्रति उत्सुकता दिखाता है।",
          "बच्चा मादक द्रव्य उपयोग को हानिरहित मानता है।",
          "बच्चा साथियों के दबाव में स्पष्ट रूप से 'नहीं' कह सकता है।",
          "मादक द्रव्य उपयोग के जोखिमों को बच्चा समझता है।",
          "मादक द्रव्य उपयोग को तनाव से निपटने का तरीका मानता है।",
          "दोस्तों या दिनचर्या में अचानक बदलाव।",
          "गोपनीयता, झूठ या असामान्य गोपनीयता।",
          "शैक्षिक या व्यक्तिगत स्वच्छता में गिरावट।",
          "मूड स्विंग, चिड़चिड़ापन या अलग-थलग होना।",
          "सामान्य गतिविधियों में रुचि की कमी।",
          "घर पर मादक द्रव्य उपयोग पर खुलकर चर्चा होती है।",
          "मादक द्रव्य उपयोग के बारे में स्पष्ट परिवार नियम हैं।",
          "परिणाम सुसंगत और ज्ञात हैं।",
          "गलतियों पर चर्चा करने में बच्चा सुरक्षित महसूस करता है।",
          "वयस्क मादक द्रव्य उपयोग से बचते हैं या जिम्मेदारी से मॉडल करते हैं।",
          "बच्चे में मजबूत आत्म-सम्मान है।",
          "बच्चे के पास स्वस्थ coping तंत्र हैं।",
          "बच्चा संरचित गतिविधियों में भाग लेता है।",
          "परिवार के बाहर विश्वसनीय वयस्क उपलब्ध हैं।",
          "जरूरत पड़ने पर मदद कहाँ लेनी है, बच्चा जानता है।"
        ]
      },
      educator: {
        en: [
          "Sudden changes in peer group, behavior or academic engagement.",
          "Signs of secrecy, withdrawal or unexplained mood shifts in school.",
          "Decline in hygiene, attendance or participation in structured activities.",
          "Reports or observations of exposure to substance-related talk or media.",
          "Difficulty with impulse control or emotional regulation in class.",
          "Loss of interest in usual school activities or friendships."
        ],
        hi: [
          "साथी समूह, व्यवहार या शैक्षिक जुड़ाव में अचानक बदलाव।",
          "स्कूल में गोपनीयता, वापसी या बिना कारण मूड बदलाव के संकेत।",
          "स्वच्छता, उपस्थिति या संरचित गतिविधियों में गिरावट।",
          "मादक द्रव्य-संबंधी बात या मीडिया के संपर्क की रिपोर्ट/अवलोकन।",
          "कक्षा में आवेग नियंत्रण या भावनात्मक नियमन में कठिनाई।",
          "सामान्य स्कूल गतिविधियों या दोस्ती में रुचि की कमी।"
        ]
      },
      doctor: {
        en: [
          "Parental/teacher reports of risk factors (peer exposure, curiosity, secrecy) or early warning signs.",
          "History of mood/behavior changes, academic decline or physical symptoms possibly linked to substance exposure.",
          "Signs of low self-esteem, poor coping or high stress potentially increasing vulnerability.",
          "No primary medical/psychiatric condition (e.g., untreated ADHD, depression) fully explains observed patterns."
        ],
        hi: [
          "जोखिम कारक (साथी संपर्क, उत्सुकता, गोपनीयता) या प्रारंभिक चेतावनी संकेतों की अभिभावक/शिक्षक रिपोर्ट।",
          "मूड/व्यवहार बदलाव, शैक्षिक गिरावट या मादक द्रव्य संपर्क से संभवतः जुड़े शारीरिक लक्षणों का इतिहास।",
          "कम आत्म-सम्मान, खराब coping या उच्च तनाव के संकेत जो संवेदनशीलता बढ़ा सकते हैं।",
          "देखे गए पैटर्न को पूरी तरह समझाने वाली कोई प्राथमिक चिकित्सकीय/मनोरोग स्थिति (जैसे अनुपचारित ADHD, अवसाद) नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = No concern / protective factors present, 3 = High risk or confirmed concern) — Lower total score = safer, more protected child",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong protective environment", hi: "मजबूत सुरक्षात्मक वातावरण" },
          insight: {
            en: "Excellent protective factors (strong self-esteem, healthy coping, open family communication) are in place. Child is well-protected against substance risks. Continue modeling responsibility, regular check-ins and positive activities to maintain this strong shield.",
            hi: "मजबूत सुरक्षात्मक कारक (उच्च आत्म-सम्मान, स्वस्थ coping, खुला परिवार संवाद) मौजूद हैं। बच्चा मादक द्रव्य जोखिमों से अच्छी तरह सुरक्षित है। जिम्मेदारी का मॉडल बनाए रखें, नियमित चेक-इन और सकारात्मक गतिविधियाँ जारी रखकर इस मजबूत ढाल को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Low risk; prevention focus recommended", hi: "कम जोखिम; रोकथाम पर फोकस की सिफारिश" },
          insight: {
            en: "Mild exposure or curiosity present, but strong protective factors mitigate risk. Strengthen prevention: increase open substance discussions, reinforce 'no' skills, monitor peer influences, and promote structured activities/self-esteem building to keep risk low.",
            hi: "हल्का संपर्क या उत्सुकता मौजूद है, लेकिन मजबूत सुरक्षात्मक कारक जोखिम कम करते हैं। रोकथाम मजबूत करें: मादक द्रव्य पर खुली चर्चा बढ़ाएँ, 'नहीं' कौशल मजबूत करें, साथी प्रभावों की निगरानी करें, और संरचित गतिविधियाँ/आत्म-सम्मान निर्माण को बढ़ावा देकर जोखिम कम रखें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate risk; active engagement needed", hi: "मध्यम जोखिम; सक्रिय जुड़ाव आवश्यक" },
          insight: {
            en: "Repeated exposure, warning signs or weakening protective factors increasing vulnerability. Take active steps: tighten family rules/boundaries, enhance communication on risks/coping, monitor closely (friends, online), involve school counselor if needed, and reinforce self-esteem/healthy outlets to reduce escalation.",
            hi: "बार-बार संपर्क, चेतावनी संकेत या कमजोर सुरक्षात्मक कारक से संवेदनशीलता बढ़ रही है। सक्रिय कदम उठाएँ: परिवार नियम/सीमाएँ सख्त करें, जोखिम/coping पर संवाद बढ़ाएँ, निकट निगरानी (दोस्त, ऑनलाइन), जरूरत पर स्कूल काउंसलर शामिल करें, और आत्म-सम्मान/स्वस्थ विकल्प मजबूत करके वृद्धि कम करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High risk; professional support advised", hi: "उच्च जोखिम; पेशेवर समर्थन की सलाह" },
          insight: {
            en: "Significant exposure, behavioral/emotional warning signs and eroded protective factors indicating high vulnerability. Professional support urgently recommended (child psychologist, addiction counselor or pediatrician) for thorough risk assessment, underlying factor exploration (stress, peer pressure, self-esteem), and development of a comprehensive family-based prevention and early intervention plan.",
            hi: "महत्वपूर्ण संपर्क, व्यवहारिक/भावनात्मक चेतावनी संकेत और क्षीण सुरक्षात्मक कारक से उच्च संवेदनशीलता संकेतित। गहन जोखिम मूल्यांकन, अंतर्निहित कारकों (तनाव, साथी दबाव, आत्म-सम्मान) की खोज और परिवार-आधारित रोकथाम तथा प्रारंभिक हस्तक्षेप योजना बनाने के लिए बाल मनोवैज्ञानिक, व्यसन काउंसलर या बाल रोग विशेषज्ञ द्वारा तत्काल पेशेवर समर्थन की सिफारिश।"
          }
        }
      ]
    }
  }
];


export const CHILD_ISSUES_PART3 = [
  {
    id: "cultural-social-integration",
    title: {
      en: "Cultural & Social Integration",
      hi: "सांस्कृतिक और सामाजिक एकीकरण"
    },
    description: {
      en: "Ability to adapt, belong, respect diversity and function confidently in society",
      hi: "अनुकूलन, संबंध, विविधता का सम्मान और समाज में आत्मविश्वास से कार्य करने की क्षमता"
    },
    questions: {
      parent: {
        en: [
          "My child feels comfortable in school or community settings.",
          "My child feels accepted by peers from different backgrounds.",
          "My child often feels left out or excluded.",
          "My child avoids social situations due to discomfort.",
          "My child expresses a sense of belonging in groups.",
          "My child understands basic social rules.",
          "My child adapts behavior based on social context.",
          "My child struggles to adjust in new environments.",
          "My child understands acceptable public behavior.",
          "My child frequently violates social norms unintentionally.",
          "My child respects people from different cultures or beliefs.",
          "My child shows curiosity about other cultures.",
          "My child makes insensitive remarks about differences.",
          "My child can interact comfortably with diverse peers.",
          "My child shows prejudice learned from surroundings.",
          "My child participates in group conversations.",
          "My child listens to others’ viewpoints.",
          "My child dominates or withdraws in group settings.",
          "My child resolves social misunderstandings peacefully.",
          "My child avoids speaking in social gatherings.",
          "My child feels safe expressing opinions.",
          "My child changes behavior excessively to fit in.",
          "My child feels pressure to conform socially.",
          "My child is comfortable with personal identity.",
          "My child experiences social anxiety or isolation."
        ],
        hi: [
          "मेरा बच्चा स्कूल या सामुदायिक सेटिंग में सहज महसूस करता है।",
          "विभिन्न पृष्ठभूमि के साथियों द्वारा स्वीकार्य महसूस करता है।",
          "अक्सर छूटा हुआ या बहिष्कृत महसूस करता है।",
          "असहजता के कारण सामाजिक स्थितियों से बचता है।",
          "समूहों में संबंध की भावना व्यक्त करता है।",
          "बुनियादी सामाजिक नियम समझता है।",
          "सामाजिक संदर्भ के आधार पर व्यवहार अनुकूलित करता है।",
          "नए वातावरण में ढलने में संघर्ष करता है।",
          "सार्वजनिक व्यवहार के स्वीकार्य मानदंड समझता है।",
          "अनजाने में सामाजिक मानदंडों का उल्लंघन बार-बार करता है।",
          "विभिन्न संस्कृतियों या विश्वासों वाले लोगों का सम्मान करता है।",
          "अन्य संस्कृतियों के प्रति उत्सुकता दिखाता है।",
          "अंतरों पर असंवेदनशील टिप्पणियाँ करता है।",
          "विविध साथियों से सहज अंतर्क्रिया करता है।",
          "परिवेश से सीखी गई पूर्वाग्रह दिखाता है।",
          "समूह बातचीत में भाग लेता है।",
          "दूसरों के दृष्टिकोण सुनता है।",
          "समूह सेटिंग में हावी होता है या वापस खिंच जाता है।",
          "सामाजिक गलतफहमियों को शांतिपूर्वक सुलझाता है।",
          "सामाजिक सभाओं में बोलने से बचता है।",
          "राय व्यक्त करने में सुरक्षित महसूस करता है।",
          "फिट होने के लिए व्यवहार अत्यधिक बदलता है।",
          "सामाजिक रूप से अनुरूप होने का दबाव महसूस करता है।",
          "व्यक्तिगत पहचान के साथ सहज महसूस करता है।",
          "सामाजिक चिंता या अलगाव का अनुभव करता है।"
        ]
      },
      educator: {
        en: [
          "Limited participation or visible discomfort in diverse group activities or discussions.",
          "Difficulty adapting behavior to classroom or playground social norms.",
          "Occasional insensitive comments or prejudice toward peers from different backgrounds.",
          "Shows withdrawal, isolation or anxiety in social settings or transitions.",
          "Struggles to resolve peer misunderstandings or conflicts peacefully.",
          "Over-conforms or resists group expectations, affecting integration."
        ],
        hi: [
          "विविध समूह गतिविधियों या चर्चाओं में सीमित भागीदारी या दृश्य असहजता।",
          "कक्षा या प्लेग्राउंड सामाजिक मानदंडों के अनुसार व्यवहार अनुकूलित करने में कठिनाई।",
          "विभिन्न पृष्ठभूमि के साथियों के प्रति कभी-कभी असंवेदनशील टिप्पणियाँ या पूर्वाग्रह।",
          "सामाजिक सेटिंग या संक्रमण में वापसी, अलगाव या चिंता दिखाता है।",
          "साथी गलतफहमियों या विवादों को शांतिपूर्वक सुलझाने में संघर्ष।",
          "समूह अपेक्षाओं पर अत्यधिक अनुरूपता या प्रतिरोध से एकीकरण प्रभावित।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of social anxiety, withdrawal or identity-related distress in multicultural contexts.",
          "History of difficulty navigating social norms, prejudice or peer exclusion experiences.",
          "Signs of low belonging, pressure to conform or emotional isolation observed.",
          "No primary anxiety disorder, developmental delay or trauma fully explains integration challenges."
        ],
        hi: [
          "बहुसांस्कृतिक संदर्भों में सामाजिक चिंता, वापसी या पहचान-संबंधी संकट की अभिभावक रिपोर्ट।",
          "सामाजिक मानदंड नेविगेट करने, पूर्वाग्रह या साथी बहिष्कार अनुभवों में कठिनाई का इतिहास।",
          "कम संबंध, अनुरूपता दबाव या भावनात्मक अलगाव के संकेत देखे गए।",
          "एकीकरण चुनौतियों को पूरी तरह समझाने वाली कोई प्राथमिक चिंता विकार, विकासात्मक विलंब या आघात नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Healthy integration, 3 = Significant difficulty) — Lower total score = stronger social and cultural integration",
      bands: [
        {
          range: "0–15",
          label: { en: "Well-integrated & socially confident", hi: "अच्छी तरह एकीकृत और सामाजिक रूप से आत्मविश्वासपूर्ण" },
          insight: {
            en: "Child shows strong belonging, adaptability and respect for diversity. Family and school environments are supportive — continue fostering inclusive conversations, curiosity about differences and confident self-expression to maintain this healthy integration.",
            hi: "बच्चा मजबूत संबंध, अनुकूलन और विविधता का सम्मान दिखाता है। परिवार और स्कूल वातावरण समर्थक हैं — समावेशी बातचीत, अंतरों के प्रति जिज्ञासा और आत्मविश्वासपूर्ण अभिव्यक्ति को बढ़ावा देकर इस स्वस्थ एकीकरण को बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor adjustment support needed", hi: "छोटा समायोजन समर्थन आवश्यक" },
          insight: {
            en: "Mild difficulties in adaptation, belonging or diversity respect emerging. Provide gentle support: encourage peer interactions, discuss cultural differences positively, role-play social scenarios and affirm child's identity to ease minor adjustments.",
            hi: "अनुकूलन, संबंध या विविधता सम्मान में हल्की कठिनाइयाँ उभर रही हैं। हल्का समर्थन दें: साथी अंतर्क्रियाओं को प्रोत्साहित करें, सांस्कृतिक अंतरों पर सकारात्मक चर्चा करें, सामाजिक परिदृश्यों का रोल-प्ले और बच्चे की पहचान की पुष्टि करके छोटे समायोजन आसान करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Integration challenges present", hi: "एकीकरण चुनौतियाँ मौजूद" },
          insight: {
            en: "Noticeable struggles with belonging, social norms or diversity acceptance affecting confidence and participation. Build structured support: facilitate diverse friendships, teach social-emotional skills, discuss identity openly, and collaborate with school for inclusive activities to strengthen integration.",
            hi: "संबंध, सामाजिक मानदंड या विविधता स्वीकृति में स्पष्ट संघर्ष जो आत्मविश्वास और भागीदारी को प्रभावित कर रहे हैं। संरचित समर्थन बनाएँ: विविध दोस्ती सुगम करें, सामाजिक-भावनात्मक कौशल सिखाएँ, पहचान पर खुलकर चर्चा करें और समावेशी गतिविधियों के लिए स्कूल के साथ सहयोग करें ताकि एकीकरण मजबूत हो।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern; guided intervention advised", hi: "उच्च चिंता; निर्देशित हस्तक्षेप की सलाह" },
          insight: {
            en: "Significant integration challenges, isolation, prejudice or identity conflict impacting emotional and social well-being. Guided intervention recommended (child psychologist, school counselor or cultural/community specialist) for assessment of underlying factors (anxiety, family dynamics, peer experiences) and development of a targeted plan to foster secure belonging, respect and adaptability.",
            hi: "एकीकरण में महत्वपूर्ण चुनौतियाँ, अलगाव, पूर्वाग्रह या पहचान संघर्ष जो भावनात्मक और सामाजिक कल्याण को प्रभावित कर रहे हैं। अंतर्निहित कारकों (चिंता, परिवार गतिशीलता, साथी अनुभव) के मूल्यांकन और सुरक्षित संबंध, सम्मान और अनुकूलन को बढ़ावा देने वाली लक्षित योजना बनाने के लिए बाल मनोवैज्ञानिक, स्कूल काउंसलर या सांस्कृतिक/सामुदायिक विशेषज्ञ द्वारा निर्देशित हस्तक्षेप की सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "respect-for-elders",
    title: {
      en: "Respect for Elders",
      hi: "बड़ों का सम्मान"
    },
    description: {
      en: "Empathy, communication, behavior & intergenerational awareness",
      hi: "सहानुभूति, संचार, व्यवहार और अंतरपीढ़ी जागरूकता"
    },
    questions: {
      parent: {
        en: [
          "My child shows basic courtesy toward elders.",
          "My child understands why respect for elders matters.",
          "My child dismisses elders’ opinions.",
          "My child shows impatience with older people.",
          "My child recognizes elders as individuals, not authority figures only.",
          "My child uses polite language when speaking to elders.",
          "My child listens without interrupting elders.",
          "My child uses rude tone or gestures.",
          "My child acknowledges elders in shared spaces.",
          "My child avoids interaction with elders.",
          "My child shows empathy toward elders’ limitations.",
          "My child becomes frustrated with elders’ pace or views.",
          "My child offers help to elders when appropriate.",
          "My child understands generational differences.",
          "My child mocks or mimics elders disrespectfully.",
          "My child can express disagreement respectfully.",
          "My child feels safe saying “no” to elders when needed.",
          "My child becomes aggressive or silent around elders.",
          "My child understands personal boundaries.",
          "My child confuses respect with blind obedience.",
          "Elders are treated respectfully within the family.",
          "Adults model calm, respectful disagreement.",
          "My child observes elders being spoken about negatively.",
          "Respectful intergenerational interactions are encouraged.",
          "My child internalizes respectful behavior naturally."
        ],
        hi: [
          "मेरा बच्चा बड़ों के प्रति बुनियादी शिष्टाचार दिखाता है।",
          "बड़ों का सम्मान क्यों महत्वपूर्ण है, बच्चा समझता है।",
          "बड़ों की राय को नजरअंदाज करता है।",
          "बड़े लोगों के साथ अधीरता दिखाता है।",
          "बड़ों को केवल अधिकार व्यक्ति नहीं, बल्कि व्यक्ति के रूप में पहचानता है।",
          "बड़ों से बात करते समय विनम्र भाषा का उपयोग करता है।",
          "बड़ों को बीच में टोकता नहीं, ध्यान से सुनता है।",
          "रूखा लहजा या इशारे करता है।",
          "साझा स्थानों में बड़ों को स्वीकार करता है।",
          "बड़ों से अंतर्क्रिया से बचता है।",
          "बड़ों की सीमाओं के प्रति सहानुभूति दिखाता है।",
          "बड़ों की गति या विचारों से निराश हो जाता है।",
          "उचित होने पर बड़ों की मदद करता है।",
          "पीढ़ीगत अंतर समझता है।",
          "बड़ों का मजाक उड़ाता या नकल करता है।",
          "असहमति को सम्मानजनक ढंग से व्यक्त कर सकता है।",
          "जरूरत पर बड़ों से 'नहीं' कहने में सुरक्षित महसूस करता है।",
          "बड़ों के आसपास आक्रामक या चुप हो जाता है।",
          "व्यक्तिगत सीमाओं को समझता है।",
          "सम्मान को अंधे आज्ञाकारिता से भ्रमित करता है।",
          "परिवार में बड़ों का सम्मानजनक व्यवहार होता है।",
          "वयस्क शांत, सम्मानजनक असहमति का मॉडल प्रस्तुत करते हैं।",
          "बच्चा बड़ों के बारे में नकारात्मक बातें सुनता है।",
          "अंतरपीढ़ी सम्मानजनक अंतर्क्रियाएँ प्रोत्साहित की जाती हैं।",
          "बच्चा सम्मानजनक व्यवहार को स्वाभाविक रूप से आत्मसात करता है।"
        ]
      },
      educator: {
        en: [
          "Shows limited courtesy or respect toward older staff/teachers in school.",
          "Dismisses or interrupts elders (teachers, grandparents visiting) in classroom.",
          "Struggles with patience or empathy during interactions with older peers/adults.",
          "Rarely acknowledges or offers help to elders in school/community events.",
          "Difficulty expressing disagreement respectfully with authority figures.",
          "Observes negative modeling of elder interactions from peers/family."
        ],
        hi: [
          "स्कूल में बड़े स्टाफ/शिक्षकों के प्रति सीमित शिष्टाचार या सम्मान दिखाता है।",
          "कक्षा में बड़ों (शिक्षक, दादा-दादी विजिट) को नजरअंदाज या बीच में टोकता है।",
          "बड़े साथियों/वयस्कों के साथ अंतर्क्रिया में धैर्य या सहानुभूति में संघर्ष।",
          "स्कूल/सामुदायिक कार्यक्रमों में बड़ों को स्वीकार या मदद कम करता है।",
          "प्राधिकार व्यक्तियों से असहमति को सम्मानजनक ढंग से व्यक्त करने में कठिनाई।",
          "साथियों/परिवार से बड़ों के नकारात्मक मॉडलिंग का अवलोकन।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of impatience, dismissal or disrespectful behavior toward elders.",
          "History of poor empathy/perspective-taking with older individuals.",
          "Signs of learned negative attitudes or confusion about respect vs. obedience.",
          "No primary behavioral/developmental disorder fully explains the patterns."
        ],
        hi: [
          "बड़ों के प्रति अधीरता, नजरअंदाज या असम्मानजनक व्यवहार की अभिभावक रिपोर्ट।",
          "बड़े व्यक्तियों के साथ सहानुभूति/दृष्टिकोण लेने में खराब इतिहास।",
          "सम्मान बनाम आज्ञाकारिता पर सीखी गई नकारात्मक दृष्टि या भ्रम के संकेत।",
          "पैटर्न को पूरी तरह समझाने वाला कोई प्राथमिक व्यवहारिक/विकासात्मक विकार नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Consistently respectful, 3 = Serious concern) — Lower total score = healthy respect and social grounding",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong values & empathy", hi: "मजबूत मूल्य और सहानुभूति" },
          insight: {
            en: "Child consistently shows courtesy, empathy and respectful behavior toward elders. Family modeling and intergenerational interactions are excellent — continue encouraging active listening, helpfulness and open dialogue to reinforce this strong social grounding.",
            hi: "बच्चा बड़ों के प्रति लगातार शिष्टाचार, सहानुभूति और सम्मानजनक व्यवहार दिखाता है। परिवार मॉडलिंग और अंतरपीढ़ी अंतर्क्रियाएँ उत्कृष्ट हैं — सक्रिय सुनना, मददगारता और खुली बातचीत को प्रोत्साहित करके इस मजबूत सामाजिक आधार को मजबूत करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Normal development with guidance", hi: "मार्गदर्शन के साथ सामान्य विकास" },
          insight: {
            en: "Occasional lapses in patience, listening or courtesy — typical for age. Provide gentle guidance: model respectful disagreement, teach empathy through stories, encourage helping elders and discuss why respect matters to build consistent habits.",
            hi: "धैर्य, सुनने या शिष्टाचार में कभी-कभी चूक — आयु के लिए सामान्य। हल्का मार्गदर्शन दें: सम्मानजनक असहमति का मॉडल बनाएँ, कहानियों से सहानुभूति सिखाएँ, बड़ों की मदद को प्रोत्साहित करें और सम्मान क्यों महत्वपूर्ण है, इस पर चर्चा करके सुसंगत आदतें बनाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Value reinforcement needed", hi: "मूल्य सुदृढ़ीकरण आवश्यक" },
          insight: {
            en: "Frequent impatience, dismissal or disrespectful patterns affecting intergenerational respect. Strengthen values through structured reinforcement: family role-plays, elder interaction opportunities, consistent positive modeling and clear discussions on empathy/boundaries to correct patterns early.",
            hi: "अधीरता, नजरअंदाज या असम्मानजनक पैटर्न अंतरपीढ़ी सम्मान को प्रभावित कर रहे हैं। संरचित सुदृढ़ीकरण से मूल्य मजबूत करें: परिवार रोल-प्ले, बड़ों से अंतर्क्रिया अवसर, सुसंगत सकारात्मक मॉडलिंग और सहानुभूति/सीमाओं पर स्पष्ट चर्चा करके पैटर्न जल्दी सुधारें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Concerning patterns; intervention advised", hi: "चिंताजनक पैटर्न; हस्तक्षेप की सलाह" },
          insight: {
            en: "Serious disrespectful or aggressive patterns toward elders, likely impacting social grounding and family dynamics. Intervention advised (child psychologist, family counselor or elder-respect workshop) to explore underlying causes (learned behavior, frustration, boundaries confusion) and implement targeted empathy-building, modeling and communication strategies.",
            hi: "बड़ों के प्रति गंभीर असम्मानजनक या आक्रामक पैटर्न, जो सामाजिक आधार और परिवार गतिशीलता को प्रभावित कर रहे हैं। अंतर्निहित कारणों (सीखा व्यवहार, निराशा, सीमा भ्रम) की खोज और लक्षित सहानुभूति-निर्माण, मॉडलिंग तथा संचार रणनीतियों के लिए बाल मनोवैज्ञानिक, परिवार काउंसलर या बड़ों-सम्मान वर्कशॉप द्वारा हस्तक्षेप की सलाह।"
          }
        }
      ]
    }
  },
  {
    id: "responsible-social-media",
    title: {
      en: "Responsible Use of Social Media",
      hi: "सोशल मीडिया का जिम्मेदार उपयोग"
    },
    description: {
      en: "Digital behavior, safety, balance and emotional impact",
      hi: "डिजिटल व्यवहार, सुरक्षा, संतुलन और भावनात्मक प्रभाव"
    },
    questions: {
      parent: {
        en: [
          "My child follows clear rules about social media usage.",
          "My child spends age-appropriate time on social platforms.",
          "My child uses social media late at night.",
          "My child becomes upset when access is limited.",
          "Devices are used without supervision or boundaries.",
          "My child understands online privacy and safety.",
          "My child shares personal information online.",
          "My child can identify fake or misleading content.",
          "My child knows how to block or report abuse.",
          "My child interacts with strangers online.",
          "My child compares themselves to others online.",
          "Social media affects my child’s self-esteem.",
          "My child becomes anxious or moody after online use.",
          "My child seeks validation through likes or comments.",
          "My child can emotionally detach from online feedback.",
          "My child communicates respectfully online.",
          "My child has participated in online teasing or trolling.",
          "My child understands digital consequences.",
          "My child forwards harmful or inappropriate content.",
          "My child practices kindness in online interactions.",
          "Social media rules are discussed at home.",
          "Parents model responsible digital behavior.",
          "My child hides online activity from adults.",
          "Offline activities are prioritized.",
          "My child understands that online life is not real life."
        ],
        hi: [
          "मेरा बच्चा सोशल मीडिया उपयोग के स्पष्ट नियमों का पालन करता है।",
          "बच्चा आयु-अनुसार समय सोशल प्लेटफॉर्म पर बिताता है।",
          "रात देर तक सोशल मीडिया का उपयोग करता है।",
          "पहुंच सीमित होने पर परेशान हो जाता है।",
          "निगरानी या सीमाओं के बिना डिवाइस का उपयोग होता है।",
          "ऑनलाइन गोपनीयता और सुरक्षा को समझता है।",
          "ऑनलाइन व्यक्तिगत जानकारी साझा करता है।",
          "नकली या भ्रामक कंटेंट पहचान सकता है।",
          "अपमान या दुरुपयोग को ब्लॉक/रिपोर्ट करना जानता है।",
          "ऑनलाइन अजनबियों से अंतर्क्रिया करता है।",
          "खुद की ऑनलाइन दूसरों से तुलना करता है।",
          "सोशल मीडिया बच्चे के आत्म-सम्मान को प्रभावित करता है।",
          "ऑनलाइन उपयोग के बाद चिंतित या मूडी हो जाता है।",
          "लाइक्स या कमेंट्स से मान्यता मांगता है।",
          "ऑनलाइन फीडबैक से भावनात्मक रूप से अलग हो सकता है।",
          "ऑनलाइन सम्मानजनक संवाद करता है।",
          "ऑनलाइन चिढ़ाने या ट्रोलिंग में भाग लिया है।",
          "डिजिटल परिणामों को समझता है।",
          "हानिकारक या अनुचित कंटेंट फॉरवर्ड करता है।",
          "ऑनलाइन अंतर्क्रियाओं में दयालुता बरतता है।",
          "घर पर सोशल मीडिया नियमों पर चर्चा होती है।",
          "माता-पिता जिम्मेदार डिजिटल व्यवहार का मॉडल प्रस्तुत करते हैं।",
          "ऑनलाइन गतिविधियाँ वयस्कों से छिपाता है।",
          "ऑफलाइन गतिविधियों को प्राथमिकता दी जाती है।",
          "ऑनलाइन जीवन वास्तविक जीवन नहीं है, यह समझता है।"
        ]
      },
      educator: {
        en: [
          "Excessive focus on phone/social media during class or breaks.",
          "Signs of mood changes, anxiety or comparison after online use.",
          "Reports or observations of sharing personal info or interacting with strangers online.",
          "Difficulty disengaging from device during school activities.",
          "Participates in or witnesses online teasing/trolling in digital school platforms.",
          "Reduced attention or engagement in offline group/class work possibly linked to social media."
        ],
        hi: [
          "कक्षा या ब्रेक के दौरान फोन/सोशल मीडिया पर अत्यधिक फोकस।",
          "ऑनलाइन उपयोग के बाद मूड बदलाव, चिंता या तुलना के संकेत।",
          "व्यक्तिगत जानकारी साझा करने या अजनबियों से अंतर्क्रिया की रिपोर्ट/अवलोकन।",
          "स्कूल गतिविधियों के दौरान डिवाइस से अलग होने में कठिनाई।",
          "डिजिटल स्कूल प्लेटफॉर्म पर ऑनलाइन चिढ़ाने/ट्रोलिंग में भागीदारी या साक्षी।",
          "सोशल मीडिया से संभवतः जुड़ी ऑफलाइन समूह/कक्षा कार्य में कम ध्यान या जुड़ाव।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of late-night use, mood/emotional changes post-social media, or validation-seeking behavior.",
          "History of excessive comparison, anxiety, reduced self-esteem linked to online exposure.",
          "Signs of compulsive checking, secrecy or defensive responses regarding digital activity.",
          "No primary behavioral/mental health condition fully explains the usage patterns or impact."
        ],
        hi: [
          "रात देर उपयोग, सोशल मीडिया के बाद मूड/भावनात्मक बदलाव या मान्यता मांगने के व्यवहार की अभिभावक रिपोर्ट।",
          "ऑनलाइन एक्सपोजर से जुड़ी अत्यधिक तुलना, चिंता, कम आत्म-सम्मान का इतिहास।",
          "कम्पल्सिव चेकिंग, गोपनीयता या डिजिटल गतिविधि पर रक्षात्मक प्रतिक्रियाओं के संकेत।",
          "उपयोग पैटर्न या प्रभाव को पूरी तरह समझाने वाली कोई प्राथमिक व्यवहारिक/मानसिक स्वास्थ्य स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Healthy, age-appropriate use, 3 = High-risk or unsafe behavior) — Lower total score = safer and more responsible usage",
      bands: [
        {
          range: "0–15",
          label: { en: "Healthy digital habits", hi: "स्वस्थ डिजिटल आदतें" },
          insight: {
            en: "Child demonstrates balanced, safe and responsible social media use with strong family guidance. Protective factors are excellent — continue modeling healthy boundaries, open discussions on digital wellness and prioritizing offline life to sustain positive habits.",
            hi: "बच्चा संतुलित, सुरक्षित और जिम्मेदार सोशल मीडिया उपयोग दिखाता है जिसमें मजबूत परिवार मार्गदर्शन है। सुरक्षात्मक कारक उत्कृष्ट हैं — स्वस्थ सीमाओं का मॉडल बनाए रखें, डिजिटल कल्याण पर खुली चर्चा और ऑफलाइन जीवन को प्राथमिकता देकर सकारात्मक आदतें बनाए रखें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Minor risks; guidance recommended", hi: "हल्के जोखिम; मार्गदर्शन की सिफारिश" },
          insight: {
            en: "Occasional minor concerns (late use, comparison, limited privacy awareness). Reinforce guidance: review/update family rules, teach privacy/safety basics, monitor usage patterns, and encourage offline balance to prevent minor risks from escalating.",
            hi: "कभी-कभी छोटी चिंताएँ (देर उपयोग, तुलना, सीमित गोपनीयता जागरूकता)। मार्गदर्शन मजबूत करें: परिवार नियमों की समीक्षा/अपडेट, गोपनीयता/सुरक्षा मूल बातें सिखाएँ, उपयोग पैटर्न की निगरानी करें और ऑफलाइन संतुलन को प्रोत्साहित करके छोटे जोखिम बढ़ने से रोकें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Digital well-being concerns", hi: "डिजिटल कल्याण चिंताएँ" },
          insight: {
            en: "Noticeable risk patterns (emotional impact, unsafe behavior, boundary issues) affecting mood and safety. Establish structured limits: device curfews, supervised use, digital detox periods, teach critical thinking/online ethics, and increase family monitoring/discussion to restore balance.",
            hi: "मूड और सुरक्षा को प्रभावित करने वाले स्पष्ट जोखिम पैटर्न (भावनात्मक प्रभाव, असुरक्षित व्यवहार, सीमा मुद्दे)। संरचित सीमाएँ स्थापित करें: डिवाइस कर्फ्यू, निगरानी में उपयोग, डिजिटल detox अवधि, क्रिटिकल थिंकिंग/ऑनलाइन नीति सिखाएँ और संतुलन बहाल करने के लिए परिवार निगरानी/चर्चा बढ़ाएँ।"
          }
        },
        {
          range: "51–75",
          label: { en: "High risk; immediate intervention advised", hi: "उच्च जोखिम; तत्काल हस्तक्षेप की सलाह" },
          insight: {
            en: "Serious high-risk or unsafe patterns causing significant emotional, behavioral or safety concerns. Immediate intervention strongly recommended (child psychologist, digital wellness specialist or school counselor) for assessment of underlying factors (self-esteem, peer pressure, addiction signs), structured detox plan, family rules overhaul and therapeutic support to ensure child safety and healthy digital development.",
            hi: "महत्वपूर्ण भावनात्मक, व्यवहारिक या सुरक्षा चिंताएँ पैदा करने वाले गंभीर उच्च-जोखिम या असुरक्षित पैटर्न। अंतर्निहित कारकों (आत्म-सम्मान, साथी दबाव, व्यसन संकेत) के मूल्यांकन, संरचित detox प्लान, परिवार नियमों के पूर्ण पुनर्निर्माण और थेरेप्यूटिक समर्थन के लिए बाल मनोवैज्ञानिक, डिजिटल वेलनेस विशेषज्ञ या स्कूल काउंसलर द्वारा तत्काल हस्तक्षेप की मजबूत सिफारिश ताकि बच्चे की सुरक्षा और स्वस्थ डिजिटल विकास सुनिश्चित हो।"
          }
        }
      ]
    }
  },
  {
    id: "community-involvement",
    title: {
      en: "Community Involvement",
      hi: "सामुदायिक भागीदारी"
    },
    description: {
      en: "Engagement with society, service, responsibility and social contribution",
      hi: "समाज से जुड़ाव, सेवा, जिम्मेदारी और सामाजिक योगदान"
    },
    questions: {
      parent: {
        en: [
          "My child understands the concept of helping others.",
          "My child recognizes community needs and challenges.",
          "My child can identify opportunities to contribute.",
          "My child understands that small actions can make a difference.",
          "My child is aware of environmental and social issues.",
          "My child participates in community activities voluntarily.",
          "My child initiates small acts of service at home or school.",
          "My child collaborates with peers in group projects.",
          "My child avoids taking part in group or social initiatives.",
          "My child relies entirely on adults to organize community efforts.",
          "My child shows empathy toward people in need.",
          "My child volunteers time or effort without expecting rewards.",
          "My child disregards the struggles of others.",
          "My child respects rules and responsibilities during group activities.",
          "My child demonstrates fairness and inclusivity in participation.",
          "My child reflects on what they learn from helping others.",
          "My child applies lessons from community activities in daily life.",
          "My child forgets or undervalues experiences from participation.",
          "My child is motivated to improve their impact over time.",
          "My child recognizes the importance of teamwork.",
          "Our family encourages community service and social responsibility.",
          "My child receives guidance on how to contribute meaningfully.",
          "Family models service-oriented behavior consistently.",
          "My child feels supported in taking initiative.",
          "Community involvement is integrated into family values and activities."
        ],
        hi: [
          "मेरा बच्चा दूसरों की मदद करने की अवधारणा समझता है।",
          "समुदाय की आवश्यकताओं और चुनौतियों को पहचानता है।",
          "योगदान के अवसरों की पहचान कर सकता है।",
          "छोटे कार्यों से भी फर्क पड़ सकता है, यह समझता है।",
          "पर्यावरण और सामाजिक मुद्दों से अवगत है।",
          "समुदाय गतिविधियों में स्वेच्छा से भाग लेता है।",
          "घर या स्कूल में छोटे सेवा कार्यों की शुरुआत करता है।",
          "समूह प्रोजेक्ट्स में साथियों के साथ सहयोग करता है।",
          "समूह या सामाजिक पहलों में भाग लेने से बचता है।",
          "समुदाय प्रयासों को संगठित करने के लिए पूरी तरह वयस्कों पर निर्भर रहता है।",
          "जरूरतमंद लोगों के प्रति सहानुभूति दिखाता है।",
          "इनाम की अपेक्षा के बिना समय या प्रयास स्वयंसेवा करता है।",
          "दूसरों की परेशानियों को नजरअंदाज करता है।",
          "समूह गतिविधियों के दौरान नियमों और जिम्मेदारियों का सम्मान करता है।",
          "भागीदारी में निष्पक्षता और समावेशिता दिखाता है।",
          "दूसरों की मदद से क्या सीखा, इस पर विचार करता है।",
          "समुदाय गतिविधियों से सीखे पाठों को दैनिक जीवन में लागू करता है।",
          "भागीदारी के अनुभवों को भूल जाता या कम महत्व देता है।",
          "समय के साथ अपने प्रभाव को बेहतर बनाने के लिए प्रेरित रहता है।",
          "टीमवर्क के महत्व को पहचानता है।",
          "हमारा परिवार सामुदायिक सेवा और सामाजिक जिम्मेदारी को प्रोत्साहित करता है।",
          "अर्थपूर्ण योगदान कैसे दें, इस पर मार्गदर्शन प्राप्त करता है।",
          "परिवार लगातार सेवा-उन्मुख व्यवहार का मॉडल प्रस्तुत करता है।",
          "पहल करने में बच्चा समर्थित महसूस करता है।",
          "सामुदायिक भागीदारी परिवार मूल्यों और गतिविधियों में एकीकृत है।"
        ]
      },
      educator: {
        en: [
          "Limited voluntary participation in school community service or group projects.",
          "Rarely initiates helpful acts or shows leadership in peer activities.",
          "Shows low empathy or disregard for others' needs in classroom/group settings.",
          "Difficulty collaborating or respecting rules in team-based tasks.",
          "Minimal reflection or application of social responsibility lessons.",
          "Family support for community involvement not evident in school behavior."
        ],
        hi: [
          "स्कूल सामुदायिक सेवा या समूह प्रोजेक्ट्स में स्वैच्छिक भागीदारी सीमित।",
          "साथी गतिविधियों में मददगार कार्य या नेतृत्व की शुरुआत कम करता है।",
          "कक्षा/समूह सेटिंग में दूसरों की जरूरतों के प्रति कम सहानुभूति या नजरअंदाज।",
          "टीम-आधारित कार्यों में सहयोग या नियमों का सम्मान करने में कठिनाई।",
          "सामाजिक जिम्मेदारी पाठों का न्यूनतम चिंतन या अनुप्रयोग।",
          "स्कूल व्यवहार में सामुदायिक भागीदारी के लिए परिवार समर्थन दिखाई नहीं देता।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of low empathy, minimal helping behavior or disinterest in social causes.",
          "History of limited participation in group or service-oriented activities.",
          "Signs of self-centeredness, poor teamwork or lack of reflection on social impact.",
          "No primary developmental or emotional condition fully explains reduced engagement."
        ],
        hi: [
          "कम सहानुभूति, न्यूनतम मदद व्यवहार या सामाजिक कारणों में रुचि की कमी की अभिभावक रिपोर्ट।",
          "समूह या सेवा-उन्मुख गतिविधियों में सीमित भागीदारी का इतिहास।",
          "स्व-केंद्रितता, खराब टीमवर्क या सामाजिक प्रभाव पर चिंतन की कमी के संकेत।",
          "कम जुड़ाव को पूरी तरह समझाने वाली कोई प्राथमिक विकासात्मक या भावनात्मक स्थिति नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Consistently engaged / healthy involvement, 3 = Minimal or no participation) — Lower total score = higher community engagement and social responsibility",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong social responsibility", hi: "मजबूत सामाजिक जिम्मेदारी" },
          insight: {
            en: "Child consistently shows empathy, initiative and meaningful community engagement. Family values and modeling are powerful — continue encouraging voluntary service, reflection on impact, and inclusive family involvement to nurture lifelong civic responsibility.",
            hi: "बच्चा लगातार सहानुभूति, पहल और अर्थपूर्ण सामुदायिक जुड़ाव दिखाता है। परिवार मूल्य और मॉडलिंग शक्तिशाली हैं — स्वैच्छिक सेवा, प्रभाव पर चिंतन और समावेशी परिवार भागीदारी को प्रोत्साहित करके जीवनभर नागरिक जिम्मेदारी पोषित करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Developing engagement; encouragement helpful", hi: "विकसित हो रहा जुड़ाव; प्रोत्साहन उपयोगी" },
          insight: {
            en: "Occasional participation with emerging awareness and empathy. Boost engagement gently: involve in small family/school service projects, discuss real-world needs, celebrate contributions and model helping behavior to build consistent habits.",
            hi: "उभरती जागरूकता और सहानुभूति के साथ कभी-कभी भागीदारी। जुड़ाव को हल्के ढंग से बढ़ाएँ: छोटे परिवार/स्कूल सेवा प्रोजेक्ट में शामिल करें, वास्तविक दुनिया जरूरतों पर चर्चा करें, योगदान का जश्न मनाएँ और मदद व्यवहार का मॉडल बनाकर सुसंगत आदतें बनाएँ।"
          }
        },
        {
          range: "31–50",
          label: { en: "Limited participation; structured guidance needed", hi: "सीमित भागीदारी; संरचित मार्गदर्शन आवश्यक" },
          insight: {
            en: "Inconsistent or low engagement with gaps in empathy, initiative or understanding. Provide structured guidance: schedule regular community activities, teach teamwork/reflection, encourage small independent contributions, and discuss social issues to strengthen responsibility and connection.",
            hi: "सहानुभूति, पहल या समझ में अंतराल के साथ असंगत या कम जुड़ाव। संरचित मार्गदर्शन दें: नियमित सामुदायिक गतिविधियाँ शेड्यूल करें, टीमवर्क/चिंतन सिखाएँ, छोटे स्वतंत्र योगदान प्रोत्साहित करें और सामाजिक मुद्दों पर चर्चा करके जिम्मेदारी और संबंध मजबूत करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "Minimal involvement; active mentoring recommended", hi: "न्यूनतम जुड़ाव; सक्रिय मेंटरिंग की सिफारिश" },
          insight: {
            en: "Significant disengagement or disregard for community needs, potentially affecting empathy and social development. Active mentoring strongly recommended (school counselor, community youth program or child psychologist) for assessment of underlying factors (low empathy, isolation, family modeling) and implementation of structured, rewarding involvement plan to build connection, responsibility and long-term civic awareness.",
            hi: "सामुदायिक जरूरतों के प्रति महत्वपूर्ण अलगाव या उपेक्षा, जो सहानुभूति और सामाजिक विकास को प्रभावित कर सकती है। अंतर्निहित कारकों (कम सहानुभूति, अलगाव, परिवार मॉडलिंग) के मूल्यांकन और जुड़ाव, जिम्मेदारी तथा लंबे समय की नागरिक जागरूकता बनाने वाली संरचित, पुरस्कृत भागीदारी योजना लागू करने के लिए स्कूल काउंसलर, सामुदायिक युवा कार्यक्रम या बाल मनोवैज्ञानिक द्वारा सक्रिय मेंटरिंग की मजबूत सिफारिश।"
          }
        }
      ]
    }
  },
  {
    id: "time-for-family-bonding",
    title: {
      en: "Time for Family Bonding",
      hi: "परिवार के साथ बंधन के लिए समय"
    },
    description: {
      en: "Connection, shared experiences, emotional closeness and routines",
      hi: "जुड़ाव, साझा अनुभव, भावनात्मक निकटता और दिनचर्या"
    },
    questions: {
      parent: {
        en: [
          "My family regularly spends time together.",
          "My child participates willingly in family activities.",
          "Family routines include shared meals, play or conversations.",
          "My child often feels alone despite being with family.",
          "Quality family time is sacrificed due to schedules or screens.",
          "Conversations at home are meaningful and attentive.",
          "My child feels heard and valued during family time.",
          "Family interactions are rushed or superficial.",
          "My child can express feelings freely at home.",
          "Arguments or distractions often interrupt family bonding.",
          "My child feels emotionally supported by family.",
          "Family members show empathy and understanding.",
          "My child avoids sharing feelings with family.",
          "Emotional closeness is present even during conflicts.",
          "My child feels distant or disconnected from family.",
          "My child engages in shared hobbies or play with family.",
          "Family traditions or rituals are observed together.",
          "My child rarely participates in shared family activities.",
          "Family time includes learning, exploration or creativity.",
          "My child feels family activities are forced or unenjoyable.",
          "Parents model respect, attention and presence.",
          "Family encourages open communication and collaboration.",
          "My child sees positive examples of relationships at home.",
          "Parents balance work, screen time and attention effectively.",
          "Family bonding time is prioritized as a value, not an obligation."
        ],
        hi: [
          "हमारा परिवार नियमित रूप से साथ समय बिताता है।",
          "बच्चा परिवार की गतिविधियों में स्वेच्छा से भाग लेता है।",
          "परिवार दिनचर्या में साझा भोजन, खेल या बातचीत शामिल है।",
          "परिवार के साथ होने पर भी बच्चा अक्सर अकेला महसूस करता है।",
          "शेड्यूल या स्क्रीन के कारण गुणवत्ता परिवार समय त्याग दिया जाता है।",
          "घर पर बातचीत अर्थपूर्ण और ध्यान देने वाली होती है।",
          "परिवार समय के दौरान बच्चा सुना और मूल्यवान महसूस करता है।",
          "परिवार अंतर्क्रियाएँ जल्दबाजी या सतही होती हैं।",
          "घर पर बच्चा भावनाएँ स्वतंत्र रूप से व्यक्त कर सकता है।",
          "तर्क या distractions अक्सर परिवार बंधन में बाधा डालते हैं।",
          "बच्चा परिवार द्वारा भावनात्मक रूप से समर्थित महसूस करता है।",
          "परिवार के सदस्य सहानुभूति और समझ दिखाते हैं।",
          "बच्चा परिवार के साथ भावनाएँ साझा करने से बचता है।",
          "संघर्ष के दौरान भी भावनात्मक निकटता मौजूद रहती है।",
          "बच्चा परिवार से दूर या डिस्कनेक्टेड महसूस करता है।",
          "परिवार के साथ साझा शौक या खेल में शामिल होता है।",
          "परिवार परंपराएँ या रिचुअल साथ मनाए जाते हैं।",
          "बच्चा साझा परिवार गतिविधियों में बहुत कम भाग लेता है।",
          "परिवार समय में सीखना, खोज या रचनात्मकता शामिल होती है।",
          "बच्चा परिवार गतिविधियों को जबरदस्ती या अप्रिय महसूस करता है।",
          "माता-पिता सम्मान, ध्यान और उपस्थिति का मॉडल प्रस्तुत करते हैं।",
          "परिवार खुली संवाद और सहयोग को प्रोत्साहित करता है।",
          "बच्चा घर पर सकारात्मक संबंधों के उदाहरण देखता है।",
          "माता-पिता काम, स्क्रीन समय और ध्यान को प्रभावी ढंग से संतुलित करते हैं।",
          "परिवार बंधन समय को मूल्य के रूप में प्राथमिकता दी जाती है, दायित्व के रूप में नहीं।"
        ]
      },
      educator: {
        en: [
          "Child shows signs of emotional disconnection or low self-worth in school interactions.",
          "Limited sharing of family experiences or positive home references in class.",
          "Visible stress, irritability or withdrawal possibly linked to family dynamics.",
          "Difficulty expressing feelings or needs appropriately in social settings.",
          "Reports or signs of isolation despite peer presence.",
          "Struggles with trust or openness in group activities."
        ],
        hi: [
          "स्कूल अंतर्क्रियाओं में भावनात्मक डिस्कनेक्शन या कम आत्म-मूल्य के संकेत।",
          "कक्षा में परिवार अनुभव या सकारात्मक घर संदर्भों का सीमित साझा करना।",
          "परिवार गतिशीलता से संभवतः जुड़ा दृश्य तनाव, चिड़चिड़ापन या वापसी।",
          "सामाजिक सेटिंग में भावनाएँ या आवश्यकताएँ उचित रूप से व्यक्त करने में कठिनाई।",
          "साथी मौजूदगी के बावजूद अलगाव की रिपोर्ट या संकेत।",
          "समूह गतिविधियों में विश्वास या खुलापन में संघर्ष।"
        ]
      },
      doctor: {
        en: [
          "Parental reports of limited quality family time, emotional distance or routine gaps.",
          "History of child feeling unsupported, unheard or disconnected at home.",
          "Signs of stress, low mood or behavioral issues potentially linked to weak bonding.",
          "No primary attachment or mental health disorder fully explains the bonding concerns."
        ],
        hi: [
          "गुणवत्ता परिवार समय की कमी, भावनात्मक दूरी या दिनचर्या अंतराल की अभिभावक रिपोर्ट।",
          "घर पर असमर्थित, अनसुना या डिस्कनेक्टेड महसूस करने का इतिहास।",
          "कमजोर बंधन से संभवतः जुड़े तनाव, कम मूड या व्यवहारिक मुद्दों के संकेत।",
          "बंधन चिंताओं को पूरी तरह समझाने वाली कोई प्राथमिक लगाव या मानसिक स्वास्थ्य विकार नहीं।"
        ]
      }
    },
    scoring: {
      scale: "0–3 (0 = Consistently strong bonding, 3 = Minimal or absent bonding) — Lower total score = stronger family connections and emotional security",
      bands: [
        {
          range: "0–15",
          label: { en: "Strong family connection", hi: "मजबूत परिवार जुड़ाव" },
          insight: {
            en: "Family demonstrates consistent, meaningful and emotionally safe bonding. Routines, empathy and open communication are excellent — continue prioritizing quality time, active listening and shared rituals to nurture this powerful protective foundation for child's well-being.",
            hi: "परिवार सुसंगत, अर्थपूर्ण और भावनात्मक रूप से सुरक्षित बंधन दिखाता है। दिनचर्या, सहानुभूति और खुला संवाद उत्कृष्ट हैं — गुणवत्ता समय, सक्रिय सुनना और साझा रिचुअल्स को प्राथमिकता देकर बच्चे के कल्याण के लिए इस शक्तिशाली सुरक्षात्मक आधार को पोषित करें।"
          }
        },
        {
          range: "16–30",
          label: { en: "Occasional gaps; attention recommended", hi: "कभी-कभी अंतराल; ध्यान की सिफारिश" },
          insight: {
            en: "Minor inconsistencies in quality time, attentiveness or emotional closeness. Strengthen gently: schedule regular family meals/activities, reduce distractions (screens), practice active listening and validate feelings to close small gaps and reinforce connection.",
            hi: "गुणवत्ता समय, ध्यान या भावनात्मक निकटता में छोटी असंगतियाँ। हल्के ढंग से मजबूत करें: नियमित परिवार भोजन/गतिविधियाँ शेड्यूल करें, distractions (स्क्रीन) कम करें, सक्रिय सुनना अभ्यास करें और भावनाओं की मान्यता देकर छोटे अंतराल बंद करें और जुड़ाव मजबूत करें।"
          }
        },
        {
          range: "31–50",
          label: { en: "Moderate concern; guided bonding needed", hi: "मध्यम चिंता; निर्देशित बंधन आवश्यक" },
          insight: {
            en: "Noticeable gaps in frequency, quality or emotional safety affecting child's security and openness. Implement guided bonding: create predictable family rituals, reduce work/screen interference, encourage free expression, and use positive conflict resolution to rebuild closeness and trust.",
            hi: "आवृत्ति, गुणवत्ता या भावनात्मक सुरक्षा में स्पष्ट अंतराल जो बच्चे की सुरक्षा और खुलापन को प्रभावित कर रहे हैं। निर्देशित बंधन लागू करें: पूर्वानुमानित परिवार रिचुअल बनाएँ, काम/स्क्रीन हस्तक्षेप कम करें, स्वतंत्र अभिव्यक्ति प्रोत्साहित करें और सकारात्मक संघर्ष समाधान से निकटता और विश्वास पुनर्निर्माण करें।"
          }
        },
        {
          range: "51–75",
          label: { en: "High concern; urgent intervention to improve family dynamics", hi: "उच्च चिंता; परिवार गतिशीलता सुधारने के लिए तत्काल हस्तक्षेप" },
          insight: {
            en: "Significant disconnection, minimal bonding or emotional distance creating stress and insecurity. Urgent intervention strongly recommended (family therapist, child psychologist or parenting counselor) for assessment of dynamics, communication patterns and emotional barriers, followed by structured family bonding plan, conflict resolution skills and consistent quality time rebuilding.",
            hi: "महत्वपूर्ण डिस्कनेक्शन, न्यूनतम बंधन या भावनात्मक दूरी से तनाव और असुरक्षा। परिवार गतिशीलता, संवाद पैटर्न और भावनात्मक बाधाओं के मूल्यांकन के लिए परिवार थेरेपिस्ट, बाल मनोवैज्ञानिक या पेरेंटिंग काउंसलर द्वारा तत्काल हस्तक्षेप की मजबूत सिफारिश, उसके बाद संरचित परिवार बंधन प्लान, संघर्ष समाधान कौशल और सुसंगत गुणवत्ता समय पुनर्निर्माण।"
          }
        }
      ]
    }
  }  
];
